/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.2.0.0 (NJsonSchema v10.1.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface ISystemReportClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: number): Observable<SystemReportViewModel>;
    getReportParamsByName(name: string | null): Observable<SystemReportViewModel>;
    getByName(name: string | null): Observable<SystemReportModel>;
    upsert(command: UpsertSystemReportCommand): Observable<SystemReportModel>;
    delete(id: number): Observable<void>;
    setSystemReportParam(name: string | null, uniqid: string | null, systemReportParams: SystemReportParamModel[]): Observable<void>;
}

@Injectable()
export class SystemReportClient implements ISystemReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/SystemReport/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<SystemReportViewModel> {
        let url_ = this.baseUrl + "/api/SystemReport/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<SystemReportViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<SystemReportViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SystemReportViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemReportViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SystemReportViewModel>(<any>null);
    }

    getReportParamsByName(name: string | null): Observable<SystemReportViewModel> {
        let url_ = this.baseUrl + "/api/SystemReport/GetReportParamsByName/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportParamsByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportParamsByName(<any>response_);
                } catch (e) {
                    return <Observable<SystemReportViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<SystemReportViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetReportParamsByName(response: HttpResponseBase): Observable<SystemReportViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemReportViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SystemReportViewModel>(<any>null);
    }

    getByName(name: string | null): Observable<SystemReportModel> {
        let url_ = this.baseUrl + "/api/SystemReport/GetByName/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByName(<any>response_);
                } catch (e) {
                    return <Observable<SystemReportModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<SystemReportModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetByName(response: HttpResponseBase): Observable<SystemReportModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemReportModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SystemReportModel>(<any>null);
    }

    upsert(command: UpsertSystemReportCommand): Observable<SystemReportModel> {
        let url_ = this.baseUrl + "/api/SystemReport/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<SystemReportModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<SystemReportModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<SystemReportModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemReportModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/SystemReport/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    setSystemReportParam(name: string | null, uniqid: string | null, systemReportParams: SystemReportParamModel[]): Observable<void> {
        let url_ = this.baseUrl + "/api/SystemReport/SetSystemReportParam/{name}?";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name)); 
        if (uniqid === undefined)
            throw new Error("The parameter 'uniqid' must be defined.");
        else
            url_ += "uniqid=" + encodeURIComponent("" + uniqid) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(systemReportParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSystemReportParam(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSystemReportParam(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetSystemReportParam(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IApplicationImageClient {
    uploadImage(entity: string | null, entityId: string | null, id: number): Observable<ApplicationImageModel>;
}

@Injectable()
export class ApplicationImageClient implements IApplicationImageClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    uploadImage(entity: string | null, entityId: string | null, id: number): Observable<ApplicationImageModel> {
        let url_ = this.baseUrl + "/api/ApplicationImage/UploadImage/{entity}/{entityId}/{id}";
        if (entity === undefined || entity === null)
            throw new Error("The parameter 'entity' must be defined.");
        url_ = url_.replace("{entity}", encodeURIComponent("" + entity)); 
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId)); 
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImage(<any>response_);
                } catch (e) {
                    return <Observable<ApplicationImageModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApplicationImageModel>><any>_observableThrow(response_);
        }));
    }

    protected processUploadImage(response: HttpResponseBase): Observable<ApplicationImageModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationImageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IApplicationSettingsClient {
    getAdminAppSettings(): Observable<ApplicationSettingsViewModel>;
    getConfigurationMenuSettings(): Observable<ApplicationSettingsViewModel>;
    getFacilityHomeMenuSettings(): Observable<ApplicationSettingsViewModel>;
}

@Injectable()
export class ApplicationSettingsClient implements IApplicationSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAdminAppSettings(): Observable<ApplicationSettingsViewModel> {
        let url_ = this.baseUrl + "/api/ApplicationSettings/GetAdminAppSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminAppSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminAppSettings(<any>response_);
                } catch (e) {
                    return <Observable<ApplicationSettingsViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApplicationSettingsViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAdminAppSettings(response: HttpResponseBase): Observable<ApplicationSettingsViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationSettingsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApplicationSettingsViewModel>(<any>null);
    }

    getConfigurationMenuSettings(): Observable<ApplicationSettingsViewModel> {
        let url_ = this.baseUrl + "/api/ApplicationSettings/GetConfigurationMenuSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfigurationMenuSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfigurationMenuSettings(<any>response_);
                } catch (e) {
                    return <Observable<ApplicationSettingsViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApplicationSettingsViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetConfigurationMenuSettings(response: HttpResponseBase): Observable<ApplicationSettingsViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationSettingsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApplicationSettingsViewModel>(<any>null);
    }

    getFacilityHomeMenuSettings(): Observable<ApplicationSettingsViewModel> {
        let url_ = this.baseUrl + "/api/ApplicationSettings/GetFacilityHomeMenuSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFacilityHomeMenuSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFacilityHomeMenuSettings(<any>response_);
                } catch (e) {
                    return <Observable<ApplicationSettingsViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApplicationSettingsViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetFacilityHomeMenuSettings(response: HttpResponseBase): Observable<ApplicationSettingsViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationSettingsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApplicationSettingsViewModel>(<any>null);
    }
}

export interface IAttributesClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: number): Observable<AttributeViewModel>;
    upsert(command: UpsertAttributeCommand): Observable<number>;
    delete(id: number): Observable<void>;
}

@Injectable()
export class AttributesClient implements IAttributesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/Attributes/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<AttributeViewModel> {
        let url_ = this.baseUrl + "/api/Attributes/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<AttributeViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AttributeViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AttributeViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttributeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttributeViewModel>(<any>null);
    }

    upsert(command: UpsertAttributeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Attributes/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Attributes/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IBusinessProfileClient {
    get(id: number): Observable<BusinessProfileModel>;
    upsert(command: UpsertBusinessProfileCommand): Observable<number>;
}

@Injectable()
export class BusinessProfileClient implements IBusinessProfileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    get(id: number): Observable<BusinessProfileModel> {
        let url_ = this.baseUrl + "/api/BusinessProfile/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<BusinessProfileModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<BusinessProfileModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessProfileModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessProfileModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BusinessProfileModel>(<any>null);
    }

    upsert(command: UpsertBusinessProfileCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/BusinessProfile/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

export interface ICurrentStockClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    getAllKitchenStock(): Observable<KitchenStockModel[]>;
    kitchenStockConsumptionRegister(command: KitchenStockModel[]): Observable<number>;
    getAllBarStock(): Observable<BarStockModel[]>;
    barStockConsumptionRegister(command: BarStockModel[]): Observable<number>;
}

@Injectable()
export class CurrentStockClient implements ICurrentStockClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/CurrentStock/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    getAllKitchenStock(): Observable<KitchenStockModel[]> {
        let url_ = this.baseUrl + "/api/CurrentStock/GetAllKitchenStock";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllKitchenStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllKitchenStock(<any>response_);
                } catch (e) {
                    return <Observable<KitchenStockModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<KitchenStockModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllKitchenStock(response: HttpResponseBase): Observable<KitchenStockModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KitchenStockModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<KitchenStockModel[]>(<any>null);
    }

    kitchenStockConsumptionRegister(command: KitchenStockModel[]): Observable<number> {
        let url_ = this.baseUrl + "/api/CurrentStock/KitchenStockConsumptionRegister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKitchenStockConsumptionRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKitchenStockConsumptionRegister(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processKitchenStockConsumptionRegister(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getAllBarStock(): Observable<BarStockModel[]> {
        let url_ = this.baseUrl + "/api/CurrentStock/GetAllBarStock";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBarStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBarStock(<any>response_);
                } catch (e) {
                    return <Observable<BarStockModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<BarStockModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBarStock(response: HttpResponseBase): Observable<BarStockModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BarStockModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BarStockModel[]>(<any>null);
    }

    barStockConsumptionRegister(command: BarStockModel[]): Observable<number> {
        let url_ = this.baseUrl + "/api/CurrentStock/BarStockConsumptionRegister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBarStockConsumptionRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBarStockConsumptionRegister(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processBarStockConsumptionRegister(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IDashboardClient {
    getAllMembersCount(): Observable<number>;
}

@Injectable()
export class DashboardClient implements IDashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAllMembersCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/Dashboard/GetAllMembersCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMembersCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMembersCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMembersCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

export interface IDeviceClient {
    getRequestHeaders(): Observable<RHeaders[]>;
    getIPAddress(): Observable<string[]>;
    printHeader(dict: IHeaderDictionary): Observable<RHeaders[]>;
    authenticate(userName: string | null, password: string | null): Observable<TokenResponseModel>;
    authenticateMember(model: LoginModel): Observable<TokenResponseModel>;
    authenticateSystemUser(model: LoginModel): Observable<UserTokenResponseModel>;
    refreshToken(refreshToken: string | null): Observable<TokenResponseModel>;
    getMemberLastCardInfo(memberId: number): Observable<MemberCardModel>;
    getRelatedMembersCardListQuery(memberId: number): Observable<MemberCardModel[]>;
    tennisSlotTransferRequest(tennisSlotBookingId: number, memberId: number): Observable<void>;
    acceptTennisSlotTransferRequest(tennisSlotBookingId: number): Observable<void>;
    rejectTennisSlotTransferRequest(tennisSlotBookingId: number): Observable<void>;
    pinChangeRequest(model: PinChangeRequestModel): Observable<FileResponse>;
    pinChange(memberId: number, envNumber: number): Observable<void>;
    pinChangeByMobile(cardId: number, oldPin: string | null, newPin: string | null): Observable<void>;
    getNMemberTransactionsList(memberId: number, number: number): Observable<ListViewModel>;
    getMemberByCode(code: string | null): Observable<MemberModel>;
    getMemberByCard(cardNumber: string | null): Observable<MemberModel>;
    getMemberByRfId(rfId: string | null): Observable<MemberModel>;
    upsertTipsoiLog(command: TipsoiLogUpsertCommand): Observable<number>;
    memberPasswordChange(memberCode: string | null, oldPass: string | null, newPass: string | null): Observable<void>;
    getUpcomingTennisStolBooking(memberId: number): Observable<SelectModel[]>;
    getAvailableTennisBookingStols(day: Date): Observable<TennisBookingStolModel[]>;
    upsertTennisSlotBooking(command: UpsertTennisSlotBookingCommand): Observable<void>;
    getTennisSlotBookingDetails(id: number): Observable<TennisSlotBookingModelForDevice>;
    getTennisSlotBookingDetailsByMember(memberId: number): Observable<TennisSlotBookingModelForDevice[]>;
    restaurantBarItemCatalog(): Observable<void>;
    verifyMember(query: VerifyMemberPin): Observable<void>;
    memberCardBalance(memberId: number): Observable<MemberCardBalanceModel>;
    userActivitySummary(userId: string | null): Observable<UserActivitySummaryModel>;
    insertPoolAvailLog(memberCode: string | null, personCount: number, isExcludedMember: boolean): Observable<number>;
    insertGymAvailLog(memberCode: string | null): Observable<number>;
    availSlotBooking(tennisToken: string | null): Observable<number>;
    cancelSlotBooking(id: number, slotDate: Date): Observable<number>;
    upsertTransaction(command: UpsertTransactionCommand): Observable<number>;
    getAllowedTransactionTypes(): Observable<SelectModel[]>;
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    getNotices(): Observable<ListViewModel>;
    getEvents(): Observable<ListViewModel>;
    upsertRFID(command: UpsertDeviceRfIdMemberTagCommand): Observable<number>;
    upsertRFIDWithCard(command: UpsertRfIdByCardNumberCommand): Observable<number>;
}

@Injectable()
export class DeviceClient implements IDeviceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getRequestHeaders(): Observable<RHeaders[]> {
        let url_ = this.baseUrl + "/api/Device/GetRequestHeaders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestHeaders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestHeaders(<any>response_);
                } catch (e) {
                    return <Observable<RHeaders[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RHeaders[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRequestHeaders(response: HttpResponseBase): Observable<RHeaders[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RHeaders.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RHeaders[]>(<any>null);
    }

    getIPAddress(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Device/GetIPAddress";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIPAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIPAddress(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetIPAddress(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    printHeader(dict: IHeaderDictionary): Observable<RHeaders[]> {
        let url_ = this.baseUrl + "/api/Device/PrintHeader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dict);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintHeader(<any>response_);
                } catch (e) {
                    return <Observable<RHeaders[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RHeaders[]>><any>_observableThrow(response_);
        }));
    }

    protected processPrintHeader(response: HttpResponseBase): Observable<RHeaders[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RHeaders.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RHeaders[]>(<any>null);
    }

    authenticate(userName: string | null, password: string | null): Observable<TokenResponseModel> {
        let url_ = this.baseUrl + "/api/Device/Authenticate?";
        if (userName === undefined)
            throw new Error("The parameter 'userName' must be defined.");
        else
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        if (password === undefined)
            throw new Error("The parameter 'password' must be defined.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<TokenResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TokenResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<TokenResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenResponseModel>(<any>null);
    }

    authenticateMember(model: LoginModel): Observable<TokenResponseModel> {
        let url_ = this.baseUrl + "/api/Device/AuthenticateMember";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateMember(<any>response_);
                } catch (e) {
                    return <Observable<TokenResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TokenResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticateMember(response: HttpResponseBase): Observable<TokenResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenResponseModel>(<any>null);
    }

    authenticateSystemUser(model: LoginModel): Observable<UserTokenResponseModel> {
        let url_ = this.baseUrl + "/api/Device/AuthenticateSystemUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateSystemUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateSystemUser(<any>response_);
                } catch (e) {
                    return <Observable<UserTokenResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserTokenResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticateSystemUser(response: HttpResponseBase): Observable<UserTokenResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTokenResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserTokenResponseModel>(<any>null);
    }

    refreshToken(refreshToken: string | null): Observable<TokenResponseModel> {
        let url_ = this.baseUrl + "/api/Device/RefreshToken/{refreshToken}";
        if (refreshToken === undefined || refreshToken === null)
            throw new Error("The parameter 'refreshToken' must be defined.");
        url_ = url_.replace("{refreshToken}", encodeURIComponent("" + refreshToken)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(<any>response_);
                } catch (e) {
                    return <Observable<TokenResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TokenResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<TokenResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenResponseModel>(<any>null);
    }

    getMemberLastCardInfo(memberId: number): Observable<MemberCardModel> {
        let url_ = this.baseUrl + "/api/Device/GetMemberLastCardInfo/{memberId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberLastCardInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberLastCardInfo(<any>response_);
                } catch (e) {
                    return <Observable<MemberCardModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberCardModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberLastCardInfo(response: HttpResponseBase): Observable<MemberCardModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberCardModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberCardModel>(<any>null);
    }

    getRelatedMembersCardListQuery(memberId: number): Observable<MemberCardModel[]> {
        let url_ = this.baseUrl + "/api/Device/GetRelatedMembersCardListQuery/{memberId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRelatedMembersCardListQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRelatedMembersCardListQuery(<any>response_);
                } catch (e) {
                    return <Observable<MemberCardModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberCardModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRelatedMembersCardListQuery(response: HttpResponseBase): Observable<MemberCardModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberCardModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberCardModel[]>(<any>null);
    }

    tennisSlotTransferRequest(tennisSlotBookingId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Device/TennisSlotTransferRequest?";
        if (tennisSlotBookingId === undefined || tennisSlotBookingId === null)
            throw new Error("The parameter 'tennisSlotBookingId' must be defined and cannot be null.");
        else
            url_ += "tennisSlotBookingId=" + encodeURIComponent("" + tennisSlotBookingId) + "&"; 
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTennisSlotTransferRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTennisSlotTransferRequest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTennisSlotTransferRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    acceptTennisSlotTransferRequest(tennisSlotBookingId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Device/AcceptTennisSlotTransferRequest?";
        if (tennisSlotBookingId === undefined || tennisSlotBookingId === null)
            throw new Error("The parameter 'tennisSlotBookingId' must be defined and cannot be null.");
        else
            url_ += "tennisSlotBookingId=" + encodeURIComponent("" + tennisSlotBookingId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptTennisSlotTransferRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptTennisSlotTransferRequest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAcceptTennisSlotTransferRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    rejectTennisSlotTransferRequest(tennisSlotBookingId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Device/RejectTennisSlotTransferRequest?";
        if (tennisSlotBookingId === undefined || tennisSlotBookingId === null)
            throw new Error("The parameter 'tennisSlotBookingId' must be defined and cannot be null.");
        else
            url_ += "tennisSlotBookingId=" + encodeURIComponent("" + tennisSlotBookingId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectTennisSlotTransferRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectTennisSlotTransferRequest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRejectTennisSlotTransferRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    pinChangeRequest(model: PinChangeRequestModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Device/PinChangeRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPinChangeRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPinChangeRequest(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processPinChangeRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    pinChange(memberId: number, envNumber: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Device/PinChange?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&"; 
        if (envNumber === undefined || envNumber === null)
            throw new Error("The parameter 'envNumber' must be defined and cannot be null.");
        else
            url_ += "envNumber=" + encodeURIComponent("" + envNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPinChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPinChange(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPinChange(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    pinChangeByMobile(cardId: number, oldPin: string | null, newPin: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Device/PinChangeByMobile?";
        if (cardId === undefined || cardId === null)
            throw new Error("The parameter 'cardId' must be defined and cannot be null.");
        else
            url_ += "cardId=" + encodeURIComponent("" + cardId) + "&"; 
        if (oldPin === undefined)
            throw new Error("The parameter 'oldPin' must be defined.");
        else
            url_ += "oldPin=" + encodeURIComponent("" + oldPin) + "&"; 
        if (newPin === undefined)
            throw new Error("The parameter 'newPin' must be defined.");
        else
            url_ += "newPin=" + encodeURIComponent("" + newPin) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPinChangeByMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPinChangeByMobile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPinChangeByMobile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getNMemberTransactionsList(memberId: number, number: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/Device/GetNMemberTransactionsList?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&"; 
        if (number === undefined || number === null)
            throw new Error("The parameter 'number' must be defined and cannot be null.");
        else
            url_ += "number=" + encodeURIComponent("" + number) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNMemberTransactionsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNMemberTransactionsList(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetNMemberTransactionsList(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    getMemberByCode(code: string | null): Observable<MemberModel> {
        let url_ = this.baseUrl + "/api/Device/GetMemberByCode/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberByCode(<any>response_);
                } catch (e) {
                    return <Observable<MemberModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberByCode(response: HttpResponseBase): Observable<MemberModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberModel>(<any>null);
    }

    getMemberByCard(cardNumber: string | null): Observable<MemberModel> {
        let url_ = this.baseUrl + "/api/Device/GetMemberByCard/{cardNumber}";
        if (cardNumber === undefined || cardNumber === null)
            throw new Error("The parameter 'cardNumber' must be defined.");
        url_ = url_.replace("{cardNumber}", encodeURIComponent("" + cardNumber)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberByCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberByCard(<any>response_);
                } catch (e) {
                    return <Observable<MemberModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberByCard(response: HttpResponseBase): Observable<MemberModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberModel>(<any>null);
    }

    getMemberByRfId(rfId: string | null): Observable<MemberModel> {
        let url_ = this.baseUrl + "/api/Device/GetMemberByRfId/{rfId}";
        if (rfId === undefined || rfId === null)
            throw new Error("The parameter 'rfId' must be defined.");
        url_ = url_.replace("{rfId}", encodeURIComponent("" + rfId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberByRfId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberByRfId(<any>response_);
                } catch (e) {
                    return <Observable<MemberModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberByRfId(response: HttpResponseBase): Observable<MemberModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberModel>(<any>null);
    }

    upsertTipsoiLog(command: TipsoiLogUpsertCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Device/UpsertTipsoiLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertTipsoiLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertTipsoiLog(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertTipsoiLog(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    memberPasswordChange(memberCode: string | null, oldPass: string | null, newPass: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Device/MemberPasswordChange?";
        if (memberCode === undefined)
            throw new Error("The parameter 'memberCode' must be defined.");
        else
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (oldPass === undefined)
            throw new Error("The parameter 'oldPass' must be defined.");
        else
            url_ += "oldPass=" + encodeURIComponent("" + oldPass) + "&"; 
        if (newPass === undefined)
            throw new Error("The parameter 'newPass' must be defined.");
        else
            url_ += "newPass=" + encodeURIComponent("" + newPass) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMemberPasswordChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMemberPasswordChange(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMemberPasswordChange(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getUpcomingTennisStolBooking(memberId: number): Observable<SelectModel[]> {
        let url_ = this.baseUrl + "/api/Device/GetUpcomingTennisStolBooking/{memberId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpcomingTennisStolBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpcomingTennisStolBooking(<any>response_);
                } catch (e) {
                    return <Observable<SelectModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SelectModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUpcomingTennisStolBooking(response: HttpResponseBase): Observable<SelectModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModel[]>(<any>null);
    }

    getAvailableTennisBookingStols(day: Date): Observable<TennisBookingStolModel[]> {
        let url_ = this.baseUrl + "/api/Device/GetAvailableTennisBookingStols/{day}";
        if (day === undefined || day === null)
            throw new Error("The parameter 'day' must be defined.");
        url_ = url_.replace("{day}", encodeURIComponent(day ? "" + day.toJSON() : "null")); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableTennisBookingStols(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableTennisBookingStols(<any>response_);
                } catch (e) {
                    return <Observable<TennisBookingStolModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TennisBookingStolModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailableTennisBookingStols(response: HttpResponseBase): Observable<TennisBookingStolModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TennisBookingStolModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TennisBookingStolModel[]>(<any>null);
    }

    upsertTennisSlotBooking(command: UpsertTennisSlotBookingCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Device/UpsertTennisSlotBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertTennisSlotBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertTennisSlotBooking(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertTennisSlotBooking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getTennisSlotBookingDetails(id: number): Observable<TennisSlotBookingModelForDevice> {
        let url_ = this.baseUrl + "/api/Device/GetTennisSlotBookingDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTennisSlotBookingDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTennisSlotBookingDetails(<any>response_);
                } catch (e) {
                    return <Observable<TennisSlotBookingModelForDevice>><any>_observableThrow(e);
                }
            } else
                return <Observable<TennisSlotBookingModelForDevice>><any>_observableThrow(response_);
        }));
    }

    protected processGetTennisSlotBookingDetails(response: HttpResponseBase): Observable<TennisSlotBookingModelForDevice> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TennisSlotBookingModelForDevice.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TennisSlotBookingModelForDevice>(<any>null);
    }

    getTennisSlotBookingDetailsByMember(memberId: number): Observable<TennisSlotBookingModelForDevice[]> {
        let url_ = this.baseUrl + "/api/Device/GetTennisSlotBookingDetailsByMember/{memberId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTennisSlotBookingDetailsByMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTennisSlotBookingDetailsByMember(<any>response_);
                } catch (e) {
                    return <Observable<TennisSlotBookingModelForDevice[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TennisSlotBookingModelForDevice[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTennisSlotBookingDetailsByMember(response: HttpResponseBase): Observable<TennisSlotBookingModelForDevice[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TennisSlotBookingModelForDevice.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TennisSlotBookingModelForDevice[]>(<any>null);
    }

    restaurantBarItemCatalog(): Observable<void> {
        let url_ = this.baseUrl + "/api/Device/RestaurantBarItemCatalog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestaurantBarItemCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestaurantBarItemCatalog(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRestaurantBarItemCatalog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    verifyMember(query: VerifyMemberPin): Observable<void> {
        let url_ = this.baseUrl + "/api/Device/VerifyMember";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyMember(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyMember(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    memberCardBalance(memberId: number): Observable<MemberCardBalanceModel> {
        let url_ = this.baseUrl + "/api/Device/MemberCardBalance/{memberId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMemberCardBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMemberCardBalance(<any>response_);
                } catch (e) {
                    return <Observable<MemberCardBalanceModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberCardBalanceModel>><any>_observableThrow(response_);
        }));
    }

    protected processMemberCardBalance(response: HttpResponseBase): Observable<MemberCardBalanceModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberCardBalanceModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    userActivitySummary(userId: string | null): Observable<UserActivitySummaryModel> {
        let url_ = this.baseUrl + "/api/Device/UserActivitySummary/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserActivitySummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserActivitySummary(<any>response_);
                } catch (e) {
                    return <Observable<UserActivitySummaryModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserActivitySummaryModel>><any>_observableThrow(response_);
        }));
    }

    protected processUserActivitySummary(response: HttpResponseBase): Observable<UserActivitySummaryModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserActivitySummaryModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    insertPoolAvailLog(memberCode: string | null, personCount: number, isExcludedMember: boolean): Observable<number> {
        let url_ = this.baseUrl + "/api/Device/InsertPoolAvailLog?";
        if (memberCode === undefined)
            throw new Error("The parameter 'memberCode' must be defined.");
        else
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        if (personCount === undefined || personCount === null)
            throw new Error("The parameter 'personCount' must be defined and cannot be null.");
        else
            url_ += "personCount=" + encodeURIComponent("" + personCount) + "&"; 
        if (isExcludedMember === undefined || isExcludedMember === null)
            throw new Error("The parameter 'isExcludedMember' must be defined and cannot be null.");
        else
            url_ += "isExcludedMember=" + encodeURIComponent("" + isExcludedMember) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertPoolAvailLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertPoolAvailLog(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processInsertPoolAvailLog(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    insertGymAvailLog(memberCode: string | null): Observable<number> {
        let url_ = this.baseUrl + "/api/Device/InsertGymAvailLog?";
        if (memberCode === undefined)
            throw new Error("The parameter 'memberCode' must be defined.");
        else
            url_ += "memberCode=" + encodeURIComponent("" + memberCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertGymAvailLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertGymAvailLog(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processInsertGymAvailLog(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    availSlotBooking(tennisToken: string | null): Observable<number> {
        let url_ = this.baseUrl + "/api/Device/AvailSlotBooking?";
        if (tennisToken === undefined)
            throw new Error("The parameter 'tennisToken' must be defined.");
        else
            url_ += "tennisToken=" + encodeURIComponent("" + tennisToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvailSlotBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvailSlotBooking(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processAvailSlotBooking(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    cancelSlotBooking(id: number, slotDate: Date): Observable<number> {
        let url_ = this.baseUrl + "/api/Device/CancelSlotBooking?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (slotDate === undefined || slotDate === null)
            throw new Error("The parameter 'slotDate' must be defined and cannot be null.");
        else
            url_ += "slotDate=" + encodeURIComponent(slotDate ? "" + slotDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelSlotBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelSlotBooking(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCancelSlotBooking(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    upsertTransaction(command: UpsertTransactionCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Device/UpsertTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertTransaction(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertTransaction(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getAllowedTransactionTypes(): Observable<SelectModel[]> {
        let url_ = this.baseUrl + "/api/Device/GetAllowedTransactionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowedTransactionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedTransactionTypes(<any>response_);
                } catch (e) {
                    return <Observable<SelectModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SelectModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllowedTransactionTypes(response: HttpResponseBase): Observable<SelectModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModel[]>(<any>null);
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/Device/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    getNotices(): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/Device/GetNotices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotices(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotices(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    getEvents(): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/Device/GetEvents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvents(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetEvents(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    upsertRFID(command: UpsertDeviceRfIdMemberTagCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Device/UpsertRFID";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertRFID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertRFID(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertRFID(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    upsertRFIDWithCard(command: UpsertRfIdByCardNumberCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Device/UpsertRFIDWithCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertRFIDWithCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertRFIDWithCard(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertRFIDWithCard(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IDeviceNotificationsClient {
    upsert(command: UpsertDeviceNotificationsCommand): Observable<number>;
}

@Injectable()
export class DeviceNotificationsClient implements IDeviceNotificationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    upsert(command: UpsertDeviceNotificationsCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/DeviceNotifications/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IEmailProcessClient {
    upsertEmailProcessForMonthlyBill(command: UpsertEmailProcessCommand): Observable<number>;
    upsertEmailProcessForMembershipFee(command: UpsertEmailProcessCommand): Observable<number>;
    upsertTennisFee(command: UpsertTennisFeeProcessCommand): Observable<number>;
}

@Injectable()
export class EmailProcessClient implements IEmailProcessClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    upsertEmailProcessForMonthlyBill(command: UpsertEmailProcessCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/EmailProcess/UpsertEmailProcessForMonthlyBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertEmailProcessForMonthlyBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertEmailProcessForMonthlyBill(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertEmailProcessForMonthlyBill(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    upsertEmailProcessForMembershipFee(command: UpsertEmailProcessCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/EmailProcess/UpsertEmailProcessForMembershipFee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertEmailProcessForMembershipFee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertEmailProcessForMembershipFee(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertEmailProcessForMembershipFee(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    upsertTennisFee(command: UpsertTennisFeeProcessCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/EmailProcess/UpsertTennisFee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertTennisFee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertTennisFee(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertTennisFee(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IEventClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: number): Observable<EventViewModel>;
    upsert(command: UpsertEventCommand): Observable<number>;
    delete(id: number): Observable<void>;
}

@Injectable()
export class EventClient implements IEventClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/Event/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<EventViewModel> {
        let url_ = this.baseUrl + "/api/Event/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<EventViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<EventViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EventViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventViewModel>(<any>null);
    }

    upsert(command: UpsertEventCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Event/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Event/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IGymAvailLogsClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: number): Observable<GymAvailLogViewModel>;
    getMemberByMemberCode(memmberCode: string | null): Observable<GymAvailLogViewModel>;
    upsert(command: UpsertGymAvailLogCommand): Observable<number>;
    delete(id: number): Observable<void>;
}

@Injectable()
export class GymAvailLogsClient implements IGymAvailLogsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/GymAvailLogs/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<GymAvailLogViewModel> {
        let url_ = this.baseUrl + "/api/GymAvailLogs/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<GymAvailLogViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<GymAvailLogViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GymAvailLogViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GymAvailLogViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GymAvailLogViewModel>(<any>null);
    }

    getMemberByMemberCode(memmberCode: string | null): Observable<GymAvailLogViewModel> {
        let url_ = this.baseUrl + "/api/GymAvailLogs/GetMemberByMemberCode/{memmberCode}";
        if (memmberCode === undefined || memmberCode === null)
            throw new Error("The parameter 'memmberCode' must be defined.");
        url_ = url_.replace("{memmberCode}", encodeURIComponent("" + memmberCode)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberByMemberCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberByMemberCode(<any>response_);
                } catch (e) {
                    return <Observable<GymAvailLogViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<GymAvailLogViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberByMemberCode(response: HttpResponseBase): Observable<GymAvailLogViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GymAvailLogViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GymAvailLogViewModel>(<any>null);
    }

    upsert(command: UpsertGymAvailLogCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/GymAvailLogs/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/GymAvailLogs/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IGymRateClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: number): Observable<GymRatesViewModel>;
    upsert(command: UpsertGymRatesCommand): Observable<number>;
    delete(id: number): Observable<void>;
}

@Injectable()
export class GymRateClient implements IGymRateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/GymRate/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<GymRatesViewModel> {
        let url_ = this.baseUrl + "/api/GymRate/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<GymRatesViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<GymRatesViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GymRatesViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GymRatesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GymRatesViewModel>(<any>null);
    }

    upsert(command: UpsertGymRatesCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/GymRate/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/GymRate/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IHolidayClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: number): Observable<HolidayModel>;
    upsert(command: UpsertHolidayCommand): Observable<number>;
}

@Injectable()
export class HolidayClient implements IHolidayClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/Holiday/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<HolidayModel> {
        let url_ = this.baseUrl + "/api/Holiday/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<HolidayModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<HolidayModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HolidayModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HolidayModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HolidayModel>(<any>null);
    }

    upsert(command: UpsertHolidayCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Holiday/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

export interface IIngredientsClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: number): Observable<IngredientViewModel>;
    upsert(command: UpsertIngredientCommand): Observable<number>;
    delete(id: number): Observable<void>;
}

@Injectable()
export class IngredientsClient implements IIngredientsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/Ingredients/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<IngredientViewModel> {
        let url_ = this.baseUrl + "/api/Ingredients/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<IngredientViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<IngredientViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<IngredientViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IngredientViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IngredientViewModel>(<any>null);
    }

    upsert(command: UpsertIngredientCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Ingredients/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Ingredients/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IItemCatalogClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number, statusId: number | null): Observable<ListViewModel>;
    get(id: number): Observable<ItemCatalogViewModel>;
    upsert(command: UpsertItemCatalogCommand): Observable<number>;
    delete(id: number): Observable<void>;
    getItems(): Observable<ItemModel[]>;
}

@Injectable()
export class ItemCatalogClient implements IItemCatalogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number, statusId: number | null): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/ItemCatalog/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        if (statusId === undefined)
            throw new Error("The parameter 'statusId' must be defined.");
        else
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<ItemCatalogViewModel> {
        let url_ = this.baseUrl + "/api/ItemCatalog/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ItemCatalogViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ItemCatalogViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ItemCatalogViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemCatalogViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ItemCatalogViewModel>(<any>null);
    }

    upsert(command: UpsertItemCatalogCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/ItemCatalog/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ItemCatalog/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getItems(): Observable<ItemModel[]> {
        let url_ = this.baseUrl + "/api/ItemCatalog/GetItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItems(<any>response_);
                } catch (e) {
                    return <Observable<ItemModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ItemModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetItems(response: HttpResponseBase): Observable<ItemModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ItemModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ItemModel[]>(<any>null);
    }
}

export interface IMemberCardsClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number, memberId: number): Observable<ListViewModel>;
    get(id: number, memberId: number): Observable<MemberCardViewModel>;
    upsert(command: UpsertCardCommand): Observable<number>;
    pinChangeRequest(model: PinChangeRequestModel): Observable<FileResponse>;
    getAllPinChangeRequst(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    checkMemberCard(memberId: number): Observable<boolean>;
}

@Injectable()
export class MemberCardsClient implements IMemberCardsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number, memberId: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/MemberCards/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number, memberId: number): Observable<MemberCardViewModel> {
        let url_ = this.baseUrl + "/api/MemberCards/Get/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MemberCardViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberCardViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MemberCardViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberCardViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberCardViewModel>(<any>null);
    }

    upsert(command: UpsertCardCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MemberCards/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    pinChangeRequest(model: PinChangeRequestModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MemberCards/PinChangeRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPinChangeRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPinChangeRequest(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processPinChangeRequest(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    getAllPinChangeRequst(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/MemberCards/GetAllPinChangeRequst?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPinChangeRequst(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPinChangeRequst(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPinChangeRequst(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    checkMemberCard(memberId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/MemberCards/CheckMemberCard/{memberId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckMemberCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMemberCard(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckMemberCard(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

export interface IMemberCardsPinClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    builkInsert(command: BulkInsertMembershipCardPinCommand): Observable<number>;
}

@Injectable()
export class MemberCardsPinClient implements IMemberCardsPinClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/MemberCardsPin/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    builkInsert(command: BulkInsertMembershipCardPinCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MemberCardsPin/BuilkInsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuilkInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuilkInsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processBuilkInsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IMemberContributionsClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number, memberId: number): Observable<ListViewModel>;
    get(id: number, memberId: number): Observable<MemberContributionViewModel>;
    upsert(command: UpsertContributionCommand): Observable<number>;
    delete(id: number): Observable<void>;
}

@Injectable()
export class MemberContributionsClient implements IMemberContributionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number, memberId: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/MemberContributions/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number, memberId: number): Observable<MemberContributionViewModel> {
        let url_ = this.baseUrl + "/api/MemberContributions/Get/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MemberContributionViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberContributionViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MemberContributionViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberContributionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberContributionViewModel>(<any>null);
    }

    upsert(command: UpsertContributionCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MemberContributions/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/MemberContributions/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IMemberDocumentsClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number, memberId: number): Observable<ListViewModel>;
    get(id: number): Observable<MemberDocumentViewModel>;
    upsert(command: UpsertMemberDocumentCommand): Observable<number>;
    downloadDocument(id: number): Observable<FileResponse>;
    delete(id: number): Observable<void>;
}

@Injectable()
export class MemberDocumentsClient implements IMemberDocumentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number, memberId: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/MemberDocuments/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<MemberDocumentViewModel> {
        let url_ = this.baseUrl + "/api/MemberDocuments/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MemberDocumentViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberDocumentViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MemberDocumentViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberDocumentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberDocumentViewModel>(<any>null);
    }

    upsert(command: UpsertMemberDocumentCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MemberDocuments/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    downloadDocument(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/MemberDocuments/DownloadDocument/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDocument(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/MemberDocuments/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IMemberPhotosClient {
    get(id: number): Observable<ApplicationImageModel>;
    upsert(command: UpsertMemberPhotoCommand): Observable<number>;
    delete(id: number): Observable<void>;
    handleImageData(memberId: number, fileName: string | null): Observable<void>;
}

@Injectable()
export class MemberPhotosClient implements IMemberPhotosClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    get(id: number): Observable<ApplicationImageModel> {
        let url_ = this.baseUrl + "/api/MemberPhotos/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ApplicationImageModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApplicationImageModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApplicationImageModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationImageModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApplicationImageModel>(<any>null);
    }

    upsert(command: UpsertMemberPhotoCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MemberPhotos/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/MemberPhotos/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    handleImageData(memberId: number, fileName: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/MemberPhotos/HandleImageData/{memberId}/{fileName}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId)); 
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHandleImageData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHandleImageData(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processHandleImageData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IMemberRfIdTrackClient {
    get(id: number): Observable<RFTracViewModel>;
    upsert(command: UpssertRfIdTrackCommand): Observable<number>;
}

@Injectable()
export class MemberRfIdTrackClient implements IMemberRfIdTrackClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    get(id: number): Observable<RFTracViewModel> {
        let url_ = this.baseUrl + "/api/MemberRfIdTrack/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RFTracViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<RFTracViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RFTracViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RFTracViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RFTracViewModel>(<any>null);
    }

    upsert(command: UpssertRfIdTrackCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MemberRfIdTrack/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IMembersClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number, statusId: number | null): Observable<ListViewModel>;
    get(id: number): Observable<MemberViewModel>;
    upsert(command: UpsertMemberCommand): Observable<MemberUpsertResponse>;
    getMemberByCode(code: string | null): Observable<MemberModel>;
    delete(id: number): Observable<void>;
    passwordReset(memberCode: string | null): Observable<void>;
}

@Injectable()
export class MembersClient implements IMembersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number, statusId: number | null): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/Members/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        if (statusId === undefined)
            throw new Error("The parameter 'statusId' must be defined.");
        else
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<MemberViewModel> {
        let url_ = this.baseUrl + "/api/Members/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MemberViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MemberViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberViewModel>(<any>null);
    }

    upsert(command: UpsertMemberCommand): Observable<MemberUpsertResponse> {
        let url_ = this.baseUrl + "/api/Members/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<MemberUpsertResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberUpsertResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<MemberUpsertResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberUpsertResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getMemberByCode(code: string | null): Observable<MemberModel> {
        let url_ = this.baseUrl + "/api/Members/GetMemberByCode/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberByCode(<any>response_);
                } catch (e) {
                    return <Observable<MemberModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberByCode(response: HttpResponseBase): Observable<MemberModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberModel>(<any>null);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Members/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    passwordReset(memberCode: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/Members/passwordReset/{memberCode}";
        if (memberCode === undefined || memberCode === null)
            throw new Error("The parameter 'memberCode' must be defined.");
        url_ = url_.replace("{memberCode}", encodeURIComponent("" + memberCode)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPasswordReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPasswordReset(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPasswordReset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IMembershipTypeClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: number): Observable<MembershipTypeViewModel>;
    upsert(command: UpsertMembershipTypeCommand): Observable<number>;
    delete(id: number): Observable<void>;
}

@Injectable()
export class MembershipTypeClient implements IMembershipTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/MembershipType/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<MembershipTypeViewModel> {
        let url_ = this.baseUrl + "/api/MembershipType/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MembershipTypeViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MembershipTypeViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MembershipTypeViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MembershipTypeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MembershipTypeViewModel>(<any>null);
    }

    upsert(command: UpsertMembershipTypeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MembershipType/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/MembershipType/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IMemberTransactionsClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number, memberId: number): Observable<ListViewModel>;
    get(id: number, memberId: number): Observable<MemberTransactionViewModel>;
    getMemberType(memberId: number): Observable<number>;
    getNMemberTransactionsList(memberId: number, number: number): Observable<ListViewModel>;
    upsert(command: UpsertTransactionCommand): Observable<number>;
    getMember(): Observable<MemberTransactionViewModel>;
}

@Injectable()
export class MemberTransactionsClient implements IMemberTransactionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number, memberId: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/MemberTransactions/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number, memberId: number): Observable<MemberTransactionViewModel> {
        let url_ = this.baseUrl + "/api/MemberTransactions/Get/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<MemberTransactionViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberTransactionViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MemberTransactionViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberTransactionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberTransactionViewModel>(<any>null);
    }

    getMemberType(memberId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/MemberTransactions/GetMemberType?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberType(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberType(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    getNMemberTransactionsList(memberId: number, number: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/MemberTransactions/GetNMemberTransactionsList?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&"; 
        if (number === undefined || number === null)
            throw new Error("The parameter 'number' must be defined and cannot be null.");
        else
            url_ += "number=" + encodeURIComponent("" + number) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNMemberTransactionsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNMemberTransactionsList(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetNMemberTransactionsList(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    upsert(command: UpsertTransactionCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/MemberTransactions/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getMember(): Observable<MemberTransactionViewModel> {
        let url_ = this.baseUrl + "/api/MemberTransactions/GetMember";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMember(<any>response_);
                } catch (e) {
                    return <Observable<MemberTransactionViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberTransactionViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetMember(response: HttpResponseBase): Observable<MemberTransactionViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberTransactionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberTransactionViewModel>(<any>null);
    }
}

export interface INoticeClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: number): Observable<NoticeViewModel>;
    upsert(command: UpsertNoticeCommand): Observable<number>;
    delete(id: number): Observable<void>;
}

@Injectable()
export class NoticeClient implements INoticeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/Notice/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<NoticeViewModel> {
        let url_ = this.baseUrl + "/api/Notice/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<NoticeViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<NoticeViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NoticeViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoticeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NoticeViewModel>(<any>null);
    }

    upsert(command: UpsertNoticeCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Notice/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Notice/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IOrdersClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number, statusId: number | null): Observable<ListViewModel>;
    getActiveOrder(counterId: number): Observable<OrderModel[]>;
    get(id: number): Observable<OrderViewModel>;
    getByCounter(id: number, counterId: number): Observable<OrderViewModel>;
    upsert(command: UpsertOrderCommand): Observable<OrderModel>;
    completeOrder(orderId: number): Observable<boolean>;
    deleteSpecificOrderItem(id: number): Observable<void>;
    upsertSpecificOrderItem(command: UpdateSpecificOrderItemCommand): Observable<void>;
    updateOrderItemStatus(command: UpdateOrderItemCommand): Observable<void>;
    updateOrderStatus(orderId: number, orderStatusId: number): Observable<void>;
    getActiveOrdersByUser(userId: string | null): Observable<OrderModel[]>;
    getAllOrdersByUser(pageIndex: number, pageSize: number, userId: string | null): Observable<ListModel>;
    deleteOrder(id: number): Observable<void>;
    getAllPendingOrdersByUser(pageIndex: number, pageSize: number, userId: string | null, searchValue: string | null): Observable<ListModel>;
    getAllCompleteOrdersByUser(pageIndex: number, pageSize: number, userId: string | null, searchValue: string | null): Observable<ListModel>;
    getAllStatus(): Observable<SelectModel[]>;
    printSalesOrder(orderId: number): Observable<void>;
}

@Injectable()
export class OrdersClient implements IOrdersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number, statusId: number | null): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/Orders/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        if (statusId === undefined)
            throw new Error("The parameter 'statusId' must be defined.");
        else
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    getActiveOrder(counterId: number): Observable<OrderModel[]> {
        let url_ = this.baseUrl + "/api/Orders/GetActiveOrder?";
        if (counterId === undefined || counterId === null)
            throw new Error("The parameter 'counterId' must be defined and cannot be null.");
        else
            url_ += "counterId=" + encodeURIComponent("" + counterId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveOrder(<any>response_);
                } catch (e) {
                    return <Observable<OrderModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveOrder(response: HttpResponseBase): Observable<OrderModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderModel[]>(<any>null);
    }

    get(id: number): Observable<OrderViewModel> {
        let url_ = this.baseUrl + "/api/Orders/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OrderViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderViewModel>(<any>null);
    }

    getByCounter(id: number, counterId: number): Observable<OrderViewModel> {
        let url_ = this.baseUrl + "/api/Orders/GetByCounter/{id}/{counterId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (counterId === undefined || counterId === null)
            throw new Error("The parameter 'counterId' must be defined.");
        url_ = url_.replace("{counterId}", encodeURIComponent("" + counterId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCounter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCounter(<any>response_);
                } catch (e) {
                    return <Observable<OrderViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetByCounter(response: HttpResponseBase): Observable<OrderViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderViewModel>(<any>null);
    }

    upsert(command: UpsertOrderCommand): Observable<OrderModel> {
        let url_ = this.baseUrl + "/api/Orders/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<OrderModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderModel>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<OrderModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    completeOrder(orderId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Orders/CompleteOrder/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteOrder(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCompleteOrder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    deleteSpecificOrderItem(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders/DeleteSpecificOrderItem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSpecificOrderItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSpecificOrderItem(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteSpecificOrderItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    upsertSpecificOrderItem(command: UpdateSpecificOrderItemCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders/UpsertSpecificOrderItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertSpecificOrderItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertSpecificOrderItem(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpsertSpecificOrderItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    updateOrderItemStatus(command: UpdateOrderItemCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders/UpdateOrderItemStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderItemStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderItemStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateOrderItemStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    updateOrderStatus(orderId: number, orderStatusId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders/UpdateOrderStatus/{orderId}/{orderStatusId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId)); 
        if (orderStatusId === undefined || orderStatusId === null)
            throw new Error("The parameter 'orderStatusId' must be defined.");
        url_ = url_.replace("{orderStatusId}", encodeURIComponent("" + orderStatusId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateOrderStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getActiveOrdersByUser(userId: string | null): Observable<OrderModel[]> {
        let url_ = this.baseUrl + "/api/Orders/GetActiveOrdersByUser/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveOrdersByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveOrdersByUser(<any>response_);
                } catch (e) {
                    return <Observable<OrderModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveOrdersByUser(response: HttpResponseBase): Observable<OrderModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderModel[]>(<any>null);
    }

    getAllOrdersByUser(pageIndex: number, pageSize: number, userId: string | null): Observable<ListModel> {
        let url_ = this.baseUrl + "/api/Orders/GetAllOrdersByUser?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (userId === undefined)
            throw new Error("The parameter 'userId' must be defined.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrdersByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrdersByUser(<any>response_);
                } catch (e) {
                    return <Observable<ListModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllOrdersByUser(response: HttpResponseBase): Observable<ListModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListModel>(<any>null);
    }

    deleteOrder(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders/DeleteOrder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrder(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getAllPendingOrdersByUser(pageIndex: number, pageSize: number, userId: string | null, searchValue: string | null): Observable<ListModel> {
        let url_ = this.baseUrl + "/api/Orders/GetAllPendingOrdersByUser?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (userId === undefined)
            throw new Error("The parameter 'userId' must be defined.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPendingOrdersByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPendingOrdersByUser(<any>response_);
                } catch (e) {
                    return <Observable<ListModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPendingOrdersByUser(response: HttpResponseBase): Observable<ListModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListModel>(<any>null);
    }

    getAllCompleteOrdersByUser(pageIndex: number, pageSize: number, userId: string | null, searchValue: string | null): Observable<ListModel> {
        let url_ = this.baseUrl + "/api/Orders/GetAllCompleteOrdersByUser?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (userId === undefined)
            throw new Error("The parameter 'userId' must be defined.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompleteOrdersByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompleteOrdersByUser(<any>response_);
                } catch (e) {
                    return <Observable<ListModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCompleteOrdersByUser(response: HttpResponseBase): Observable<ListModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListModel>(<any>null);
    }

    getAllStatus(): Observable<SelectModel[]> {
        let url_ = this.baseUrl + "/api/Orders/GetAllStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatus(<any>response_);
                } catch (e) {
                    return <Observable<SelectModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SelectModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllStatus(response: HttpResponseBase): Observable<SelectModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModel[]>(<any>null);
    }

    printSalesOrder(orderId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Orders/PrintSalesOrder/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrintSalesOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrintSalesOrder(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPrintSalesOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IPasswordChangeClient {
    passwordChange(command: PasswordChangeCommand): Observable<void>;
}

@Injectable()
export class PasswordChangeClient implements IPasswordChangeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    passwordChange(command: PasswordChangeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/PasswordChange/PasswordChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPasswordChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPasswordChange(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPasswordChange(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IPoolAvailLogsClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: number): Observable<PoolAvailLogViewModel>;
    getMemberByMemberCode(memberCode: string | null): Observable<PoolAvailLogViewModel>;
    upsert(command: UpsertPoolAvailLogCommand): Observable<number>;
    delete(id: number): Observable<void>;
}

@Injectable()
export class PoolAvailLogsClient implements IPoolAvailLogsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/PoolAvailLogs/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<PoolAvailLogViewModel> {
        let url_ = this.baseUrl + "/api/PoolAvailLogs/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PoolAvailLogViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PoolAvailLogViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PoolAvailLogViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PoolAvailLogViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PoolAvailLogViewModel>(<any>null);
    }

    getMemberByMemberCode(memberCode: string | null): Observable<PoolAvailLogViewModel> {
        let url_ = this.baseUrl + "/api/PoolAvailLogs/GetMemberByMemberCode/{memberCode}";
        if (memberCode === undefined || memberCode === null)
            throw new Error("The parameter 'memberCode' must be defined.");
        url_ = url_.replace("{memberCode}", encodeURIComponent("" + memberCode)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberByMemberCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberByMemberCode(<any>response_);
                } catch (e) {
                    return <Observable<PoolAvailLogViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PoolAvailLogViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberByMemberCode(response: HttpResponseBase): Observable<PoolAvailLogViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PoolAvailLogViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PoolAvailLogViewModel>(<any>null);
    }

    upsert(command: UpsertPoolAvailLogCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/PoolAvailLogs/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/PoolAvailLogs/Delete?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IPoolRateClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: number): Observable<PoolRatesViewModel>;
    upsert(command: UpsertPoolRatesCommand): Observable<number>;
    delete(id: number): Observable<void>;
}

@Injectable()
export class PoolRateClient implements IPoolRateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/PoolRate/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<PoolRatesViewModel> {
        let url_ = this.baseUrl + "/api/PoolRate/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PoolRatesViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PoolRatesViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PoolRatesViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PoolRatesViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PoolRatesViewModel>(<any>null);
    }

    upsert(command: UpsertPoolRatesCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/PoolRate/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/PoolRate/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IReportDesignerClient {
    getReportDesignerModel(reportUrl: string | null): Observable<FileResponse>;
    invoke(): Observable<FileResponse>;
    getLocalization(): Observable<FileResponse>;
}

@Injectable()
export class ReportDesignerClient implements IReportDesignerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getReportDesignerModel(reportUrl: string | null): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportDesigner/get-report-designer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (reportUrl !== null && reportUrl !== undefined)
            content_.append("reportUrl", reportUrl.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportDesignerModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportDesignerModel(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetReportDesignerModel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    invoke(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DXXRD";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoke(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processInvoke(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    getLocalization(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DXXRD/GetLocalization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalization(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocalization(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

export interface IRolePermissionsClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: string | null): Observable<RolePermissionViewModel>;
    upsert(command: UpsertRolePermissionCommand): Observable<void>;
    delete(id: string | null): Observable<void>;
}

@Injectable()
export class RolePermissionsClient implements IRolePermissionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/RolePermissions/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: string | null): Observable<RolePermissionViewModel> {
        let url_ = this.baseUrl + "/api/RolePermissions/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RolePermissionViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<RolePermissionViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RolePermissionViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RolePermissionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RolePermissionViewModel>(<any>null);
    }

    upsert(command: UpsertRolePermissionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/RolePermissions/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: string | null): Observable<void> {
        let url_ = this.baseUrl + "/api/RolePermissions/Delete?";
        if (id === undefined)
            throw new Error("The parameter 'id' must be defined.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface ISalesCategoriesClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    getCategoriesSelectList(): Observable<SelectModel[]>;
    getCategoriesTreeNodes(): Observable<TreeNodeModel[]>;
    get(id: number): Observable<SalesCategoryViewModel>;
    upsert(command: UpsertCategoryCommand): Observable<number>;
    delete(id: number): Observable<void>;
}

@Injectable()
export class SalesCategoriesClient implements ISalesCategoriesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/SalesCategories/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    getCategoriesSelectList(): Observable<SelectModel[]> {
        let url_ = this.baseUrl + "/api/SalesCategories/GetCategoriesSelectList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoriesSelectList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoriesSelectList(<any>response_);
                } catch (e) {
                    return <Observable<SelectModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SelectModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategoriesSelectList(response: HttpResponseBase): Observable<SelectModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModel[]>(<any>null);
    }

    getCategoriesTreeNodes(): Observable<TreeNodeModel[]> {
        let url_ = this.baseUrl + "/api/SalesCategories/GetCategoriesTreeNodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoriesTreeNodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoriesTreeNodes(<any>response_);
                } catch (e) {
                    return <Observable<TreeNodeModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TreeNodeModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategoriesTreeNodes(response: HttpResponseBase): Observable<TreeNodeModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeNodeModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TreeNodeModel[]>(<any>null);
    }

    get(id: number): Observable<SalesCategoryViewModel> {
        let url_ = this.baseUrl + "/api/SalesCategories/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<SalesCategoryViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<SalesCategoryViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SalesCategoryViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesCategoryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalesCategoryViewModel>(<any>null);
    }

    upsert(command: UpsertCategoryCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/SalesCategories/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/SalesCategories/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface ISellsCounterClient {
    getAll(): Observable<CounterModel[]>;
}

@Injectable()
export class SellsCounterClient implements ISellsCounterClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(): Observable<CounterModel[]> {
        let url_ = this.baseUrl + "/api/SellsCounter/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CounterModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CounterModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CounterModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CounterModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CounterModel[]>(<any>null);
    }
}

export interface IStockCategoriesClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: number): Observable<StockCategoryViewModel>;
    upsert(command: UpsertStockCategoryCommand): Observable<number>;
    delete(id: number): Observable<void>;
}

@Injectable()
export class StockCategoriesClient implements IStockCategoriesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/StockCategories/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<StockCategoryViewModel> {
        let url_ = this.baseUrl + "/api/StockCategories/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<StockCategoryViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockCategoryViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StockCategoryViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockCategoryViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockCategoryViewModel>(<any>null);
    }

    upsert(command: UpsertStockCategoryCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/StockCategories/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/StockCategories/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IStockItemClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: number): Observable<StockItemViewModel>;
    upsert(command: UpsertStockItemCommand): Observable<number>;
    delete(id: number): Observable<void>;
}

@Injectable()
export class StockItemClient implements IStockItemClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/StockItem/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<StockItemViewModel> {
        let url_ = this.baseUrl + "/api/StockItem/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<StockItemViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockItemViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StockItemViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockItemViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockItemViewModel>(<any>null);
    }

    upsert(command: UpsertStockItemCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/StockItem/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/StockItem/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IStockItemRegisterClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number, stockRegisterTypeId: number): Observable<ListViewModel>;
    get(id: number, registerType: string | null, storeId: number): Observable<StockItemRegisterViewModel>;
    getCurrentStockByStoreId(storeId: number): Observable<SelectModel[]>;
    getItemConsumtionRegister(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<StockItemRegisterViewModel>;
    insertStockItemRegister(command: InsertStockItemRegisterCommand): Observable<number>;
    insertStockItemTransferRegister(command: InsertStockItemTransferRegisterCommand): Observable<number>;
    insertStockItemConsumptionRegister(command: InsertStockItemConsumptionRegisterCommand): Observable<number[]>;
    getStockCategorySelectList(): Observable<SelectModel[]>;
    generateMonthlyStockDetailExcelReport(command: GetReportOfMonthlyStockItemsDetailQuery): Observable<FileResponse>;
}

@Injectable()
export class StockItemRegisterClient implements IStockItemRegisterClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number, stockRegisterTypeId: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/StockItemRegister/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        if (stockRegisterTypeId === undefined || stockRegisterTypeId === null)
            throw new Error("The parameter 'stockRegisterTypeId' must be defined and cannot be null.");
        else
            url_ += "stockRegisterTypeId=" + encodeURIComponent("" + stockRegisterTypeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number, registerType: string | null, storeId: number): Observable<StockItemRegisterViewModel> {
        let url_ = this.baseUrl + "/api/StockItemRegister/Get/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (registerType === undefined)
            throw new Error("The parameter 'registerType' must be defined.");
        else
            url_ += "registerType=" + encodeURIComponent("" + registerType) + "&"; 
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined and cannot be null.");
        else
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<StockItemRegisterViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockItemRegisterViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StockItemRegisterViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockItemRegisterViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockItemRegisterViewModel>(<any>null);
    }

    getCurrentStockByStoreId(storeId: number): Observable<SelectModel[]> {
        let url_ = this.baseUrl + "/api/StockItemRegister/GetCurrentStockByStoreId/{storeId}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentStockByStoreId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentStockByStoreId(<any>response_);
                } catch (e) {
                    return <Observable<SelectModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SelectModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentStockByStoreId(response: HttpResponseBase): Observable<SelectModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModel[]>(<any>null);
    }

    getItemConsumtionRegister(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<StockItemRegisterViewModel> {
        let url_ = this.baseUrl + "/api/StockItemRegister/GetItemConsumtionRegister?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetItemConsumtionRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItemConsumtionRegister(<any>response_);
                } catch (e) {
                    return <Observable<StockItemRegisterViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockItemRegisterViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetItemConsumtionRegister(response: HttpResponseBase): Observable<StockItemRegisterViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockItemRegisterViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockItemRegisterViewModel>(<any>null);
    }

    insertStockItemRegister(command: InsertStockItemRegisterCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/StockItemRegister/InsertStockItemRegister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertStockItemRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertStockItemRegister(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processInsertStockItemRegister(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    insertStockItemTransferRegister(command: InsertStockItemTransferRegisterCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/StockItemRegister/InsertStockItemTransferRegister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertStockItemTransferRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertStockItemTransferRegister(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processInsertStockItemTransferRegister(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    insertStockItemConsumptionRegister(command: InsertStockItemConsumptionRegisterCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/StockItemRegister/InsertStockItemConsumptionRegister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertStockItemConsumptionRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertStockItemConsumptionRegister(<any>response_);
                } catch (e) {
                    return <Observable<number[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<number[]>><any>_observableThrow(response_);
        }));
    }

    protected processInsertStockItemConsumptionRegister(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getStockCategorySelectList(): Observable<SelectModel[]> {
        let url_ = this.baseUrl + "/api/StockItemRegister/GetStockCategorySelectList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockCategorySelectList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockCategorySelectList(<any>response_);
                } catch (e) {
                    return <Observable<SelectModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SelectModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetStockCategorySelectList(response: HttpResponseBase): Observable<SelectModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModel[]>(<any>null);
    }

    generateMonthlyStockDetailExcelReport(command: GetReportOfMonthlyStockItemsDetailQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/StockItemRegister/GenerateMonthlyStockDetailExcelReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateMonthlyStockDetailExcelReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateMonthlyStockDetailExcelReport(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateMonthlyStockDetailExcelReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

export interface IStockItemTransferRegisterClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<StockItemRegisterViewModel>;
}

@Injectable()
export class StockItemTransferRegisterClient implements IStockItemTransferRegisterClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<StockItemRegisterViewModel> {
        let url_ = this.baseUrl + "/api/StockItemTransferRegister/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<StockItemRegisterViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockItemRegisterViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StockItemRegisterViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockItemRegisterViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockItemRegisterViewModel>(<any>null);
    }
}

export interface ITennisBookingSlotClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    getAllSchedules(startDate: Date, endDate: Date): Observable<ListViewModel>;
    get(id: number): Observable<TennisBookingSlotViewModel>;
    upsert(command: UpsertTennisBookingSlotCommand): Observable<number>;
    delete(id: number): Observable<void>;
    getSlotWithDate(bookingDate: Date): Observable<CardListModel>;
    cancelBooking(command: CancelTennisBookingSlotCommand): Observable<number>;
    blockBooking(command: BlockTennisBookingSlotCommand): Observable<number>;
}

@Injectable()
export class TennisBookingSlotClient implements ITennisBookingSlotClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/TennisBookingSlot/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    getAllSchedules(startDate: Date, endDate: Date): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/TennisBookingSlot/GetAllSchedules?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSchedules(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSchedules(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<TennisBookingSlotViewModel> {
        let url_ = this.baseUrl + "/api/TennisBookingSlot/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TennisBookingSlotViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TennisBookingSlotViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TennisBookingSlotViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TennisBookingSlotViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TennisBookingSlotViewModel>(<any>null);
    }

    upsert(command: UpsertTennisBookingSlotCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/TennisBookingSlot/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/TennisBookingSlot/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getSlotWithDate(bookingDate: Date): Observable<CardListModel> {
        let url_ = this.baseUrl + "/api/TennisBookingSlot/GetSlotWithDate?";
        if (bookingDate === undefined || bookingDate === null)
            throw new Error("The parameter 'bookingDate' must be defined and cannot be null.");
        else
            url_ += "bookingDate=" + encodeURIComponent(bookingDate ? "" + bookingDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlotWithDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlotWithDate(<any>response_);
                } catch (e) {
                    return <Observable<CardListModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<CardListModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetSlotWithDate(response: HttpResponseBase): Observable<CardListModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardListModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CardListModel>(<any>null);
    }

    cancelBooking(command: CancelTennisBookingSlotCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/TennisBookingSlot/CancelBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelBooking(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCancelBooking(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    blockBooking(command: BlockTennisBookingSlotCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/TennisBookingSlot/BlockBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlockBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockBooking(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processBlockBooking(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface ITennisFeeSettingsClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: number): Observable<TennisFeeSettingViewModel>;
    upsert(command: UpsertTennisFeeSettingCommand): Observable<number>;
    delete(id: number): Observable<void>;
}

@Injectable()
export class TennisFeeSettingsClient implements ITennisFeeSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/TennisFeeSettings/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<TennisFeeSettingViewModel> {
        let url_ = this.baseUrl + "/api/TennisFeeSettings/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TennisFeeSettingViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TennisFeeSettingViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TennisFeeSettingViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TennisFeeSettingViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TennisFeeSettingViewModel>(<any>null);
    }

    upsert(command: UpsertTennisFeeSettingCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/TennisFeeSettings/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/TennisFeeSettings/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface ITennisSlotBookingClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: number): Observable<TennisSlotBookingViewModel>;
    upsert(command: UpsertTennisSlotBookingCommand): Observable<number>;
    delete(id: number): Observable<void>;
    getSlotInfo(id: number, day: Date): Observable<TennisFeeSettingViewModel>;
    getAvailableSlots(day: Date): Observable<TennisBookingStolModel[]>;
    getUpcomingBooking(memberId: number): Observable<SelectModel[]>;
}

@Injectable()
export class TennisSlotBookingClient implements ITennisSlotBookingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/TennisSlotBooking/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<TennisSlotBookingViewModel> {
        let url_ = this.baseUrl + "/api/TennisSlotBooking/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TennisSlotBookingViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TennisSlotBookingViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TennisSlotBookingViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TennisSlotBookingViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TennisSlotBookingViewModel>(<any>null);
    }

    upsert(command: UpsertTennisSlotBookingCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/TennisSlotBooking/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/TennisSlotBooking/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    getSlotInfo(id: number, day: Date): Observable<TennisFeeSettingViewModel> {
        let url_ = this.baseUrl + "/api/TennisSlotBooking/GetSlotInfo/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (day === undefined || day === null)
            throw new Error("The parameter 'day' must be defined and cannot be null.");
        else
            url_ += "day=" + encodeURIComponent(day ? "" + day.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlotInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlotInfo(<any>response_);
                } catch (e) {
                    return <Observable<TennisFeeSettingViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TennisFeeSettingViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetSlotInfo(response: HttpResponseBase): Observable<TennisFeeSettingViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TennisFeeSettingViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TennisFeeSettingViewModel>(<any>null);
    }

    getAvailableSlots(day: Date): Observable<TennisBookingStolModel[]> {
        let url_ = this.baseUrl + "/api/TennisSlotBooking/GetAvailableSlots/{day}";
        if (day === undefined || day === null)
            throw new Error("The parameter 'day' must be defined.");
        url_ = url_.replace("{day}", encodeURIComponent(day ? "" + day.toJSON() : "null")); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableSlots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableSlots(<any>response_);
                } catch (e) {
                    return <Observable<TennisBookingStolModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TennisBookingStolModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailableSlots(response: HttpResponseBase): Observable<TennisBookingStolModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TennisBookingStolModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TennisBookingStolModel[]>(<any>null);
    }

    getUpcomingBooking(memberId: number): Observable<SelectModel[]> {
        let url_ = this.baseUrl + "/api/TennisSlotBooking/GetUpcomingBooking/{memberId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpcomingBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpcomingBooking(<any>response_);
                } catch (e) {
                    return <Observable<SelectModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SelectModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUpcomingBooking(response: HttpResponseBase): Observable<SelectModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectModel[]>(<any>null);
    }
}

export interface IUploadClient {
    uploadFile(): Observable<void>;
}

@Injectable()
export class UploadClient implements IUploadClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    uploadFile(): Observable<void> {
        let url_ = this.baseUrl + "/api/Upload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        }
    }
}

export interface IUserContactsClient {
    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel>;
    get(id: number): Observable<UserContactViewModel>;
    upsert(command: UpsertUserContactCommand): Observable<number>;
}

@Injectable()
export class UserContactsClient implements IUserContactsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(pageIndex: number, pageSize: number, searchValue: string | null, sortDirection: string | null, sortFieldName: string | null, isSchemaLoaded: boolean, totalCount: number): Observable<ListViewModel> {
        let url_ = this.baseUrl + "/api/UserContacts/GetAll?";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&"; 
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (searchValue === undefined)
            throw new Error("The parameter 'searchValue' must be defined.");
        else
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&"; 
        if (sortDirection === undefined)
            throw new Error("The parameter 'sortDirection' must be defined.");
        else
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&"; 
        if (sortFieldName === undefined)
            throw new Error("The parameter 'sortFieldName' must be defined.");
        else
            url_ += "sortFieldName=" + encodeURIComponent("" + sortFieldName) + "&"; 
        if (isSchemaLoaded === undefined || isSchemaLoaded === null)
            throw new Error("The parameter 'isSchemaLoaded' must be defined and cannot be null.");
        else
            url_ += "isSchemaLoaded=" + encodeURIComponent("" + isSchemaLoaded) + "&"; 
        if (totalCount === undefined || totalCount === null)
            throw new Error("The parameter 'totalCount' must be defined and cannot be null.");
        else
            url_ += "totalCount=" + encodeURIComponent("" + totalCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<ListViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ListViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListViewModel>(<any>null);
    }

    get(id: number): Observable<UserContactViewModel> {
        let url_ = this.baseUrl + "/api/UserContacts/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserContactViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserContactViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserContactViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserContactViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserContactViewModel>(<any>null);
    }

    upsert(command: UpsertUserContactCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/UserContacts/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IUserProfileClient {
    get(id: number): Observable<UserProfileViewModel>;
    upsert(command: UpsertUserProfileCommand): Observable<number>;
}

@Injectable()
export class UserProfileClient implements IUserProfileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    get(id: number): Observable<UserProfileViewModel> {
        let url_ = this.baseUrl + "/api/UserProfile/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserProfileViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserProfileViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserProfileViewModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProfileViewModel>(<any>null);
    }

    upsert(command: UpsertUserProfileCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/UserProfile/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IWebDocumentViewerClient {
    invoke(): Observable<FileResponse>;
    invoke2(): Observable<FileResponse>;
    invoke3(): Observable<FileResponse>;
    getLocalization(): Observable<FileResponse>;
}

@Injectable()
export class WebDocumentViewerClient implements IWebDocumentViewerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    invoke(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DXXRDV";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoke(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processInvoke(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    invoke2(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DXXRDV";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoke2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoke2(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processInvoke2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    invoke3(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DXXRDV";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("options", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoke3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoke3(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processInvoke3(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    getLocalization(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DXXRDV/GetLocalization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalization(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocalization(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

export interface IQueryBuilderClient {
    invoke(): Observable<FileResponse>;
    getLocalization(): Observable<FileResponse>;
}

@Injectable()
export class QueryBuilderClient implements IQueryBuilderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    invoke(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DXXQB";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvoke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvoke(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processInvoke(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }

    getLocalization(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/DXXQB/GetLocalization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalization(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocalization(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(<any>null);
    }
}

export class ListModel implements IListModel {
    data?: any | undefined;
    count?: number;

    constructor(data?: IListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ListModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["count"] = this.count;
        return data; 
    }
}

export interface IListModel {
    data?: any | undefined;
    count?: number;
}

export class ListViewModel extends ListModel implements IListViewModel {
    fields?: FieldModel[] | undefined;
    toolbarItems?: ToolbarItemModel[] | undefined;
    searchFields?: string | undefined;

    constructor(data?: IListViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(FieldModel.fromJS(item));
            }
            if (Array.isArray(_data["toolbarItems"])) {
                this.toolbarItems = [] as any;
                for (let item of _data["toolbarItems"])
                    this.toolbarItems!.push(ToolbarItemModel.fromJS(item));
            }
            this.searchFields = _data["searchFields"];
        }
    }

    static fromJS(data: any): ListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        if (Array.isArray(this.toolbarItems)) {
            data["toolbarItems"] = [];
            for (let item of this.toolbarItems)
                data["toolbarItems"].push(item.toJSON());
        }
        data["searchFields"] = this.searchFields;
        super.toJSON(data);
        return data; 
    }
}

export interface IListViewModel extends IListModel {
    fields?: FieldModel[] | undefined;
    toolbarItems?: ToolbarItemModel[] | undefined;
    searchFields?: string | undefined;
}

export class FieldModel implements IFieldModel {
    name?: string | undefined;
    displayName?: string | undefined;
    isLink?: boolean;
    dataType?: string | undefined;
    format?: string | undefined;
    visible?: boolean;
    width?: number;
    sortOrder?: number;

    constructor(data?: IFieldModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isLink = _data["isLink"];
            this.dataType = _data["dataType"];
            this.format = _data["format"];
            this.visible = _data["visible"];
            this.width = _data["width"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): FieldModel {
        data = typeof data === 'object' ? data : {};
        let result = new FieldModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isLink"] = this.isLink;
        data["dataType"] = this.dataType;
        data["format"] = this.format;
        data["visible"] = this.visible;
        data["width"] = this.width;
        data["sortOrder"] = this.sortOrder;
        return data; 
    }
}

export interface IFieldModel {
    name?: string | undefined;
    displayName?: string | undefined;
    isLink?: boolean;
    dataType?: string | undefined;
    format?: string | undefined;
    visible?: boolean;
    width?: number;
    sortOrder?: number;
}

export class ToolbarItemModel implements IToolbarItemModel {
    name?: string | undefined;
    icon?: string | undefined;
    navigationUrl?: string | undefined;
    visible?: boolean;
    sortOrder?: number;

    constructor(data?: IToolbarItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.navigationUrl = _data["navigationUrl"];
            this.visible = _data["visible"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ToolbarItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new ToolbarItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["navigationUrl"] = this.navigationUrl;
        data["visible"] = this.visible;
        data["sortOrder"] = this.sortOrder;
        return data; 
    }
}

export interface IToolbarItemModel {
    name?: string | undefined;
    icon?: string | undefined;
    navigationUrl?: string | undefined;
    visible?: boolean;
    sortOrder?: number;
}

export class SystemReportViewModel implements ISystemReportViewModel {
    model?: SystemReportModel | undefined;
    optionsDataSources?: any | undefined;

    constructor(data?: ISystemReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? SystemReportModel.fromJS(_data["model"]) : <any>undefined;
            this.optionsDataSources = _data["optionsDataSources"];
        }
    }

    static fromJS(data: any): SystemReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        data["optionsDataSources"] = this.optionsDataSources;
        return data; 
    }
}

export interface ISystemReportViewModel {
    model?: SystemReportModel | undefined;
    optionsDataSources?: any | undefined;
}

export class BaseModel implements IBaseModel {
    systemNotifications?: NotificationModel[] | undefined;

    constructor(data?: IBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["systemNotifications"])) {
                this.systemNotifications = [] as any;
                for (let item of _data["systemNotifications"])
                    this.systemNotifications!.push(NotificationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.systemNotifications)) {
            data["systemNotifications"] = [];
            for (let item of this.systemNotifications)
                data["systemNotifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBaseModel {
    systemNotifications?: NotificationModel[] | undefined;
}

export class SystemReportModel extends BaseModel implements ISystemReportModel {
    id?: number;
    businessProfileId?: number | undefined;
    moduleId?: number;
    name?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    reportTypeId?: number;
    reportMapTypeId?: number | undefined;
    layout?: string | undefined;
    sampleReportJsonDataSource?: any | undefined;
    parameterOptionDataSourceUrl?: string | undefined;
    reportDataServiceUrl?: string | undefined;
    parentReportId?: number | undefined;
    isActive?: boolean;
    isDefault?: boolean;
    systemReportParams?: SystemReportParamModel[] | undefined;

    constructor(data?: ISystemReportModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.businessProfileId = _data["businessProfileId"];
            this.moduleId = _data["moduleId"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.reportTypeId = _data["reportTypeId"];
            this.reportMapTypeId = _data["reportMapTypeId"];
            this.layout = _data["layout"];
            this.sampleReportJsonDataSource = _data["sampleReportJsonDataSource"];
            this.parameterOptionDataSourceUrl = _data["parameterOptionDataSourceUrl"];
            this.reportDataServiceUrl = _data["reportDataServiceUrl"];
            this.parentReportId = _data["parentReportId"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
            if (Array.isArray(_data["systemReportParams"])) {
                this.systemReportParams = [] as any;
                for (let item of _data["systemReportParams"])
                    this.systemReportParams!.push(SystemReportParamModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SystemReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessProfileId"] = this.businessProfileId;
        data["moduleId"] = this.moduleId;
        data["name"] = this.name;
        data["title"] = this.title;
        data["description"] = this.description;
        data["reportTypeId"] = this.reportTypeId;
        data["reportMapTypeId"] = this.reportMapTypeId;
        data["layout"] = this.layout;
        data["sampleReportJsonDataSource"] = this.sampleReportJsonDataSource;
        data["parameterOptionDataSourceUrl"] = this.parameterOptionDataSourceUrl;
        data["reportDataServiceUrl"] = this.reportDataServiceUrl;
        data["parentReportId"] = this.parentReportId;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        if (Array.isArray(this.systemReportParams)) {
            data["systemReportParams"] = [];
            for (let item of this.systemReportParams)
                data["systemReportParams"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface ISystemReportModel extends IBaseModel {
    id?: number;
    businessProfileId?: number | undefined;
    moduleId?: number;
    name?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    reportTypeId?: number;
    reportMapTypeId?: number | undefined;
    layout?: string | undefined;
    sampleReportJsonDataSource?: any | undefined;
    parameterOptionDataSourceUrl?: string | undefined;
    reportDataServiceUrl?: string | undefined;
    parentReportId?: number | undefined;
    isActive?: boolean;
    isDefault?: boolean;
    systemReportParams?: SystemReportParamModel[] | undefined;
}

export class SystemReportParamModel extends BaseModel implements ISystemReportParamModel {
    id?: number;
    systemReportId?: number;
    name?: string | undefined;
    caption?: string | undefined;
    dataType?: string | undefined;
    editorType?: string | undefined;
    dataSource?: string | undefined;
    defaultValue?: string | undefined;
    isQueryParam?: boolean;
    isRequired?: boolean;
    isVisble?: boolean;

    constructor(data?: ISystemReportParamModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.systemReportId = _data["systemReportId"];
            this.name = _data["name"];
            this.caption = _data["caption"];
            this.dataType = _data["dataType"];
            this.editorType = _data["editorType"];
            this.dataSource = _data["dataSource"];
            this.defaultValue = _data["defaultValue"];
            this.isQueryParam = _data["isQueryParam"];
            this.isRequired = _data["isRequired"];
            this.isVisble = _data["isVisble"];
        }
    }

    static fromJS(data: any): SystemReportParamModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemReportParamModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["systemReportId"] = this.systemReportId;
        data["name"] = this.name;
        data["caption"] = this.caption;
        data["dataType"] = this.dataType;
        data["editorType"] = this.editorType;
        data["dataSource"] = this.dataSource;
        data["defaultValue"] = this.defaultValue;
        data["isQueryParam"] = this.isQueryParam;
        data["isRequired"] = this.isRequired;
        data["isVisble"] = this.isVisble;
        super.toJSON(data);
        return data; 
    }
}

export interface ISystemReportParamModel extends IBaseModel {
    id?: number;
    systemReportId?: number;
    name?: string | undefined;
    caption?: string | undefined;
    dataType?: string | undefined;
    editorType?: string | undefined;
    dataSource?: string | undefined;
    defaultValue?: string | undefined;
    isQueryParam?: boolean;
    isRequired?: boolean;
    isVisble?: boolean;
}

export class NotificationModel implements INotificationModel {
    userId?: string | undefined;
    title?: string | undefined;
    message?: string | undefined;
    type?: string | undefined;
    url?: string | undefined;
    data?: { [key: string]: string; } | undefined;
    sendToAll?: boolean;

    constructor(data?: INotificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.title = _data["title"];
            this.message = _data["message"];
            this.type = _data["type"];
            this.url = _data["url"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        this.data![key] = _data["data"][key];
                }
            }
            this.sendToAll = _data["sendToAll"];
        }
    }

    static fromJS(data: any): NotificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["title"] = this.title;
        data["message"] = this.message;
        data["type"] = this.type;
        data["url"] = this.url;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    data["data"][key] = this.data[key];
            }
        }
        data["sendToAll"] = this.sendToAll;
        return data; 
    }
}

export interface INotificationModel {
    userId?: string | undefined;
    title?: string | undefined;
    message?: string | undefined;
    type?: string | undefined;
    url?: string | undefined;
    data?: { [key: string]: string; } | undefined;
    sendToAll?: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        this.extensions![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    data["extensions"][key] = this.extensions[key];
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;
}

export class UpsertSystemReportCommand extends SystemReportModel implements IUpsertSystemReportCommand {

    constructor(data?: IUpsertSystemReportCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertSystemReportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertSystemReportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertSystemReportCommand extends ISystemReportModel {
}

export class ApplicationImageModel extends BaseModel implements IApplicationImageModel {
    id?: number;
    entity?: string | undefined;
    entityId?: string | undefined;
    folderName?: string | undefined;
    imageFileName?: string | undefined;
    originalFileName?: string | undefined;
    imagePath?: string | undefined;
    applicationBinaryFileModel?: ApplicationBinaryFileModel | undefined;

    constructor(data?: IApplicationImageModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.entity = _data["entity"];
            this.entityId = _data["entityId"];
            this.folderName = _data["folderName"];
            this.imageFileName = _data["imageFileName"];
            this.originalFileName = _data["originalFileName"];
            this.imagePath = _data["imagePath"];
            this.applicationBinaryFileModel = _data["applicationBinaryFileModel"] ? ApplicationBinaryFileModel.fromJS(_data["applicationBinaryFileModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationImageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationImageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entity"] = this.entity;
        data["entityId"] = this.entityId;
        data["folderName"] = this.folderName;
        data["imageFileName"] = this.imageFileName;
        data["originalFileName"] = this.originalFileName;
        data["imagePath"] = this.imagePath;
        data["applicationBinaryFileModel"] = this.applicationBinaryFileModel ? this.applicationBinaryFileModel.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IApplicationImageModel extends IBaseModel {
    id?: number;
    entity?: string | undefined;
    entityId?: string | undefined;
    folderName?: string | undefined;
    imageFileName?: string | undefined;
    originalFileName?: string | undefined;
    imagePath?: string | undefined;
    applicationBinaryFileModel?: ApplicationBinaryFileModel | undefined;
}

export class ApplicationBinaryFileModel implements IApplicationBinaryFileModel {
    id?: number;
    image?: string | undefined;

    constructor(data?: IApplicationBinaryFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): ApplicationBinaryFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationBinaryFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["image"] = this.image;
        return data; 
    }
}

export interface IApplicationBinaryFileModel {
    id?: number;
    image?: string | undefined;
}

export class ApplicationSettingsViewModel implements IApplicationSettingsViewModel {
    applicationName?: string | undefined;
    username?: string | undefined;
    profileImgPath?: string | undefined;
    menuItems?: MenuItemModel[] | undefined;
    roleName?: string | undefined;

    constructor(data?: IApplicationSettingsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.username = _data["username"];
            this.profileImgPath = _data["profileImgPath"];
            if (Array.isArray(_data["menuItems"])) {
                this.menuItems = [] as any;
                for (let item of _data["menuItems"])
                    this.menuItems!.push(MenuItemModel.fromJS(item));
            }
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): ApplicationSettingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationSettingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["username"] = this.username;
        data["profileImgPath"] = this.profileImgPath;
        if (Array.isArray(this.menuItems)) {
            data["menuItems"] = [];
            for (let item of this.menuItems)
                data["menuItems"].push(item.toJSON());
        }
        data["roleName"] = this.roleName;
        return data; 
    }
}

export interface IApplicationSettingsViewModel {
    applicationName?: string | undefined;
    username?: string | undefined;
    profileImgPath?: string | undefined;
    menuItems?: MenuItemModel[] | undefined;
    roleName?: string | undefined;
}

export class MenuItemModel implements IMenuItemModel {
    appMenuId?: number;
    parentId?: number | undefined;
    label?: string | undefined;
    icon?: string | undefined;
    url?: string | undefined;
    tooltip?: string | undefined;
    roleName?: string | undefined;
    items?: MenuItemModel[] | undefined;

    constructor(data?: IMenuItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appMenuId = _data["appMenuId"];
            this.parentId = _data["parentId"];
            this.label = _data["label"];
            this.icon = _data["icon"];
            this.url = _data["url"];
            this.tooltip = _data["tooltip"];
            this.roleName = _data["roleName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MenuItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MenuItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appMenuId"] = this.appMenuId;
        data["parentId"] = this.parentId;
        data["label"] = this.label;
        data["icon"] = this.icon;
        data["url"] = this.url;
        data["tooltip"] = this.tooltip;
        data["roleName"] = this.roleName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMenuItemModel {
    appMenuId?: number;
    parentId?: number | undefined;
    label?: string | undefined;
    icon?: string | undefined;
    url?: string | undefined;
    tooltip?: string | undefined;
    roleName?: string | undefined;
    items?: MenuItemModel[] | undefined;
}

export class AttributeViewModel implements IAttributeViewModel {
    model?: AttributeModel | undefined;
    attributeTypeSelectList?: SelectModel[] | undefined;

    constructor(data?: IAttributeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? AttributeModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["attributeTypeSelectList"])) {
                this.attributeTypeSelectList = [] as any;
                for (let item of _data["attributeTypeSelectList"])
                    this.attributeTypeSelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttributeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.attributeTypeSelectList)) {
            data["attributeTypeSelectList"] = [];
            for (let item of this.attributeTypeSelectList)
                data["attributeTypeSelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAttributeViewModel {
    model?: AttributeModel | undefined;
    attributeTypeSelectList?: SelectModel[] | undefined;
}

export class AttributeModel implements IAttributeModel {
    id?: number;
    name?: string | undefined;
    typeId?: number;
    isActive?: boolean;

    constructor(data?: IAttributeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AttributeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IAttributeModel {
    id?: number;
    name?: string | undefined;
    typeId?: number;
    isActive?: boolean;
}

export class SelectModel implements ISelectModel {
    id?: any | undefined;
    name?: string | undefined;
    isDefault?: boolean;
    valueOne?: any | undefined;
    valueTwo?: any | undefined;

    constructor(data?: ISelectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
            this.valueOne = _data["valueOne"];
            this.valueTwo = _data["valueTwo"];
        }
    }

    static fromJS(data: any): SelectModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["valueOne"] = this.valueOne;
        data["valueTwo"] = this.valueTwo;
        return data; 
    }
}

export interface ISelectModel {
    id?: any | undefined;
    name?: string | undefined;
    isDefault?: boolean;
    valueOne?: any | undefined;
    valueTwo?: any | undefined;
}

export class UpsertAttributeCommand extends AttributeModel implements IUpsertAttributeCommand {

    constructor(data?: IUpsertAttributeCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertAttributeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertAttributeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertAttributeCommand extends IAttributeModel {
}

export class BusinessProfileModel extends BaseModel implements IBusinessProfileModel {
    id?: number;
    name?: string | undefined;
    address?: string | undefined;
    description?: string | undefined;
    cms?: string | undefined;
    logo?: string | undefined;
    imagePath?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    web?: string | undefined;
    primaryContactPerson?: string | undefined;
    primaryContactNumber?: string | undefined;

    constructor(data?: IBusinessProfileModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.description = _data["description"];
            this.cms = _data["cms"];
            this.logo = _data["logo"];
            this.imagePath = _data["imagePath"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.web = _data["web"];
            this.primaryContactPerson = _data["primaryContactPerson"];
            this.primaryContactNumber = _data["primaryContactNumber"];
        }
    }

    static fromJS(data: any): BusinessProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["description"] = this.description;
        data["cms"] = this.cms;
        data["logo"] = this.logo;
        data["imagePath"] = this.imagePath;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["web"] = this.web;
        data["primaryContactPerson"] = this.primaryContactPerson;
        data["primaryContactNumber"] = this.primaryContactNumber;
        super.toJSON(data);
        return data; 
    }
}

export interface IBusinessProfileModel extends IBaseModel {
    id?: number;
    name?: string | undefined;
    address?: string | undefined;
    description?: string | undefined;
    cms?: string | undefined;
    logo?: string | undefined;
    imagePath?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    web?: string | undefined;
    primaryContactPerson?: string | undefined;
    primaryContactNumber?: string | undefined;
}

export class UpsertBusinessProfileCommand extends BusinessProfileModel implements IUpsertBusinessProfileCommand {

    constructor(data?: IUpsertBusinessProfileCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertBusinessProfileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertBusinessProfileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertBusinessProfileCommand extends IBusinessProfileModel {
}

export class KitchenStockModel implements IKitchenStockModel {
    storeId?: number;
    stockItemId?: number;
    stockItem?: string | undefined;
    storeName?: string | undefined;
    currentStock?: number;
    primaryStore?: boolean;
    kitchenStockQuantity?: number;

    constructor(data?: IKitchenStockModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.stockItemId = _data["stockItemId"];
            this.stockItem = _data["stockItem"];
            this.storeName = _data["storeName"];
            this.currentStock = _data["currentStock"];
            this.primaryStore = _data["primaryStore"];
            this.kitchenStockQuantity = _data["kitchenStockQuantity"];
        }
    }

    static fromJS(data: any): KitchenStockModel {
        data = typeof data === 'object' ? data : {};
        let result = new KitchenStockModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["stockItemId"] = this.stockItemId;
        data["stockItem"] = this.stockItem;
        data["storeName"] = this.storeName;
        data["currentStock"] = this.currentStock;
        data["primaryStore"] = this.primaryStore;
        data["kitchenStockQuantity"] = this.kitchenStockQuantity;
        return data; 
    }
}

export interface IKitchenStockModel {
    storeId?: number;
    stockItemId?: number;
    stockItem?: string | undefined;
    storeName?: string | undefined;
    currentStock?: number;
    primaryStore?: boolean;
    kitchenStockQuantity?: number;
}

export class BarStockModel implements IBarStockModel {
    storeId?: number;
    stockItemId?: number;
    stockItem?: string | undefined;
    storeName?: string | undefined;
    currentStock?: number;
    primaryStore?: boolean;
    barStockQuantity?: number;

    constructor(data?: IBarStockModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.stockItemId = _data["stockItemId"];
            this.stockItem = _data["stockItem"];
            this.storeName = _data["storeName"];
            this.currentStock = _data["currentStock"];
            this.primaryStore = _data["primaryStore"];
            this.barStockQuantity = _data["barStockQuantity"];
        }
    }

    static fromJS(data: any): BarStockModel {
        data = typeof data === 'object' ? data : {};
        let result = new BarStockModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["stockItemId"] = this.stockItemId;
        data["stockItem"] = this.stockItem;
        data["storeName"] = this.storeName;
        data["currentStock"] = this.currentStock;
        data["primaryStore"] = this.primaryStore;
        data["barStockQuantity"] = this.barStockQuantity;
        return data; 
    }
}

export interface IBarStockModel {
    storeId?: number;
    stockItemId?: number;
    stockItem?: string | undefined;
    storeName?: string | undefined;
    currentStock?: number;
    primaryStore?: boolean;
    barStockQuantity?: number;
}

export class RHeaders implements IRHeaders {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IRHeaders) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RHeaders {
        data = typeof data === 'object' ? data : {};
        let result = new RHeaders();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data; 
    }
}

export interface IRHeaders {
    key?: string | undefined;
    value?: string | undefined;
}

export abstract class IHeaderDictionary implements IIHeaderDictionary {
    item?: string[];
    contentLength?: number | undefined;

    constructor(data?: IIHeaderDictionary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Item"])) {
                this.item = [] as any;
                for (let item of _data["Item"])
                    this.item!.push(item);
            }
            this.contentLength = _data["ContentLength"];
        }
    }

    static fromJS(data: any): IHeaderDictionary {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IHeaderDictionary' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.item)) {
            data["Item"] = [];
            for (let item of this.item)
                data["Item"].push(item);
        }
        data["ContentLength"] = this.contentLength;
        return data; 
    }
}

export interface IIHeaderDictionary {
    item?: string[];
    contentLength?: number | undefined;
}

export class TokenResponseModel implements ITokenResponseModel {
    accessToken?: string | undefined;
    identityToken?: string | undefined;
    tokenType?: string | undefined;
    refreshToken?: string | undefined;
    errorDescription?: string | undefined;
    expiresIn?: number;

    constructor(data?: ITokenResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.identityToken = _data["identityToken"];
            this.tokenType = _data["tokenType"];
            this.refreshToken = _data["refreshToken"];
            this.errorDescription = _data["errorDescription"];
            this.expiresIn = _data["expiresIn"];
        }
    }

    static fromJS(data: any): TokenResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["identityToken"] = this.identityToken;
        data["tokenType"] = this.tokenType;
        data["refreshToken"] = this.refreshToken;
        data["errorDescription"] = this.errorDescription;
        data["expiresIn"] = this.expiresIn;
        return data; 
    }
}

export interface ITokenResponseModel {
    accessToken?: string | undefined;
    identityToken?: string | undefined;
    tokenType?: string | undefined;
    refreshToken?: string | undefined;
    errorDescription?: string | undefined;
    expiresIn?: number;
}

export class LoginModel implements ILoginModel {
    username?: string | undefined;
    password?: string | undefined;
    deviceToken?: string | undefined;

    constructor(data?: ILoginModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.deviceToken = _data["deviceToken"];
        }
    }

    static fromJS(data: any): LoginModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["deviceToken"] = this.deviceToken;
        return data; 
    }
}

export interface ILoginModel {
    username?: string | undefined;
    password?: string | undefined;
    deviceToken?: string | undefined;
}

export class UserTokenResponseModel extends TokenResponseModel implements IUserTokenResponseModel {
    userId?: string | undefined;
    username?: string | undefined;
    displayName?: string | undefined;
    designation?: string | undefined;
    profileImage?: string | undefined;
    maximumConcurrentOrders?: number;

    constructor(data?: IUserTokenResponseModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.displayName = _data["displayName"];
            this.designation = _data["designation"];
            this.profileImage = _data["profileImage"];
            this.maximumConcurrentOrders = _data["maximumConcurrentOrders"];
        }
    }

    static fromJS(data: any): UserTokenResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserTokenResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["displayName"] = this.displayName;
        data["designation"] = this.designation;
        data["profileImage"] = this.profileImage;
        data["maximumConcurrentOrders"] = this.maximumConcurrentOrders;
        super.toJSON(data);
        return data; 
    }
}

export interface IUserTokenResponseModel extends ITokenResponseModel {
    userId?: string | undefined;
    username?: string | undefined;
    displayName?: string | undefined;
    designation?: string | undefined;
    profileImage?: string | undefined;
    maximumConcurrentOrders?: number;
}

export class MemberCardModel extends BaseModel implements IMemberCardModel {
    id?: number;
    memberId?: number;
    memberName?: string | undefined;
    cardNumber?: string | undefined;
    accountNumber?: string | undefined;
    issueDate?: Date;
    expireDate?: Date;
    pinEnvelopeNumber?: string | undefined;
    rfId?: string | undefined;
    activePinId?: number;
    statusId?: number;
    pinResetRequest?: boolean | undefined;
    qrCode?: string | undefined;
    qrCardNumber?: string | undefined;
    profileImg?: string | undefined;

    constructor(data?: IMemberCardModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.memberName = _data["memberName"];
            this.cardNumber = _data["cardNumber"];
            this.accountNumber = _data["accountNumber"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? new Date(_data["expireDate"].toString()) : <any>undefined;
            this.pinEnvelopeNumber = _data["pinEnvelopeNumber"];
            this.rfId = _data["rfId"];
            this.activePinId = _data["activePinId"];
            this.statusId = _data["statusId"];
            this.pinResetRequest = _data["pinResetRequest"];
            this.qrCode = _data["qrCode"];
            this.qrCardNumber = _data["qrCardNumber"];
            this.profileImg = _data["profileImg"];
        }
    }

    static fromJS(data: any): MemberCardModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberCardModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["memberName"] = this.memberName;
        data["cardNumber"] = this.cardNumber;
        data["accountNumber"] = this.accountNumber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["pinEnvelopeNumber"] = this.pinEnvelopeNumber;
        data["rfId"] = this.rfId;
        data["activePinId"] = this.activePinId;
        data["statusId"] = this.statusId;
        data["pinResetRequest"] = this.pinResetRequest;
        data["qrCode"] = this.qrCode;
        data["qrCardNumber"] = this.qrCardNumber;
        data["profileImg"] = this.profileImg;
        super.toJSON(data);
        return data; 
    }
}

export interface IMemberCardModel extends IBaseModel {
    id?: number;
    memberId?: number;
    memberName?: string | undefined;
    cardNumber?: string | undefined;
    accountNumber?: string | undefined;
    issueDate?: Date;
    expireDate?: Date;
    pinEnvelopeNumber?: string | undefined;
    rfId?: string | undefined;
    activePinId?: number;
    statusId?: number;
    pinResetRequest?: boolean | undefined;
    qrCode?: string | undefined;
    qrCardNumber?: string | undefined;
    profileImg?: string | undefined;
}

export class PinChangeRequestModel implements IPinChangeRequestModel {
    cardId?: number;

    constructor(data?: IPinChangeRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
        }
    }

    static fromJS(data: any): PinChangeRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PinChangeRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        return data; 
    }
}

export interface IPinChangeRequestModel {
    cardId?: number;
}

export class MemberModel extends BaseModel implements IMemberModel {
    id?: number;
    membershipTypeId?: number;
    referenceMemberId?: number | undefined;
    isAccompaniedMember?: boolean;
    memberCode?: string | undefined;
    refMemberCode?: string | undefined;
    accountNumber?: string | undefined;
    title?: string | undefined;
    forename?: string | undefined;
    surname?: string | undefined;
    gender?: string | undefined;
    birthDate?: Date | undefined;
    nationality?: string | undefined;
    email?: string | undefined;
    mobileNumber?: string | undefined;
    passportNumber?: string | undefined;
    residentialAddress?: string | undefined;
    organizationName?: string | undefined;
    workAddress?: string | undefined;
    workNumber?: string | undefined;
    isPrevoiusTempMember?: boolean;
    expatClubName?: string | undefined;
    activeCardId?: number | undefined;
    approvedBy?: string | undefined;
    nickName?: string | undefined;
    academicBackground?: string | undefined;
    occupation?: string | undefined;
    nid?: string | undefined;
    mr?: string | undefined;
    bloodGroupId?: number | undefined;
    bloodGroupName?: string | undefined;
    joiningDate?: Date | undefined;
    approvedDate?: Date | undefined;
    membershipExpireDate?: Date | undefined;
    profileImagePath?: string | undefined;
    debentureAmount?: number;
    overdraft?: number;
    creditLimit?: number;
    currentBalance?: number;
    totalContributingPoints?: number | undefined;
    monthlyContributingPoints?: number | undefined;
    profilePictureId?: number | undefined;
    isActive?: boolean;
    partner?: MemberModel | undefined;
    children?: MemberModel[] | undefined;
    gymRate?: number;
    poolRate?: number;
    cardNo?: string | undefined;
    membershipTypeName?: string | undefined;
    memberCategory?: string | undefined;
    cardStatus?: string | undefined;
    tennisToken?: string | undefined;
    mainMemberCode?: string | undefined;

    constructor(data?: IMemberModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.membershipTypeId = _data["membershipTypeId"];
            this.referenceMemberId = _data["referenceMemberId"];
            this.isAccompaniedMember = _data["isAccompaniedMember"];
            this.memberCode = _data["memberCode"];
            this.refMemberCode = _data["refMemberCode"];
            this.accountNumber = _data["accountNumber"];
            this.title = _data["title"];
            this.forename = _data["forename"];
            this.surname = _data["surname"];
            this.gender = _data["gender"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.nationality = _data["nationality"];
            this.email = _data["email"];
            this.mobileNumber = _data["mobileNumber"];
            this.passportNumber = _data["passportNumber"];
            this.residentialAddress = _data["residentialAddress"];
            this.organizationName = _data["organizationName"];
            this.workAddress = _data["workAddress"];
            this.workNumber = _data["workNumber"];
            this.isPrevoiusTempMember = _data["isPrevoiusTempMember"];
            this.expatClubName = _data["expatClubName"];
            this.activeCardId = _data["activeCardId"];
            this.approvedBy = _data["approvedBy"];
            this.nickName = _data["nickName"];
            this.academicBackground = _data["academicBackground"];
            this.occupation = _data["occupation"];
            this.nid = _data["nid"];
            this.mr = _data["mr"];
            this.bloodGroupId = _data["bloodGroupId"];
            this.bloodGroupName = _data["bloodGroupName"];
            this.joiningDate = _data["joiningDate"] ? new Date(_data["joiningDate"].toString()) : <any>undefined;
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : <any>undefined;
            this.membershipExpireDate = _data["membershipExpireDate"] ? new Date(_data["membershipExpireDate"].toString()) : <any>undefined;
            this.profileImagePath = _data["profileImagePath"];
            this.debentureAmount = _data["debentureAmount"];
            this.overdraft = _data["overdraft"];
            this.creditLimit = _data["creditLimit"];
            this.currentBalance = _data["currentBalance"];
            this.totalContributingPoints = _data["totalContributingPoints"];
            this.monthlyContributingPoints = _data["monthlyContributingPoints"];
            this.profilePictureId = _data["profilePictureId"];
            this.isActive = _data["isActive"];
            this.partner = _data["partner"] ? MemberModel.fromJS(_data["partner"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(MemberModel.fromJS(item));
            }
            this.gymRate = _data["gymRate"];
            this.poolRate = _data["poolRate"];
            this.cardNo = _data["cardNo"];
            this.membershipTypeName = _data["membershipTypeName"];
            this.memberCategory = _data["memberCategory"];
            this.cardStatus = _data["cardStatus"];
            this.tennisToken = _data["tennisToken"];
            this.mainMemberCode = _data["mainMemberCode"];
        }
    }

    static fromJS(data: any): MemberModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["membershipTypeId"] = this.membershipTypeId;
        data["referenceMemberId"] = this.referenceMemberId;
        data["isAccompaniedMember"] = this.isAccompaniedMember;
        data["memberCode"] = this.memberCode;
        data["refMemberCode"] = this.refMemberCode;
        data["accountNumber"] = this.accountNumber;
        data["title"] = this.title;
        data["forename"] = this.forename;
        data["surname"] = this.surname;
        data["gender"] = this.gender;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["nationality"] = this.nationality;
        data["email"] = this.email;
        data["mobileNumber"] = this.mobileNumber;
        data["passportNumber"] = this.passportNumber;
        data["residentialAddress"] = this.residentialAddress;
        data["organizationName"] = this.organizationName;
        data["workAddress"] = this.workAddress;
        data["workNumber"] = this.workNumber;
        data["isPrevoiusTempMember"] = this.isPrevoiusTempMember;
        data["expatClubName"] = this.expatClubName;
        data["activeCardId"] = this.activeCardId;
        data["approvedBy"] = this.approvedBy;
        data["nickName"] = this.nickName;
        data["academicBackground"] = this.academicBackground;
        data["occupation"] = this.occupation;
        data["nid"] = this.nid;
        data["mr"] = this.mr;
        data["bloodGroupId"] = this.bloodGroupId;
        data["bloodGroupName"] = this.bloodGroupName;
        data["joiningDate"] = this.joiningDate ? this.joiningDate.toISOString() : <any>undefined;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["membershipExpireDate"] = this.membershipExpireDate ? this.membershipExpireDate.toISOString() : <any>undefined;
        data["profileImagePath"] = this.profileImagePath;
        data["debentureAmount"] = this.debentureAmount;
        data["overdraft"] = this.overdraft;
        data["creditLimit"] = this.creditLimit;
        data["currentBalance"] = this.currentBalance;
        data["totalContributingPoints"] = this.totalContributingPoints;
        data["monthlyContributingPoints"] = this.monthlyContributingPoints;
        data["profilePictureId"] = this.profilePictureId;
        data["isActive"] = this.isActive;
        data["partner"] = this.partner ? this.partner.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["gymRate"] = this.gymRate;
        data["poolRate"] = this.poolRate;
        data["cardNo"] = this.cardNo;
        data["membershipTypeName"] = this.membershipTypeName;
        data["memberCategory"] = this.memberCategory;
        data["cardStatus"] = this.cardStatus;
        data["tennisToken"] = this.tennisToken;
        data["mainMemberCode"] = this.mainMemberCode;
        super.toJSON(data);
        return data; 
    }
}

export interface IMemberModel extends IBaseModel {
    id?: number;
    membershipTypeId?: number;
    referenceMemberId?: number | undefined;
    isAccompaniedMember?: boolean;
    memberCode?: string | undefined;
    refMemberCode?: string | undefined;
    accountNumber?: string | undefined;
    title?: string | undefined;
    forename?: string | undefined;
    surname?: string | undefined;
    gender?: string | undefined;
    birthDate?: Date | undefined;
    nationality?: string | undefined;
    email?: string | undefined;
    mobileNumber?: string | undefined;
    passportNumber?: string | undefined;
    residentialAddress?: string | undefined;
    organizationName?: string | undefined;
    workAddress?: string | undefined;
    workNumber?: string | undefined;
    isPrevoiusTempMember?: boolean;
    expatClubName?: string | undefined;
    activeCardId?: number | undefined;
    approvedBy?: string | undefined;
    nickName?: string | undefined;
    academicBackground?: string | undefined;
    occupation?: string | undefined;
    nid?: string | undefined;
    mr?: string | undefined;
    bloodGroupId?: number | undefined;
    bloodGroupName?: string | undefined;
    joiningDate?: Date | undefined;
    approvedDate?: Date | undefined;
    membershipExpireDate?: Date | undefined;
    profileImagePath?: string | undefined;
    debentureAmount?: number;
    overdraft?: number;
    creditLimit?: number;
    currentBalance?: number;
    totalContributingPoints?: number | undefined;
    monthlyContributingPoints?: number | undefined;
    profilePictureId?: number | undefined;
    isActive?: boolean;
    partner?: MemberModel | undefined;
    children?: MemberModel[] | undefined;
    gymRate?: number;
    poolRate?: number;
    cardNo?: string | undefined;
    membershipTypeName?: string | undefined;
    memberCategory?: string | undefined;
    cardStatus?: string | undefined;
    tennisToken?: string | undefined;
    mainMemberCode?: string | undefined;
}

export class TipsoiLogModel extends BaseModel implements ITipsoiLogModel {
    id?: number;
    memberId?: number | undefined;
    inTime?: Date | undefined;
    enterTypeId?: number | undefined;

    constructor(data?: ITipsoiLogModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.enterTypeId = _data["enterTypeId"];
        }
    }

    static fromJS(data: any): TipsoiLogModel {
        data = typeof data === 'object' ? data : {};
        let result = new TipsoiLogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["enterTypeId"] = this.enterTypeId;
        super.toJSON(data);
        return data; 
    }
}

export interface ITipsoiLogModel extends IBaseModel {
    id?: number;
    memberId?: number | undefined;
    inTime?: Date | undefined;
    enterTypeId?: number | undefined;
}

export class TipsoiLogUpsertCommand extends TipsoiLogModel implements ITipsoiLogUpsertCommand {

    constructor(data?: ITipsoiLogUpsertCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TipsoiLogUpsertCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TipsoiLogUpsertCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface ITipsoiLogUpsertCommand extends ITipsoiLogModel {
}

export class TennisBookingStolModel implements ITennisBookingStolModel {
    id?: number;
    name?: string | undefined;
    booked?: boolean;
    forename?: string | undefined;
    surname?: string | undefined;
    memberCode?: string | undefined;
    tennisToken?: string | undefined;
    tennisFeeSettingId?: number;
    childrenCourtFee?: number;
    holidayCourtFee?: number;
    markersFee?: number;
    noShowCharge?: number;
    openLadiesTennisHourCourtFee?: number;
    openTennisHourCourtFee?: number;
    regularCourtFee?: number;
    tennisRacketRent?: number;

    constructor(data?: ITennisBookingStolModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.booked = _data["booked"];
            this.forename = _data["forename"];
            this.surname = _data["surname"];
            this.memberCode = _data["memberCode"];
            this.tennisToken = _data["tennisToken"];
            this.tennisFeeSettingId = _data["tennisFeeSettingId"];
            this.childrenCourtFee = _data["childrenCourtFee"];
            this.holidayCourtFee = _data["holidayCourtFee"];
            this.markersFee = _data["markersFee"];
            this.noShowCharge = _data["noShowCharge"];
            this.openLadiesTennisHourCourtFee = _data["openLadiesTennisHourCourtFee"];
            this.openTennisHourCourtFee = _data["openTennisHourCourtFee"];
            this.regularCourtFee = _data["regularCourtFee"];
            this.tennisRacketRent = _data["tennisRacketRent"];
        }
    }

    static fromJS(data: any): TennisBookingStolModel {
        data = typeof data === 'object' ? data : {};
        let result = new TennisBookingStolModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["booked"] = this.booked;
        data["forename"] = this.forename;
        data["surname"] = this.surname;
        data["memberCode"] = this.memberCode;
        data["tennisToken"] = this.tennisToken;
        data["tennisFeeSettingId"] = this.tennisFeeSettingId;
        data["childrenCourtFee"] = this.childrenCourtFee;
        data["holidayCourtFee"] = this.holidayCourtFee;
        data["markersFee"] = this.markersFee;
        data["noShowCharge"] = this.noShowCharge;
        data["openLadiesTennisHourCourtFee"] = this.openLadiesTennisHourCourtFee;
        data["openTennisHourCourtFee"] = this.openTennisHourCourtFee;
        data["regularCourtFee"] = this.regularCourtFee;
        data["tennisRacketRent"] = this.tennisRacketRent;
        return data; 
    }
}

export interface ITennisBookingStolModel {
    id?: number;
    name?: string | undefined;
    booked?: boolean;
    forename?: string | undefined;
    surname?: string | undefined;
    memberCode?: string | undefined;
    tennisToken?: string | undefined;
    tennisFeeSettingId?: number;
    childrenCourtFee?: number;
    holidayCourtFee?: number;
    markersFee?: number;
    noShowCharge?: number;
    openLadiesTennisHourCourtFee?: number;
    openTennisHourCourtFee?: number;
    regularCourtFee?: number;
    tennisRacketRent?: number;
}

export class TennisSlotBookingModel extends BaseModel implements ITennisSlotBookingModel {
    id?: number;
    memberId?: number;
    bookedFor?: number;
    isBookedForChildren?: boolean;
    isBookedForMarker?: boolean;
    isBookedForRacket?: boolean;
    isBookedForNoShow?: boolean;
    isBookedForHoliday?: boolean;
    isBookedForLadies?: boolean;
    bookingDate?: Date;
    courtId?: number;
    slotId?: number;
    courtFee?: number;
    markersFee?: number;
    racketRentalCount?: number;
    racketRentalCharge?: number;
    noShowCharge?: number;
    totalCharge?: number;
    statusId?: number;
    isSlotTimeOver?: boolean;

    constructor(data?: ITennisSlotBookingModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.bookedFor = _data["bookedFor"];
            this.isBookedForChildren = _data["isBookedForChildren"];
            this.isBookedForMarker = _data["isBookedForMarker"];
            this.isBookedForRacket = _data["isBookedForRacket"];
            this.isBookedForNoShow = _data["isBookedForNoShow"];
            this.isBookedForHoliday = _data["isBookedForHoliday"];
            this.isBookedForLadies = _data["isBookedForLadies"];
            this.bookingDate = _data["bookingDate"] ? new Date(_data["bookingDate"].toString()) : <any>undefined;
            this.courtId = _data["courtId"];
            this.slotId = _data["slotId"];
            this.courtFee = _data["courtFee"];
            this.markersFee = _data["markersFee"];
            this.racketRentalCount = _data["racketRentalCount"];
            this.racketRentalCharge = _data["racketRentalCharge"];
            this.noShowCharge = _data["noShowCharge"];
            this.totalCharge = _data["totalCharge"];
            this.statusId = _data["statusId"];
            this.isSlotTimeOver = _data["isSlotTimeOver"];
        }
    }

    static fromJS(data: any): TennisSlotBookingModel {
        data = typeof data === 'object' ? data : {};
        let result = new TennisSlotBookingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["bookedFor"] = this.bookedFor;
        data["isBookedForChildren"] = this.isBookedForChildren;
        data["isBookedForMarker"] = this.isBookedForMarker;
        data["isBookedForRacket"] = this.isBookedForRacket;
        data["isBookedForNoShow"] = this.isBookedForNoShow;
        data["isBookedForHoliday"] = this.isBookedForHoliday;
        data["isBookedForLadies"] = this.isBookedForLadies;
        data["bookingDate"] = this.bookingDate ? this.bookingDate.toISOString() : <any>undefined;
        data["courtId"] = this.courtId;
        data["slotId"] = this.slotId;
        data["courtFee"] = this.courtFee;
        data["markersFee"] = this.markersFee;
        data["racketRentalCount"] = this.racketRentalCount;
        data["racketRentalCharge"] = this.racketRentalCharge;
        data["noShowCharge"] = this.noShowCharge;
        data["totalCharge"] = this.totalCharge;
        data["statusId"] = this.statusId;
        data["isSlotTimeOver"] = this.isSlotTimeOver;
        super.toJSON(data);
        return data; 
    }
}

export interface ITennisSlotBookingModel extends IBaseModel {
    id?: number;
    memberId?: number;
    bookedFor?: number;
    isBookedForChildren?: boolean;
    isBookedForMarker?: boolean;
    isBookedForRacket?: boolean;
    isBookedForNoShow?: boolean;
    isBookedForHoliday?: boolean;
    isBookedForLadies?: boolean;
    bookingDate?: Date;
    courtId?: number;
    slotId?: number;
    courtFee?: number;
    markersFee?: number;
    racketRentalCount?: number;
    racketRentalCharge?: number;
    noShowCharge?: number;
    totalCharge?: number;
    statusId?: number;
    isSlotTimeOver?: boolean;
}

export class UpsertTennisSlotBookingCommand extends TennisSlotBookingModel implements IUpsertTennisSlotBookingCommand {

    constructor(data?: IUpsertTennisSlotBookingCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertTennisSlotBookingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertTennisSlotBookingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertTennisSlotBookingCommand extends ITennisSlotBookingModel {
}

export class TennisSlotBookingModelForDevice implements ITennisSlotBookingModelForDevice {
    id?: number;
    name?: string | undefined;
    booked?: boolean;
    forename?: string | undefined;
    surname?: string | undefined;
    memberCode?: string | undefined;
    tennisToken?: string | undefined;
    isBookedForChildren?: boolean;
    isBookedForMarker?: boolean;
    isBookedForRacket?: boolean;
    isBookedForNoShow?: boolean;
    isBookedForHoliday?: boolean;
    isBookedForLadies?: boolean;
    bookingDate?: Date;
    courtFee?: number;
    markersFee?: number;
    racketRentalCount?: number;
    racketRentalCharge?: number;
    noShowCharge?: number;
    totalCharge?: number;
    statusId?: number;
    isSlotTimeOver?: boolean;

    constructor(data?: ITennisSlotBookingModelForDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.booked = _data["booked"];
            this.forename = _data["forename"];
            this.surname = _data["surname"];
            this.memberCode = _data["memberCode"];
            this.tennisToken = _data["tennisToken"];
            this.isBookedForChildren = _data["isBookedForChildren"];
            this.isBookedForMarker = _data["isBookedForMarker"];
            this.isBookedForRacket = _data["isBookedForRacket"];
            this.isBookedForNoShow = _data["isBookedForNoShow"];
            this.isBookedForHoliday = _data["isBookedForHoliday"];
            this.isBookedForLadies = _data["isBookedForLadies"];
            this.bookingDate = _data["bookingDate"] ? new Date(_data["bookingDate"].toString()) : <any>undefined;
            this.courtFee = _data["courtFee"];
            this.markersFee = _data["markersFee"];
            this.racketRentalCount = _data["racketRentalCount"];
            this.racketRentalCharge = _data["racketRentalCharge"];
            this.noShowCharge = _data["noShowCharge"];
            this.totalCharge = _data["totalCharge"];
            this.statusId = _data["statusId"];
            this.isSlotTimeOver = _data["isSlotTimeOver"];
        }
    }

    static fromJS(data: any): TennisSlotBookingModelForDevice {
        data = typeof data === 'object' ? data : {};
        let result = new TennisSlotBookingModelForDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["booked"] = this.booked;
        data["forename"] = this.forename;
        data["surname"] = this.surname;
        data["memberCode"] = this.memberCode;
        data["tennisToken"] = this.tennisToken;
        data["isBookedForChildren"] = this.isBookedForChildren;
        data["isBookedForMarker"] = this.isBookedForMarker;
        data["isBookedForRacket"] = this.isBookedForRacket;
        data["isBookedForNoShow"] = this.isBookedForNoShow;
        data["isBookedForHoliday"] = this.isBookedForHoliday;
        data["isBookedForLadies"] = this.isBookedForLadies;
        data["bookingDate"] = this.bookingDate ? this.bookingDate.toISOString() : <any>undefined;
        data["courtFee"] = this.courtFee;
        data["markersFee"] = this.markersFee;
        data["racketRentalCount"] = this.racketRentalCount;
        data["racketRentalCharge"] = this.racketRentalCharge;
        data["noShowCharge"] = this.noShowCharge;
        data["totalCharge"] = this.totalCharge;
        data["statusId"] = this.statusId;
        data["isSlotTimeOver"] = this.isSlotTimeOver;
        return data; 
    }
}

export interface ITennisSlotBookingModelForDevice {
    id?: number;
    name?: string | undefined;
    booked?: boolean;
    forename?: string | undefined;
    surname?: string | undefined;
    memberCode?: string | undefined;
    tennisToken?: string | undefined;
    isBookedForChildren?: boolean;
    isBookedForMarker?: boolean;
    isBookedForRacket?: boolean;
    isBookedForNoShow?: boolean;
    isBookedForHoliday?: boolean;
    isBookedForLadies?: boolean;
    bookingDate?: Date;
    courtFee?: number;
    markersFee?: number;
    racketRentalCount?: number;
    racketRentalCharge?: number;
    noShowCharge?: number;
    totalCharge?: number;
    statusId?: number;
    isSlotTimeOver?: boolean;
}

export class VerifyMemberModel implements IVerifyMemberModel {
    cardId?: number;
    pin?: string | undefined;

    constructor(data?: IVerifyMemberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardId = _data["cardId"];
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any): VerifyMemberModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyMemberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardId"] = this.cardId;
        data["pin"] = this.pin;
        return data; 
    }
}

export interface IVerifyMemberModel {
    cardId?: number;
    pin?: string | undefined;
}

export class VerifyMemberPin extends VerifyMemberModel implements IVerifyMemberPin {

    constructor(data?: IVerifyMemberPin) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): VerifyMemberPin {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyMemberPin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IVerifyMemberPin extends IVerifyMemberModel {
}

export class MemberCardBalanceModel implements IMemberCardBalanceModel {
    currentBalance?: number;
    availableBalace?: number;

    constructor(data?: IMemberCardBalanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentBalance = _data["currentBalance"];
            this.availableBalace = _data["availableBalace"];
        }
    }

    static fromJS(data: any): MemberCardBalanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberCardBalanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentBalance"] = this.currentBalance;
        data["availableBalace"] = this.availableBalace;
        return data; 
    }
}

export interface IMemberCardBalanceModel {
    currentBalance?: number;
    availableBalace?: number;
}

export class UserActivitySummaryModel implements IUserActivitySummaryModel {
    todaysCollection?: number;
    pendingOrder?: number;
    completedOrder?: number;

    constructor(data?: IUserActivitySummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.todaysCollection = _data["todaysCollection"];
            this.pendingOrder = _data["pendingOrder"];
            this.completedOrder = _data["completedOrder"];
        }
    }

    static fromJS(data: any): UserActivitySummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserActivitySummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["todaysCollection"] = this.todaysCollection;
        data["pendingOrder"] = this.pendingOrder;
        data["completedOrder"] = this.completedOrder;
        return data; 
    }
}

export interface IUserActivitySummaryModel {
    todaysCollection?: number;
    pendingOrder?: number;
    completedOrder?: number;
}

export class MemberTransactionModel extends BaseModel implements IMemberTransactionModel {
    id?: number;
    memberId?: number;
    memberShiptypeId?: number;
    paymentTypeId?: number;
    cardId?: number;
    transactionTypeId?: number;
    transactionAmount?: number;
    transactionDescription?: string | undefined;
    lastFourDigit?: number | undefined;
    posBank?: string | undefined;
    bankName?: string | undefined;
    chequeNo?: string | undefined;
    chequeDate?: Date | undefined;
    createdDateTime?: Date;
    transactionDate?: Date | undefined;
    orderId?: number | undefined;

    constructor(data?: IMemberTransactionModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.memberShiptypeId = _data["memberShiptypeId"];
            this.paymentTypeId = _data["paymentTypeId"];
            this.cardId = _data["cardId"];
            this.transactionTypeId = _data["transactionTypeId"];
            this.transactionAmount = _data["transactionAmount"];
            this.transactionDescription = _data["transactionDescription"];
            this.lastFourDigit = _data["lastFourDigit"];
            this.posBank = _data["posBank"];
            this.bankName = _data["bankName"];
            this.chequeNo = _data["chequeNo"];
            this.chequeDate = _data["chequeDate"] ? new Date(_data["chequeDate"].toString()) : <any>undefined;
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): MemberTransactionModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberTransactionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["memberShiptypeId"] = this.memberShiptypeId;
        data["paymentTypeId"] = this.paymentTypeId;
        data["cardId"] = this.cardId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["transactionAmount"] = this.transactionAmount;
        data["transactionDescription"] = this.transactionDescription;
        data["lastFourDigit"] = this.lastFourDigit;
        data["posBank"] = this.posBank;
        data["bankName"] = this.bankName;
        data["chequeNo"] = this.chequeNo;
        data["chequeDate"] = this.chequeDate ? this.chequeDate.toISOString() : <any>undefined;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["orderId"] = this.orderId;
        super.toJSON(data);
        return data; 
    }
}

export interface IMemberTransactionModel extends IBaseModel {
    id?: number;
    memberId?: number;
    memberShiptypeId?: number;
    paymentTypeId?: number;
    cardId?: number;
    transactionTypeId?: number;
    transactionAmount?: number;
    transactionDescription?: string | undefined;
    lastFourDigit?: number | undefined;
    posBank?: string | undefined;
    bankName?: string | undefined;
    chequeNo?: string | undefined;
    chequeDate?: Date | undefined;
    createdDateTime?: Date;
    transactionDate?: Date | undefined;
    orderId?: number | undefined;
}

export class UpsertTransactionCommand extends MemberTransactionModel implements IUpsertTransactionCommand {

    constructor(data?: IUpsertTransactionCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertTransactionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertTransactionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertTransactionCommand extends IMemberTransactionModel {
}

export class RFIdTagRequestModel implements IRFIdTagRequestModel {
    memberCode?: string | undefined;
    rfId?: string | undefined;

    constructor(data?: IRFIdTagRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberCode = _data["memberCode"];
            this.rfId = _data["rfId"];
        }
    }

    static fromJS(data: any): RFIdTagRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new RFIdTagRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["rfId"] = this.rfId;
        return data; 
    }
}

export interface IRFIdTagRequestModel {
    memberCode?: string | undefined;
    rfId?: string | undefined;
}

export class UpsertDeviceRfIdMemberTagCommand extends RFIdTagRequestModel implements IUpsertDeviceRfIdMemberTagCommand {

    constructor(data?: IUpsertDeviceRfIdMemberTagCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertDeviceRfIdMemberTagCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertDeviceRfIdMemberTagCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertDeviceRfIdMemberTagCommand extends IRFIdTagRequestModel {
}

export class RFIdTagRequestWithCardNumberModel implements IRFIdTagRequestWithCardNumberModel {
    rfId?: string | undefined;
    cardNumber?: string | undefined;

    constructor(data?: IRFIdTagRequestWithCardNumberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rfId = _data["rfId"];
            this.cardNumber = _data["cardNumber"];
        }
    }

    static fromJS(data: any): RFIdTagRequestWithCardNumberModel {
        data = typeof data === 'object' ? data : {};
        let result = new RFIdTagRequestWithCardNumberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rfId"] = this.rfId;
        data["cardNumber"] = this.cardNumber;
        return data; 
    }
}

export interface IRFIdTagRequestWithCardNumberModel {
    rfId?: string | undefined;
    cardNumber?: string | undefined;
}

export class UpsertRfIdByCardNumberCommand extends RFIdTagRequestWithCardNumberModel implements IUpsertRfIdByCardNumberCommand {

    constructor(data?: IUpsertRfIdByCardNumberCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertRfIdByCardNumberCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRfIdByCardNumberCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertRfIdByCardNumberCommand extends IRFIdTagRequestWithCardNumberModel {
}

export class DeviceNotificationsModel implements IDeviceNotificationsModel {
    id?: number;
    userId?: string | undefined;
    notification?: string | undefined;
    notificationDate?: Date;

    constructor(data?: IDeviceNotificationsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.notification = _data["notification"];
            this.notificationDate = _data["notificationDate"] ? new Date(_data["notificationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceNotificationsModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceNotificationsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["notification"] = this.notification;
        data["notificationDate"] = this.notificationDate ? this.notificationDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IDeviceNotificationsModel {
    id?: number;
    userId?: string | undefined;
    notification?: string | undefined;
    notificationDate?: Date;
}

export class UpsertDeviceNotificationsCommand extends DeviceNotificationsModel implements IUpsertDeviceNotificationsCommand {

    constructor(data?: IUpsertDeviceNotificationsCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertDeviceNotificationsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertDeviceNotificationsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertDeviceNotificationsCommand extends IDeviceNotificationsModel {
}

export class EmailProcessModel extends BaseModel implements IEmailProcessModel {
    id?: number;
    memberId?: number;
    billType?: number;
    month?: string | undefined;
    year?: number;
    emailAddress?: string | undefined;
    emailSubject?: string | undefined;
    emailBody?: string | undefined;
    emailSent?: boolean;
    emailSentOn?: Date | undefined;

    constructor(data?: IEmailProcessModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.billType = _data["billType"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.emailAddress = _data["emailAddress"];
            this.emailSubject = _data["emailSubject"];
            this.emailBody = _data["emailBody"];
            this.emailSent = _data["emailSent"];
            this.emailSentOn = _data["emailSentOn"] ? new Date(_data["emailSentOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailProcessModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailProcessModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["billType"] = this.billType;
        data["month"] = this.month;
        data["year"] = this.year;
        data["emailAddress"] = this.emailAddress;
        data["emailSubject"] = this.emailSubject;
        data["emailBody"] = this.emailBody;
        data["emailSent"] = this.emailSent;
        data["emailSentOn"] = this.emailSentOn ? this.emailSentOn.toISOString() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IEmailProcessModel extends IBaseModel {
    id?: number;
    memberId?: number;
    billType?: number;
    month?: string | undefined;
    year?: number;
    emailAddress?: string | undefined;
    emailSubject?: string | undefined;
    emailBody?: string | undefined;
    emailSent?: boolean;
    emailSentOn?: Date | undefined;
}

export class UpsertEmailProcessCommand extends EmailProcessModel implements IUpsertEmailProcessCommand {

    constructor(data?: IUpsertEmailProcessCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertEmailProcessCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertEmailProcessCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertEmailProcessCommand extends IEmailProcessModel {
}

export class UpsertTennisFeeProcessCommand extends BaseModel implements IUpsertTennisFeeProcessCommand {

    constructor(data?: IUpsertTennisFeeProcessCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertTennisFeeProcessCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertTennisFeeProcessCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertTennisFeeProcessCommand extends IBaseModel {
}

export class EventViewModel implements IEventViewModel {
    model?: EventModel | undefined;

    constructor(data?: IEventViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? EventModel.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EventViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IEventViewModel {
    model?: EventModel | undefined;
}

export class EventModel extends BaseModel implements IEventModel {
    id?: number;
    title?: string | undefined;
    description?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;

    constructor(data?: IEventModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EventModel {
        data = typeof data === 'object' ? data : {};
        let result = new EventModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IEventModel extends IBaseModel {
    id?: number;
    title?: string | undefined;
    description?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
}

export class UpsertEventCommand extends EventModel implements IUpsertEventCommand {

    constructor(data?: IUpsertEventCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertEventCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertEventCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertEventCommand extends IEventModel {
}

export class GymAvailLogViewModel implements IGymAvailLogViewModel {
    model?: GymAvailLogModel | undefined;
    members?: SelectModel[] | undefined;

    constructor(data?: IGymAvailLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? GymAvailLogModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GymAvailLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GymAvailLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGymAvailLogViewModel {
    model?: GymAvailLogModel | undefined;
    members?: SelectModel[] | undefined;
}

export class GymAvailLogModel extends BaseModel implements IGymAvailLogModel {
    id?: number;
    memberId?: number;
    inTime?: Date;
    outTime?: Date | undefined;
    charge?: number;
    memberCode?: string | undefined;
    memberName?: string | undefined;

    constructor(data?: IGymAvailLogModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.charge = _data["charge"];
            this.memberCode = _data["memberCode"];
            this.memberName = _data["memberName"];
        }
    }

    static fromJS(data: any): GymAvailLogModel {
        data = typeof data === 'object' ? data : {};
        let result = new GymAvailLogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["charge"] = this.charge;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        super.toJSON(data);
        return data; 
    }
}

export interface IGymAvailLogModel extends IBaseModel {
    id?: number;
    memberId?: number;
    inTime?: Date;
    outTime?: Date | undefined;
    charge?: number;
    memberCode?: string | undefined;
    memberName?: string | undefined;
}

export class UpsertGymAvailLogCommand extends GymAvailLogModel implements IUpsertGymAvailLogCommand {

    constructor(data?: IUpsertGymAvailLogCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertGymAvailLogCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertGymAvailLogCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertGymAvailLogCommand extends IGymAvailLogModel {
}

export class GymRatesViewModel implements IGymRatesViewModel {
    model?: GymRatesModel | undefined;
    membershipTypeSelectList?: SelectModel[] | undefined;

    constructor(data?: IGymRatesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? GymRatesModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["membershipTypeSelectList"])) {
                this.membershipTypeSelectList = [] as any;
                for (let item of _data["membershipTypeSelectList"])
                    this.membershipTypeSelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GymRatesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GymRatesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.membershipTypeSelectList)) {
            data["membershipTypeSelectList"] = [];
            for (let item of this.membershipTypeSelectList)
                data["membershipTypeSelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGymRatesViewModel {
    model?: GymRatesModel | undefined;
    membershipTypeSelectList?: SelectModel[] | undefined;
}

export class GymRatesModel implements IGymRatesModel {
    id?: number;
    membershipTypeId?: number;
    rate?: number;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    membershipType?: MembershipType | undefined;

    constructor(data?: IGymRatesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.membershipTypeId = _data["membershipTypeId"];
            this.rate = _data["rate"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.membershipType = _data["membershipType"] ? MembershipType.fromJS(_data["membershipType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GymRatesModel {
        data = typeof data === 'object' ? data : {};
        let result = new GymRatesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["membershipTypeId"] = this.membershipTypeId;
        data["rate"] = this.rate;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["membershipType"] = this.membershipType ? this.membershipType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGymRatesModel {
    id?: number;
    membershipTypeId?: number;
    rate?: number;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    membershipType?: MembershipType | undefined;
}

export class MembershipType implements IMembershipType {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    memberCategoryId?: number;
    debentureAmount?: number;
    monthlyFee?: number;
    validityDuration?: number | undefined;
    hasAccompaniedMember?: boolean;
    monthlyContributingPoints?: number | undefined;
    isInternal?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    gymRate?: GymRate | undefined;
    poolRate?: PoolRate | undefined;
    memberCategory?: BusinessCategory | undefined;
    members?: Member[] | undefined;
    membershipTypesIntechangeInterchangeMembershipType?: MembershipTypesInterchange[] | undefined;
    membershipTypesIntechangeMembershipType?: MembershipTypesInterchange[] | undefined;

    constructor(data?: IMembershipType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.memberCategoryId = _data["memberCategoryId"];
            this.debentureAmount = _data["debentureAmount"];
            this.monthlyFee = _data["monthlyFee"];
            this.validityDuration = _data["validityDuration"];
            this.hasAccompaniedMember = _data["hasAccompaniedMember"];
            this.monthlyContributingPoints = _data["monthlyContributingPoints"];
            this.isInternal = _data["isInternal"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.gymRate = _data["gymRate"] ? GymRate.fromJS(_data["gymRate"]) : <any>undefined;
            this.poolRate = _data["poolRate"] ? PoolRate.fromJS(_data["poolRate"]) : <any>undefined;
            this.memberCategory = _data["memberCategory"] ? BusinessCategory.fromJS(_data["memberCategory"]) : <any>undefined;
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(Member.fromJS(item));
            }
            if (Array.isArray(_data["membershipTypesIntechangeInterchangeMembershipType"])) {
                this.membershipTypesIntechangeInterchangeMembershipType = [] as any;
                for (let item of _data["membershipTypesIntechangeInterchangeMembershipType"])
                    this.membershipTypesIntechangeInterchangeMembershipType!.push(MembershipTypesInterchange.fromJS(item));
            }
            if (Array.isArray(_data["membershipTypesIntechangeMembershipType"])) {
                this.membershipTypesIntechangeMembershipType = [] as any;
                for (let item of _data["membershipTypesIntechangeMembershipType"])
                    this.membershipTypesIntechangeMembershipType!.push(MembershipTypesInterchange.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MembershipType {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["memberCategoryId"] = this.memberCategoryId;
        data["debentureAmount"] = this.debentureAmount;
        data["monthlyFee"] = this.monthlyFee;
        data["validityDuration"] = this.validityDuration;
        data["hasAccompaniedMember"] = this.hasAccompaniedMember;
        data["monthlyContributingPoints"] = this.monthlyContributingPoints;
        data["isInternal"] = this.isInternal;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["gymRate"] = this.gymRate ? this.gymRate.toJSON() : <any>undefined;
        data["poolRate"] = this.poolRate ? this.poolRate.toJSON() : <any>undefined;
        data["memberCategory"] = this.memberCategory ? this.memberCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        if (Array.isArray(this.membershipTypesIntechangeInterchangeMembershipType)) {
            data["membershipTypesIntechangeInterchangeMembershipType"] = [];
            for (let item of this.membershipTypesIntechangeInterchangeMembershipType)
                data["membershipTypesIntechangeInterchangeMembershipType"].push(item.toJSON());
        }
        if (Array.isArray(this.membershipTypesIntechangeMembershipType)) {
            data["membershipTypesIntechangeMembershipType"] = [];
            for (let item of this.membershipTypesIntechangeMembershipType)
                data["membershipTypesIntechangeMembershipType"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMembershipType {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    memberCategoryId?: number;
    debentureAmount?: number;
    monthlyFee?: number;
    validityDuration?: number | undefined;
    hasAccompaniedMember?: boolean;
    monthlyContributingPoints?: number | undefined;
    isInternal?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    gymRate?: GymRate | undefined;
    poolRate?: PoolRate | undefined;
    memberCategory?: BusinessCategory | undefined;
    members?: Member[] | undefined;
    membershipTypesIntechangeInterchangeMembershipType?: MembershipTypesInterchange[] | undefined;
    membershipTypesIntechangeMembershipType?: MembershipTypesInterchange[] | undefined;
}

export class GymRate implements IGymRate {
    id?: number;
    membershipTypeId?: number;
    rate?: number;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    membershipType?: MembershipType | undefined;

    constructor(data?: IGymRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.membershipTypeId = _data["membershipTypeId"];
            this.rate = _data["rate"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.membershipType = _data["membershipType"] ? MembershipType.fromJS(_data["membershipType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GymRate {
        data = typeof data === 'object' ? data : {};
        let result = new GymRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["membershipTypeId"] = this.membershipTypeId;
        data["rate"] = this.rate;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["membershipType"] = this.membershipType ? this.membershipType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGymRate {
    id?: number;
    membershipTypeId?: number;
    rate?: number;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    membershipType?: MembershipType | undefined;
}

export class PoolRate implements IPoolRate {
    id?: number;
    membershipTypeId?: number;
    rate?: number;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    membershipType?: MembershipType | undefined;

    constructor(data?: IPoolRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.membershipTypeId = _data["membershipTypeId"];
            this.rate = _data["rate"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.membershipType = _data["membershipType"] ? MembershipType.fromJS(_data["membershipType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PoolRate {
        data = typeof data === 'object' ? data : {};
        let result = new PoolRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["membershipTypeId"] = this.membershipTypeId;
        data["rate"] = this.rate;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["membershipType"] = this.membershipType ? this.membershipType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPoolRate {
    id?: number;
    membershipTypeId?: number;
    rate?: number;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    membershipType?: MembershipType | undefined;
}

export class BusinessCategory implements IBusinessCategory {
    id?: number;
    businessCategoryTypeId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isInternal?: boolean;
    isActive?: boolean;
    isDefault?: boolean;
    memberTransactionsPaymentType?: MemberTransaction[] | undefined;
    businessCategoryType?: BusinessCategoryType | undefined;
    attributes?: Attribute[] | undefined;
    counters?: Counters[] | undefined;
    emailProcess?: EmailProcess[] | undefined;
    memberCards?: MemberCard[] | undefined;
    memberTransactions?: MemberTransaction[] | undefined;
    membershipTypes?: MembershipType[] | undefined;
    orderItems?: OrderItem[] | undefined;
    orders?: Order[] | undefined;
    memberDocuments?: MemberDocument[] | undefined;
    tennisShifts?: TennisBookingSlot[] | undefined;
    stockItemRegistersRegisterType?: StockItemRegister[] | undefined;
    stockItemRegistersStatus?: StockItemRegister[] | undefined;
    tennisFeeSettings?: TennisFeeSetting[] | undefined;
    tennisSlotBookings?: TennisSlotBooking[] | undefined;
    systemReportModules?: SystemReport[] | undefined;
    systemReportReportTypes?: SystemReport[] | undefined;
    systemReportReportMapTypes?: SystemReport[] | undefined;
    salesItems?: Item[] | undefined;
    monthlyEmailsProcess?: MonthlyEmailProcess[] | undefined;
    tipsoiLogs?: TipsoiLog[] | undefined;

    constructor(data?: IBusinessCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessCategoryTypeId = _data["businessCategoryTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isInternal = _data["isInternal"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
            if (Array.isArray(_data["memberTransactionsPaymentType"])) {
                this.memberTransactionsPaymentType = [] as any;
                for (let item of _data["memberTransactionsPaymentType"])
                    this.memberTransactionsPaymentType!.push(MemberTransaction.fromJS(item));
            }
            this.businessCategoryType = _data["businessCategoryType"] ? BusinessCategoryType.fromJS(_data["businessCategoryType"]) : <any>undefined;
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(Attribute.fromJS(item));
            }
            if (Array.isArray(_data["counters"])) {
                this.counters = [] as any;
                for (let item of _data["counters"])
                    this.counters!.push(Counters.fromJS(item));
            }
            if (Array.isArray(_data["emailProcess"])) {
                this.emailProcess = [] as any;
                for (let item of _data["emailProcess"])
                    this.emailProcess!.push(EmailProcess.fromJS(item));
            }
            if (Array.isArray(_data["memberCards"])) {
                this.memberCards = [] as any;
                for (let item of _data["memberCards"])
                    this.memberCards!.push(MemberCard.fromJS(item));
            }
            if (Array.isArray(_data["memberTransactions"])) {
                this.memberTransactions = [] as any;
                for (let item of _data["memberTransactions"])
                    this.memberTransactions!.push(MemberTransaction.fromJS(item));
            }
            if (Array.isArray(_data["membershipTypes"])) {
                this.membershipTypes = [] as any;
                for (let item of _data["membershipTypes"])
                    this.membershipTypes!.push(MembershipType.fromJS(item));
            }
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItem.fromJS(item));
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["memberDocuments"])) {
                this.memberDocuments = [] as any;
                for (let item of _data["memberDocuments"])
                    this.memberDocuments!.push(MemberDocument.fromJS(item));
            }
            if (Array.isArray(_data["tennisShifts"])) {
                this.tennisShifts = [] as any;
                for (let item of _data["tennisShifts"])
                    this.tennisShifts!.push(TennisBookingSlot.fromJS(item));
            }
            if (Array.isArray(_data["stockItemRegistersRegisterType"])) {
                this.stockItemRegistersRegisterType = [] as any;
                for (let item of _data["stockItemRegistersRegisterType"])
                    this.stockItemRegistersRegisterType!.push(StockItemRegister.fromJS(item));
            }
            if (Array.isArray(_data["stockItemRegistersStatus"])) {
                this.stockItemRegistersStatus = [] as any;
                for (let item of _data["stockItemRegistersStatus"])
                    this.stockItemRegistersStatus!.push(StockItemRegister.fromJS(item));
            }
            if (Array.isArray(_data["tennisFeeSettings"])) {
                this.tennisFeeSettings = [] as any;
                for (let item of _data["tennisFeeSettings"])
                    this.tennisFeeSettings!.push(TennisFeeSetting.fromJS(item));
            }
            if (Array.isArray(_data["tennisSlotBookings"])) {
                this.tennisSlotBookings = [] as any;
                for (let item of _data["tennisSlotBookings"])
                    this.tennisSlotBookings!.push(TennisSlotBooking.fromJS(item));
            }
            if (Array.isArray(_data["systemReportModules"])) {
                this.systemReportModules = [] as any;
                for (let item of _data["systemReportModules"])
                    this.systemReportModules!.push(SystemReport.fromJS(item));
            }
            if (Array.isArray(_data["systemReportReportTypes"])) {
                this.systemReportReportTypes = [] as any;
                for (let item of _data["systemReportReportTypes"])
                    this.systemReportReportTypes!.push(SystemReport.fromJS(item));
            }
            if (Array.isArray(_data["systemReportReportMapTypes"])) {
                this.systemReportReportMapTypes = [] as any;
                for (let item of _data["systemReportReportMapTypes"])
                    this.systemReportReportMapTypes!.push(SystemReport.fromJS(item));
            }
            if (Array.isArray(_data["salesItems"])) {
                this.salesItems = [] as any;
                for (let item of _data["salesItems"])
                    this.salesItems!.push(Item.fromJS(item));
            }
            if (Array.isArray(_data["monthlyEmailsProcess"])) {
                this.monthlyEmailsProcess = [] as any;
                for (let item of _data["monthlyEmailsProcess"])
                    this.monthlyEmailsProcess!.push(MonthlyEmailProcess.fromJS(item));
            }
            if (Array.isArray(_data["tipsoiLogs"])) {
                this.tipsoiLogs = [] as any;
                for (let item of _data["tipsoiLogs"])
                    this.tipsoiLogs!.push(TipsoiLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BusinessCategory {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessCategoryTypeId"] = this.businessCategoryTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isInternal"] = this.isInternal;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        if (Array.isArray(this.memberTransactionsPaymentType)) {
            data["memberTransactionsPaymentType"] = [];
            for (let item of this.memberTransactionsPaymentType)
                data["memberTransactionsPaymentType"].push(item.toJSON());
        }
        data["businessCategoryType"] = this.businessCategoryType ? this.businessCategoryType.toJSON() : <any>undefined;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        if (Array.isArray(this.counters)) {
            data["counters"] = [];
            for (let item of this.counters)
                data["counters"].push(item.toJSON());
        }
        if (Array.isArray(this.emailProcess)) {
            data["emailProcess"] = [];
            for (let item of this.emailProcess)
                data["emailProcess"].push(item.toJSON());
        }
        if (Array.isArray(this.memberCards)) {
            data["memberCards"] = [];
            for (let item of this.memberCards)
                data["memberCards"].push(item.toJSON());
        }
        if (Array.isArray(this.memberTransactions)) {
            data["memberTransactions"] = [];
            for (let item of this.memberTransactions)
                data["memberTransactions"].push(item.toJSON());
        }
        if (Array.isArray(this.membershipTypes)) {
            data["membershipTypes"] = [];
            for (let item of this.membershipTypes)
                data["membershipTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        if (Array.isArray(this.memberDocuments)) {
            data["memberDocuments"] = [];
            for (let item of this.memberDocuments)
                data["memberDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.tennisShifts)) {
            data["tennisShifts"] = [];
            for (let item of this.tennisShifts)
                data["tennisShifts"].push(item.toJSON());
        }
        if (Array.isArray(this.stockItemRegistersRegisterType)) {
            data["stockItemRegistersRegisterType"] = [];
            for (let item of this.stockItemRegistersRegisterType)
                data["stockItemRegistersRegisterType"].push(item.toJSON());
        }
        if (Array.isArray(this.stockItemRegistersStatus)) {
            data["stockItemRegistersStatus"] = [];
            for (let item of this.stockItemRegistersStatus)
                data["stockItemRegistersStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.tennisFeeSettings)) {
            data["tennisFeeSettings"] = [];
            for (let item of this.tennisFeeSettings)
                data["tennisFeeSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.tennisSlotBookings)) {
            data["tennisSlotBookings"] = [];
            for (let item of this.tennisSlotBookings)
                data["tennisSlotBookings"].push(item.toJSON());
        }
        if (Array.isArray(this.systemReportModules)) {
            data["systemReportModules"] = [];
            for (let item of this.systemReportModules)
                data["systemReportModules"].push(item.toJSON());
        }
        if (Array.isArray(this.systemReportReportTypes)) {
            data["systemReportReportTypes"] = [];
            for (let item of this.systemReportReportTypes)
                data["systemReportReportTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.systemReportReportMapTypes)) {
            data["systemReportReportMapTypes"] = [];
            for (let item of this.systemReportReportMapTypes)
                data["systemReportReportMapTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.salesItems)) {
            data["salesItems"] = [];
            for (let item of this.salesItems)
                data["salesItems"].push(item.toJSON());
        }
        if (Array.isArray(this.monthlyEmailsProcess)) {
            data["monthlyEmailsProcess"] = [];
            for (let item of this.monthlyEmailsProcess)
                data["monthlyEmailsProcess"].push(item.toJSON());
        }
        if (Array.isArray(this.tipsoiLogs)) {
            data["tipsoiLogs"] = [];
            for (let item of this.tipsoiLogs)
                data["tipsoiLogs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBusinessCategory {
    id?: number;
    businessCategoryTypeId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isInternal?: boolean;
    isActive?: boolean;
    isDefault?: boolean;
    memberTransactionsPaymentType?: MemberTransaction[] | undefined;
    businessCategoryType?: BusinessCategoryType | undefined;
    attributes?: Attribute[] | undefined;
    counters?: Counters[] | undefined;
    emailProcess?: EmailProcess[] | undefined;
    memberCards?: MemberCard[] | undefined;
    memberTransactions?: MemberTransaction[] | undefined;
    membershipTypes?: MembershipType[] | undefined;
    orderItems?: OrderItem[] | undefined;
    orders?: Order[] | undefined;
    memberDocuments?: MemberDocument[] | undefined;
    tennisShifts?: TennisBookingSlot[] | undefined;
    stockItemRegistersRegisterType?: StockItemRegister[] | undefined;
    stockItemRegistersStatus?: StockItemRegister[] | undefined;
    tennisFeeSettings?: TennisFeeSetting[] | undefined;
    tennisSlotBookings?: TennisSlotBooking[] | undefined;
    systemReportModules?: SystemReport[] | undefined;
    systemReportReportTypes?: SystemReport[] | undefined;
    systemReportReportMapTypes?: SystemReport[] | undefined;
    salesItems?: Item[] | undefined;
    monthlyEmailsProcess?: MonthlyEmailProcess[] | undefined;
    tipsoiLogs?: TipsoiLog[] | undefined;
}

export class MemberTransaction implements IMemberTransaction {
    id?: number;
    memberId?: number;
    cardId?: number;
    transactionTypeId?: number;
    transactionAmount?: number;
    transactionDescription?: string | undefined;
    orderId?: number | undefined;
    paymentTypeId?: number | undefined;
    lastFourDigit?: number | undefined;
    posBank?: string | undefined;
    bankName?: string | undefined;
    chequeNo?: string | undefined;
    chequeDate?: Date | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    card?: MemberCard | undefined;
    member?: Member | undefined;
    transactionType?: BusinessCategory | undefined;
    paymentType?: BusinessCategory | undefined;
    memberContributions?: MemberContribution[] | undefined;

    constructor(data?: IMemberTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.cardId = _data["cardId"];
            this.transactionTypeId = _data["transactionTypeId"];
            this.transactionAmount = _data["transactionAmount"];
            this.transactionDescription = _data["transactionDescription"];
            this.orderId = _data["orderId"];
            this.paymentTypeId = _data["paymentTypeId"];
            this.lastFourDigit = _data["lastFourDigit"];
            this.posBank = _data["posBank"];
            this.bankName = _data["bankName"];
            this.chequeNo = _data["chequeNo"];
            this.chequeDate = _data["chequeDate"] ? new Date(_data["chequeDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.card = _data["card"] ? MemberCard.fromJS(_data["card"]) : <any>undefined;
            this.member = _data["member"] ? Member.fromJS(_data["member"]) : <any>undefined;
            this.transactionType = _data["transactionType"] ? BusinessCategory.fromJS(_data["transactionType"]) : <any>undefined;
            this.paymentType = _data["paymentType"] ? BusinessCategory.fromJS(_data["paymentType"]) : <any>undefined;
            if (Array.isArray(_data["memberContributions"])) {
                this.memberContributions = [] as any;
                for (let item of _data["memberContributions"])
                    this.memberContributions!.push(MemberContribution.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MemberTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new MemberTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["cardId"] = this.cardId;
        data["transactionTypeId"] = this.transactionTypeId;
        data["transactionAmount"] = this.transactionAmount;
        data["transactionDescription"] = this.transactionDescription;
        data["orderId"] = this.orderId;
        data["paymentTypeId"] = this.paymentTypeId;
        data["lastFourDigit"] = this.lastFourDigit;
        data["posBank"] = this.posBank;
        data["bankName"] = this.bankName;
        data["chequeNo"] = this.chequeNo;
        data["chequeDate"] = this.chequeDate ? this.chequeDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["card"] = this.card ? this.card.toJSON() : <any>undefined;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["transactionType"] = this.transactionType ? this.transactionType.toJSON() : <any>undefined;
        data["paymentType"] = this.paymentType ? this.paymentType.toJSON() : <any>undefined;
        if (Array.isArray(this.memberContributions)) {
            data["memberContributions"] = [];
            for (let item of this.memberContributions)
                data["memberContributions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMemberTransaction {
    id?: number;
    memberId?: number;
    cardId?: number;
    transactionTypeId?: number;
    transactionAmount?: number;
    transactionDescription?: string | undefined;
    orderId?: number | undefined;
    paymentTypeId?: number | undefined;
    lastFourDigit?: number | undefined;
    posBank?: string | undefined;
    bankName?: string | undefined;
    chequeNo?: string | undefined;
    chequeDate?: Date | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    card?: MemberCard | undefined;
    member?: Member | undefined;
    transactionType?: BusinessCategory | undefined;
    paymentType?: BusinessCategory | undefined;
    memberContributions?: MemberContribution[] | undefined;
}

export class MemberCard implements IMemberCard {
    id?: number;
    memberId?: number;
    cardNumber?: string | undefined;
    accountNumber?: string | undefined;
    issueDate?: Date;
    expireDate?: Date;
    activePinId?: number;
    statusId?: number;
    pinResetRequest?: boolean | undefined;
    createdBy?: string | undefined;
    rfId?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    activePin?: MemberCardPin | undefined;
    status?: BusinessCategory | undefined;
    memberTransactions?: MemberTransaction[] | undefined;
    members?: Member[] | undefined;

    constructor(data?: IMemberCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.cardNumber = _data["cardNumber"];
            this.accountNumber = _data["accountNumber"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? new Date(_data["expireDate"].toString()) : <any>undefined;
            this.activePinId = _data["activePinId"];
            this.statusId = _data["statusId"];
            this.pinResetRequest = _data["pinResetRequest"];
            this.createdBy = _data["createdBy"];
            this.rfId = _data["rfId"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.activePin = _data["activePin"] ? MemberCardPin.fromJS(_data["activePin"]) : <any>undefined;
            this.status = _data["status"] ? BusinessCategory.fromJS(_data["status"]) : <any>undefined;
            if (Array.isArray(_data["memberTransactions"])) {
                this.memberTransactions = [] as any;
                for (let item of _data["memberTransactions"])
                    this.memberTransactions!.push(MemberTransaction.fromJS(item));
            }
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(Member.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MemberCard {
        data = typeof data === 'object' ? data : {};
        let result = new MemberCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["cardNumber"] = this.cardNumber;
        data["accountNumber"] = this.accountNumber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["activePinId"] = this.activePinId;
        data["statusId"] = this.statusId;
        data["pinResetRequest"] = this.pinResetRequest;
        data["createdBy"] = this.createdBy;
        data["rfId"] = this.rfId;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["activePin"] = this.activePin ? this.activePin.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (Array.isArray(this.memberTransactions)) {
            data["memberTransactions"] = [];
            for (let item of this.memberTransactions)
                data["memberTransactions"].push(item.toJSON());
        }
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMemberCard {
    id?: number;
    memberId?: number;
    cardNumber?: string | undefined;
    accountNumber?: string | undefined;
    issueDate?: Date;
    expireDate?: Date;
    activePinId?: number;
    statusId?: number;
    pinResetRequest?: boolean | undefined;
    createdBy?: string | undefined;
    rfId?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    activePin?: MemberCardPin | undefined;
    status?: BusinessCategory | undefined;
    memberTransactions?: MemberTransaction[] | undefined;
    members?: Member[] | undefined;
}

export class MemberCardPin implements IMemberCardPin {
    id?: number;
    pin?: string | undefined;
    memberId?: number | undefined;
    isActive?: boolean;
    memberCards?: MemberCard[] | undefined;

    constructor(data?: IMemberCardPin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pin = _data["pin"];
            this.memberId = _data["memberId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["memberCards"])) {
                this.memberCards = [] as any;
                for (let item of _data["memberCards"])
                    this.memberCards!.push(MemberCard.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MemberCardPin {
        data = typeof data === 'object' ? data : {};
        let result = new MemberCardPin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pin"] = this.pin;
        data["memberId"] = this.memberId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.memberCards)) {
            data["memberCards"] = [];
            for (let item of this.memberCards)
                data["memberCards"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMemberCardPin {
    id?: number;
    pin?: string | undefined;
    memberId?: number | undefined;
    isActive?: boolean;
    memberCards?: MemberCard[] | undefined;
}

export class Member implements IMember {
    id?: number;
    membershipTypeId?: number;
    accompaniedMemberId?: number | undefined;
    referenceMemberId?: number | undefined;
    isAccompaniedMember?: boolean;
    memberCode?: string | undefined;
    refMemberCode?: string | undefined;
    accountNumber?: string | undefined;
    title?: string | undefined;
    forename?: string | undefined;
    surname?: string | undefined;
    gender?: string | undefined;
    birthDate?: Date | undefined;
    nationality?: string | undefined;
    email?: string | undefined;
    mobileNumber?: string | undefined;
    passportNumber?: string | undefined;
    residentialAddress?: string | undefined;
    organizationName?: string | undefined;
    workAddress?: string | undefined;
    workNumber?: string | undefined;
    isPrevoiusTempMember?: boolean;
    expatClubName?: string | undefined;
    activeCardId?: number | undefined;
    approvedBy?: string | undefined;
    approvedDate?: Date | undefined;
    membershipExpireDate?: Date | undefined;
    debentureAmount?: number;
    overdraft?: number;
    creditLimit?: number;
    currentBalance?: number;
    totalContributingPoints?: number | undefined;
    monthlyContributingPoints?: number | undefined;
    profilePictureId?: number | undefined;
    userId?: string | undefined;
    isActive?: boolean | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    pointsCalculatedOn?: Date | undefined;
    tennisToken?: string | undefined;
    nickName?: string | undefined;
    academicBackground?: string | undefined;
    occupation?: string | undefined;
    nid?: string | undefined;
    mr?: string | undefined;
    bloodGroupId?: number | undefined;
    bloodGroupName?: string | undefined;
    joiningDate?: Date | undefined;
    activeCard?: MemberCard | undefined;
    membershipType?: MembershipType | undefined;
    referenceMember?: Member | undefined;
    accompaniedMember?: Member | undefined;
    profilePicture?: ApplicationImage | undefined;
    inverseAccompaniedMember?: Member[] | undefined;
    inverseReferenceMember?: Member[] | undefined;
    memberContributions?: MemberContribution[] | undefined;
    memberDocuments?: MemberDocument[] | undefined;
    memberTransactions?: MemberTransaction[] | undefined;
    emailProcess?: EmailProcess[] | undefined;
    orders?: Order[] | undefined;
    tennisSlotBookings?: TennisSlotBooking[] | undefined;
    tipsoiLogs?: TipsoiLog[] | undefined;

    constructor(data?: IMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.membershipTypeId = _data["membershipTypeId"];
            this.accompaniedMemberId = _data["accompaniedMemberId"];
            this.referenceMemberId = _data["referenceMemberId"];
            this.isAccompaniedMember = _data["isAccompaniedMember"];
            this.memberCode = _data["memberCode"];
            this.refMemberCode = _data["refMemberCode"];
            this.accountNumber = _data["accountNumber"];
            this.title = _data["title"];
            this.forename = _data["forename"];
            this.surname = _data["surname"];
            this.gender = _data["gender"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.nationality = _data["nationality"];
            this.email = _data["email"];
            this.mobileNumber = _data["mobileNumber"];
            this.passportNumber = _data["passportNumber"];
            this.residentialAddress = _data["residentialAddress"];
            this.organizationName = _data["organizationName"];
            this.workAddress = _data["workAddress"];
            this.workNumber = _data["workNumber"];
            this.isPrevoiusTempMember = _data["isPrevoiusTempMember"];
            this.expatClubName = _data["expatClubName"];
            this.activeCardId = _data["activeCardId"];
            this.approvedBy = _data["approvedBy"];
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : <any>undefined;
            this.membershipExpireDate = _data["membershipExpireDate"] ? new Date(_data["membershipExpireDate"].toString()) : <any>undefined;
            this.debentureAmount = _data["debentureAmount"];
            this.overdraft = _data["overdraft"];
            this.creditLimit = _data["creditLimit"];
            this.currentBalance = _data["currentBalance"];
            this.totalContributingPoints = _data["totalContributingPoints"];
            this.monthlyContributingPoints = _data["monthlyContributingPoints"];
            this.profilePictureId = _data["profilePictureId"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.pointsCalculatedOn = _data["pointsCalculatedOn"] ? new Date(_data["pointsCalculatedOn"].toString()) : <any>undefined;
            this.tennisToken = _data["tennisToken"];
            this.nickName = _data["nickName"];
            this.academicBackground = _data["academicBackground"];
            this.occupation = _data["occupation"];
            this.nid = _data["nid"];
            this.mr = _data["mr"];
            this.bloodGroupId = _data["bloodGroupId"];
            this.bloodGroupName = _data["bloodGroupName"];
            this.joiningDate = _data["joiningDate"] ? new Date(_data["joiningDate"].toString()) : <any>undefined;
            this.activeCard = _data["activeCard"] ? MemberCard.fromJS(_data["activeCard"]) : <any>undefined;
            this.membershipType = _data["membershipType"] ? MembershipType.fromJS(_data["membershipType"]) : <any>undefined;
            this.referenceMember = _data["referenceMember"] ? Member.fromJS(_data["referenceMember"]) : <any>undefined;
            this.accompaniedMember = _data["accompaniedMember"] ? Member.fromJS(_data["accompaniedMember"]) : <any>undefined;
            this.profilePicture = _data["profilePicture"] ? ApplicationImage.fromJS(_data["profilePicture"]) : <any>undefined;
            if (Array.isArray(_data["inverseAccompaniedMember"])) {
                this.inverseAccompaniedMember = [] as any;
                for (let item of _data["inverseAccompaniedMember"])
                    this.inverseAccompaniedMember!.push(Member.fromJS(item));
            }
            if (Array.isArray(_data["inverseReferenceMember"])) {
                this.inverseReferenceMember = [] as any;
                for (let item of _data["inverseReferenceMember"])
                    this.inverseReferenceMember!.push(Member.fromJS(item));
            }
            if (Array.isArray(_data["memberContributions"])) {
                this.memberContributions = [] as any;
                for (let item of _data["memberContributions"])
                    this.memberContributions!.push(MemberContribution.fromJS(item));
            }
            if (Array.isArray(_data["memberDocuments"])) {
                this.memberDocuments = [] as any;
                for (let item of _data["memberDocuments"])
                    this.memberDocuments!.push(MemberDocument.fromJS(item));
            }
            if (Array.isArray(_data["memberTransactions"])) {
                this.memberTransactions = [] as any;
                for (let item of _data["memberTransactions"])
                    this.memberTransactions!.push(MemberTransaction.fromJS(item));
            }
            if (Array.isArray(_data["emailProcess"])) {
                this.emailProcess = [] as any;
                for (let item of _data["emailProcess"])
                    this.emailProcess!.push(EmailProcess.fromJS(item));
            }
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(Order.fromJS(item));
            }
            if (Array.isArray(_data["tennisSlotBookings"])) {
                this.tennisSlotBookings = [] as any;
                for (let item of _data["tennisSlotBookings"])
                    this.tennisSlotBookings!.push(TennisSlotBooking.fromJS(item));
            }
            if (Array.isArray(_data["tipsoiLogs"])) {
                this.tipsoiLogs = [] as any;
                for (let item of _data["tipsoiLogs"])
                    this.tipsoiLogs!.push(TipsoiLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Member {
        data = typeof data === 'object' ? data : {};
        let result = new Member();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["membershipTypeId"] = this.membershipTypeId;
        data["accompaniedMemberId"] = this.accompaniedMemberId;
        data["referenceMemberId"] = this.referenceMemberId;
        data["isAccompaniedMember"] = this.isAccompaniedMember;
        data["memberCode"] = this.memberCode;
        data["refMemberCode"] = this.refMemberCode;
        data["accountNumber"] = this.accountNumber;
        data["title"] = this.title;
        data["forename"] = this.forename;
        data["surname"] = this.surname;
        data["gender"] = this.gender;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["nationality"] = this.nationality;
        data["email"] = this.email;
        data["mobileNumber"] = this.mobileNumber;
        data["passportNumber"] = this.passportNumber;
        data["residentialAddress"] = this.residentialAddress;
        data["organizationName"] = this.organizationName;
        data["workAddress"] = this.workAddress;
        data["workNumber"] = this.workNumber;
        data["isPrevoiusTempMember"] = this.isPrevoiusTempMember;
        data["expatClubName"] = this.expatClubName;
        data["activeCardId"] = this.activeCardId;
        data["approvedBy"] = this.approvedBy;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["membershipExpireDate"] = this.membershipExpireDate ? this.membershipExpireDate.toISOString() : <any>undefined;
        data["debentureAmount"] = this.debentureAmount;
        data["overdraft"] = this.overdraft;
        data["creditLimit"] = this.creditLimit;
        data["currentBalance"] = this.currentBalance;
        data["totalContributingPoints"] = this.totalContributingPoints;
        data["monthlyContributingPoints"] = this.monthlyContributingPoints;
        data["profilePictureId"] = this.profilePictureId;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["pointsCalculatedOn"] = this.pointsCalculatedOn ? this.pointsCalculatedOn.toISOString() : <any>undefined;
        data["tennisToken"] = this.tennisToken;
        data["nickName"] = this.nickName;
        data["academicBackground"] = this.academicBackground;
        data["occupation"] = this.occupation;
        data["nid"] = this.nid;
        data["mr"] = this.mr;
        data["bloodGroupId"] = this.bloodGroupId;
        data["bloodGroupName"] = this.bloodGroupName;
        data["joiningDate"] = this.joiningDate ? this.joiningDate.toISOString() : <any>undefined;
        data["activeCard"] = this.activeCard ? this.activeCard.toJSON() : <any>undefined;
        data["membershipType"] = this.membershipType ? this.membershipType.toJSON() : <any>undefined;
        data["referenceMember"] = this.referenceMember ? this.referenceMember.toJSON() : <any>undefined;
        data["accompaniedMember"] = this.accompaniedMember ? this.accompaniedMember.toJSON() : <any>undefined;
        data["profilePicture"] = this.profilePicture ? this.profilePicture.toJSON() : <any>undefined;
        if (Array.isArray(this.inverseAccompaniedMember)) {
            data["inverseAccompaniedMember"] = [];
            for (let item of this.inverseAccompaniedMember)
                data["inverseAccompaniedMember"].push(item.toJSON());
        }
        if (Array.isArray(this.inverseReferenceMember)) {
            data["inverseReferenceMember"] = [];
            for (let item of this.inverseReferenceMember)
                data["inverseReferenceMember"].push(item.toJSON());
        }
        if (Array.isArray(this.memberContributions)) {
            data["memberContributions"] = [];
            for (let item of this.memberContributions)
                data["memberContributions"].push(item.toJSON());
        }
        if (Array.isArray(this.memberDocuments)) {
            data["memberDocuments"] = [];
            for (let item of this.memberDocuments)
                data["memberDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.memberTransactions)) {
            data["memberTransactions"] = [];
            for (let item of this.memberTransactions)
                data["memberTransactions"].push(item.toJSON());
        }
        if (Array.isArray(this.emailProcess)) {
            data["emailProcess"] = [];
            for (let item of this.emailProcess)
                data["emailProcess"].push(item.toJSON());
        }
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        if (Array.isArray(this.tennisSlotBookings)) {
            data["tennisSlotBookings"] = [];
            for (let item of this.tennisSlotBookings)
                data["tennisSlotBookings"].push(item.toJSON());
        }
        if (Array.isArray(this.tipsoiLogs)) {
            data["tipsoiLogs"] = [];
            for (let item of this.tipsoiLogs)
                data["tipsoiLogs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMember {
    id?: number;
    membershipTypeId?: number;
    accompaniedMemberId?: number | undefined;
    referenceMemberId?: number | undefined;
    isAccompaniedMember?: boolean;
    memberCode?: string | undefined;
    refMemberCode?: string | undefined;
    accountNumber?: string | undefined;
    title?: string | undefined;
    forename?: string | undefined;
    surname?: string | undefined;
    gender?: string | undefined;
    birthDate?: Date | undefined;
    nationality?: string | undefined;
    email?: string | undefined;
    mobileNumber?: string | undefined;
    passportNumber?: string | undefined;
    residentialAddress?: string | undefined;
    organizationName?: string | undefined;
    workAddress?: string | undefined;
    workNumber?: string | undefined;
    isPrevoiusTempMember?: boolean;
    expatClubName?: string | undefined;
    activeCardId?: number | undefined;
    approvedBy?: string | undefined;
    approvedDate?: Date | undefined;
    membershipExpireDate?: Date | undefined;
    debentureAmount?: number;
    overdraft?: number;
    creditLimit?: number;
    currentBalance?: number;
    totalContributingPoints?: number | undefined;
    monthlyContributingPoints?: number | undefined;
    profilePictureId?: number | undefined;
    userId?: string | undefined;
    isActive?: boolean | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    pointsCalculatedOn?: Date | undefined;
    tennisToken?: string | undefined;
    nickName?: string | undefined;
    academicBackground?: string | undefined;
    occupation?: string | undefined;
    nid?: string | undefined;
    mr?: string | undefined;
    bloodGroupId?: number | undefined;
    bloodGroupName?: string | undefined;
    joiningDate?: Date | undefined;
    activeCard?: MemberCard | undefined;
    membershipType?: MembershipType | undefined;
    referenceMember?: Member | undefined;
    accompaniedMember?: Member | undefined;
    profilePicture?: ApplicationImage | undefined;
    inverseAccompaniedMember?: Member[] | undefined;
    inverseReferenceMember?: Member[] | undefined;
    memberContributions?: MemberContribution[] | undefined;
    memberDocuments?: MemberDocument[] | undefined;
    memberTransactions?: MemberTransaction[] | undefined;
    emailProcess?: EmailProcess[] | undefined;
    orders?: Order[] | undefined;
    tennisSlotBookings?: TennisSlotBooking[] | undefined;
    tipsoiLogs?: TipsoiLog[] | undefined;
}

export class ApplicationImage implements IApplicationImage {
    id?: number;
    entity?: string | undefined;
    entityId?: string | undefined;
    folderName?: string | undefined;
    imageFileName?: string | undefined;
    originalFileName?: string | undefined;
    imagePath?: string | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    applicationBinaryFiles?: ApplicationBinaryFiles | undefined;
    members?: Member[] | undefined;
    contacts?: Contact[] | undefined;

    constructor(data?: IApplicationImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entity = _data["entity"];
            this.entityId = _data["entityId"];
            this.folderName = _data["folderName"];
            this.imageFileName = _data["imageFileName"];
            this.originalFileName = _data["originalFileName"];
            this.imagePath = _data["imagePath"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.applicationBinaryFiles = _data["applicationBinaryFiles"] ? ApplicationBinaryFiles.fromJS(_data["applicationBinaryFiles"]) : <any>undefined;
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(Member.fromJS(item));
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(Contact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicationImage {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entity"] = this.entity;
        data["entityId"] = this.entityId;
        data["folderName"] = this.folderName;
        data["imageFileName"] = this.imageFileName;
        data["originalFileName"] = this.originalFileName;
        data["imagePath"] = this.imagePath;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["applicationBinaryFiles"] = this.applicationBinaryFiles ? this.applicationBinaryFiles.toJSON() : <any>undefined;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IApplicationImage {
    id?: number;
    entity?: string | undefined;
    entityId?: string | undefined;
    folderName?: string | undefined;
    imageFileName?: string | undefined;
    originalFileName?: string | undefined;
    imagePath?: string | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    applicationBinaryFiles?: ApplicationBinaryFiles | undefined;
    members?: Member[] | undefined;
    contacts?: Contact[] | undefined;
}

export class ApplicationBinaryFiles implements IApplicationBinaryFiles {
    id?: number;
    image?: string | undefined;
    roundedImage?: string | undefined;
    applicationImage?: ApplicationImage | undefined;

    constructor(data?: IApplicationBinaryFiles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.image = _data["image"];
            this.roundedImage = _data["roundedImage"];
            this.applicationImage = _data["applicationImage"] ? ApplicationImage.fromJS(_data["applicationImage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationBinaryFiles {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationBinaryFiles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["image"] = this.image;
        data["roundedImage"] = this.roundedImage;
        data["applicationImage"] = this.applicationImage ? this.applicationImage.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IApplicationBinaryFiles {
    id?: number;
    image?: string | undefined;
    roundedImage?: string | undefined;
    applicationImage?: ApplicationImage | undefined;
}

export class Contact implements IContact {
    id?: number;
    profileImageId?: number | undefined;
    title?: string | undefined;
    forename?: string | undefined;
    surname?: string | undefined;
    gender?: string | undefined;
    nationality?: string | undefined;
    email?: string | undefined;
    designation?: string | undefined;
    mobileNumber?: string | undefined;
    residentialAddress?: string | undefined;
    userId?: string | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    profileImage?: ApplicationImage | undefined;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.profileImageId = _data["profileImageId"];
            this.title = _data["title"];
            this.forename = _data["forename"];
            this.surname = _data["surname"];
            this.gender = _data["gender"];
            this.nationality = _data["nationality"];
            this.email = _data["email"];
            this.designation = _data["designation"];
            this.mobileNumber = _data["mobileNumber"];
            this.residentialAddress = _data["residentialAddress"];
            this.userId = _data["userId"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.profileImage = _data["profileImage"] ? ApplicationImage.fromJS(_data["profileImage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["profileImageId"] = this.profileImageId;
        data["title"] = this.title;
        data["forename"] = this.forename;
        data["surname"] = this.surname;
        data["gender"] = this.gender;
        data["nationality"] = this.nationality;
        data["email"] = this.email;
        data["designation"] = this.designation;
        data["mobileNumber"] = this.mobileNumber;
        data["residentialAddress"] = this.residentialAddress;
        data["userId"] = this.userId;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["profileImage"] = this.profileImage ? this.profileImage.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IContact {
    id?: number;
    profileImageId?: number | undefined;
    title?: string | undefined;
    forename?: string | undefined;
    surname?: string | undefined;
    gender?: string | undefined;
    nationality?: string | undefined;
    email?: string | undefined;
    designation?: string | undefined;
    mobileNumber?: string | undefined;
    residentialAddress?: string | undefined;
    userId?: string | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    profileImage?: ApplicationImage | undefined;
}

export class MemberContribution implements IMemberContribution {
    id?: number;
    memberId?: number;
    contributionItemId?: number;
    quantity?: number;
    equivalentAmount?: number;
    transactionId?: number | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    memberTransaction?: MemberTransaction | undefined;
    contributionItem?: ContributionItem | undefined;
    member?: Member | undefined;

    constructor(data?: IMemberContribution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.contributionItemId = _data["contributionItemId"];
            this.quantity = _data["quantity"];
            this.equivalentAmount = _data["equivalentAmount"];
            this.transactionId = _data["transactionId"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.memberTransaction = _data["memberTransaction"] ? MemberTransaction.fromJS(_data["memberTransaction"]) : <any>undefined;
            this.contributionItem = _data["contributionItem"] ? ContributionItem.fromJS(_data["contributionItem"]) : <any>undefined;
            this.member = _data["member"] ? Member.fromJS(_data["member"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MemberContribution {
        data = typeof data === 'object' ? data : {};
        let result = new MemberContribution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["contributionItemId"] = this.contributionItemId;
        data["quantity"] = this.quantity;
        data["equivalentAmount"] = this.equivalentAmount;
        data["transactionId"] = this.transactionId;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["memberTransaction"] = this.memberTransaction ? this.memberTransaction.toJSON() : <any>undefined;
        data["contributionItem"] = this.contributionItem ? this.contributionItem.toJSON() : <any>undefined;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMemberContribution {
    id?: number;
    memberId?: number;
    contributionItemId?: number;
    quantity?: number;
    equivalentAmount?: number;
    transactionId?: number | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    memberTransaction?: MemberTransaction | undefined;
    contributionItem?: ContributionItem | undefined;
    member?: Member | undefined;
}

export class ContributionItem implements IContributionItem {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    value?: number;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    memberContributions?: MemberContribution[] | undefined;

    constructor(data?: IContributionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.value = _data["value"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["memberContributions"])) {
                this.memberContributions = [] as any;
                for (let item of _data["memberContributions"])
                    this.memberContributions!.push(MemberContribution.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContributionItem {
        data = typeof data === 'object' ? data : {};
        let result = new ContributionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["value"] = this.value;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.memberContributions)) {
            data["memberContributions"] = [];
            for (let item of this.memberContributions)
                data["memberContributions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IContributionItem {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    value?: number;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    memberContributions?: MemberContribution[] | undefined;
}

export class MemberDocument implements IMemberDocument {
    id?: number;
    memberId?: number;
    documentTypeId?: number;
    documentName?: string | undefined;
    documentContent?: string | undefined;
    documentDescription?: string | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    member?: Member | undefined;
    documentType?: BusinessCategory | undefined;

    constructor(data?: IMemberDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentName = _data["documentName"];
            this.documentContent = _data["documentContent"];
            this.documentDescription = _data["documentDescription"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.member = _data["member"] ? Member.fromJS(_data["member"]) : <any>undefined;
            this.documentType = _data["documentType"] ? BusinessCategory.fromJS(_data["documentType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MemberDocument {
        data = typeof data === 'object' ? data : {};
        let result = new MemberDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["documentTypeId"] = this.documentTypeId;
        data["documentName"] = this.documentName;
        data["documentContent"] = this.documentContent;
        data["documentDescription"] = this.documentDescription;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMemberDocument {
    id?: number;
    memberId?: number;
    documentTypeId?: number;
    documentName?: string | undefined;
    documentContent?: string | undefined;
    documentDescription?: string | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    member?: Member | undefined;
    documentType?: BusinessCategory | undefined;
}

export class EmailProcess implements IEmailProcess {
    id?: number;
    memberId?: number;
    billType?: number;
    month?: string | undefined;
    year?: number;
    emailAddress?: string | undefined;
    emailSubject?: string | undefined;
    emailBody?: string | undefined;
    emailSent?: boolean;
    emailSentOn?: Date | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    billTypeNavigation?: BusinessCategory | undefined;
    member?: Member | undefined;

    constructor(data?: IEmailProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.billType = _data["billType"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.emailAddress = _data["emailAddress"];
            this.emailSubject = _data["emailSubject"];
            this.emailBody = _data["emailBody"];
            this.emailSent = _data["emailSent"];
            this.emailSentOn = _data["emailSentOn"] ? new Date(_data["emailSentOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.billTypeNavigation = _data["billTypeNavigation"] ? BusinessCategory.fromJS(_data["billTypeNavigation"]) : <any>undefined;
            this.member = _data["member"] ? Member.fromJS(_data["member"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmailProcess {
        data = typeof data === 'object' ? data : {};
        let result = new EmailProcess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["billType"] = this.billType;
        data["month"] = this.month;
        data["year"] = this.year;
        data["emailAddress"] = this.emailAddress;
        data["emailSubject"] = this.emailSubject;
        data["emailBody"] = this.emailBody;
        data["emailSent"] = this.emailSent;
        data["emailSentOn"] = this.emailSentOn ? this.emailSentOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["billTypeNavigation"] = this.billTypeNavigation ? this.billTypeNavigation.toJSON() : <any>undefined;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IEmailProcess {
    id?: number;
    memberId?: number;
    billType?: number;
    month?: string | undefined;
    year?: number;
    emailAddress?: string | undefined;
    emailSubject?: string | undefined;
    emailBody?: string | undefined;
    emailSent?: boolean;
    emailSentOn?: Date | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    billTypeNavigation?: BusinessCategory | undefined;
    member?: Member | undefined;
}

export class Order implements IOrder {
    id?: number;
    memberId?: number;
    orderDate?: Date;
    orderAmount?: number;
    isOpen?: boolean | undefined;
    statusId?: number;
    tableNumber?: string | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    member?: Member | undefined;
    status?: BusinessCategory | undefined;
    orderItems?: OrderItem[] | undefined;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.orderAmount = _data["orderAmount"];
            this.isOpen = _data["isOpen"];
            this.statusId = _data["statusId"];
            this.tableNumber = _data["tableNumber"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.member = _data["member"] ? Member.fromJS(_data["member"]) : <any>undefined;
            this.status = _data["status"] ? BusinessCategory.fromJS(_data["status"]) : <any>undefined;
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["orderAmount"] = this.orderAmount;
        data["isOpen"] = this.isOpen;
        data["statusId"] = this.statusId;
        data["tableNumber"] = this.tableNumber;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOrder {
    id?: number;
    memberId?: number;
    orderDate?: Date;
    orderAmount?: number;
    isOpen?: boolean | undefined;
    statusId?: number;
    tableNumber?: string | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    member?: Member | undefined;
    status?: BusinessCategory | undefined;
    orderItems?: OrderItem[] | undefined;
}

export class OrderItem implements IOrderItem {
    id?: number;
    orderId?: number;
    itemId?: number;
    batchNumber?: string | undefined;
    quantity?: number;
    statusId?: number;
    counterId?: number | undefined;
    counter?: Counters | undefined;
    item?: Item | undefined;
    order?: Order | undefined;
    status?: BusinessCategory | undefined;
    orderItemDetails?: OrderItemDetail[] | undefined;

    constructor(data?: IOrderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.itemId = _data["itemId"];
            this.batchNumber = _data["batchNumber"];
            this.quantity = _data["quantity"];
            this.statusId = _data["statusId"];
            this.counterId = _data["counterId"];
            this.counter = _data["counter"] ? Counters.fromJS(_data["counter"]) : <any>undefined;
            this.item = _data["item"] ? Item.fromJS(_data["item"]) : <any>undefined;
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.status = _data["status"] ? BusinessCategory.fromJS(_data["status"]) : <any>undefined;
            if (Array.isArray(_data["orderItemDetails"])) {
                this.orderItemDetails = [] as any;
                for (let item of _data["orderItemDetails"])
                    this.orderItemDetails!.push(OrderItemDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["itemId"] = this.itemId;
        data["batchNumber"] = this.batchNumber;
        data["quantity"] = this.quantity;
        data["statusId"] = this.statusId;
        data["counterId"] = this.counterId;
        data["counter"] = this.counter ? this.counter.toJSON() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItemDetails)) {
            data["orderItemDetails"] = [];
            for (let item of this.orderItemDetails)
                data["orderItemDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOrderItem {
    id?: number;
    orderId?: number;
    itemId?: number;
    batchNumber?: string | undefined;
    quantity?: number;
    statusId?: number;
    counterId?: number | undefined;
    counter?: Counters | undefined;
    item?: Item | undefined;
    order?: Order | undefined;
    status?: BusinessCategory | undefined;
    orderItemDetails?: OrderItemDetail[] | undefined;
}

export class Counters implements ICounters {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    typeId?: number;
    isActive?: boolean;
    isDefault?: boolean;
    type?: BusinessCategory | undefined;
    orderItems?: OrderItem[] | undefined;

    constructor(data?: ICounters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.typeId = _data["typeId"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
            this.type = _data["type"] ? BusinessCategory.fromJS(_data["type"]) : <any>undefined;
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Counters {
        data = typeof data === 'object' ? data : {};
        let result = new Counters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["typeId"] = this.typeId;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICounters {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    typeId?: number;
    isActive?: boolean;
    isDefault?: boolean;
    type?: BusinessCategory | undefined;
    orderItems?: OrderItem[] | undefined;
}

export class Item implements IItem {
    id?: number;
    categoryId?: number;
    name?: string | undefined;
    description?: string | undefined;
    unitId?: number;
    image?: string | undefined;
    imagePath?: string | undefined;
    isActive?: boolean;
    counterId?: number | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    unit?: Unit | undefined;
    category?: Category | undefined;
    counter?: BusinessCategory | undefined;
    discountItems?: DiscountItem[] | undefined;
    itemIngredients?: ItemIngredient[] | undefined;
    itemAttributes?: ItemAttribute[] | undefined;
    orderItems?: OrderItem[] | undefined;

    constructor(data?: IItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.unitId = _data["unitId"];
            this.image = _data["image"];
            this.imagePath = _data["imagePath"];
            this.isActive = _data["isActive"];
            this.counterId = _data["counterId"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
            this.category = _data["category"] ? Category.fromJS(_data["category"]) : <any>undefined;
            this.counter = _data["counter"] ? BusinessCategory.fromJS(_data["counter"]) : <any>undefined;
            if (Array.isArray(_data["discountItems"])) {
                this.discountItems = [] as any;
                for (let item of _data["discountItems"])
                    this.discountItems!.push(DiscountItem.fromJS(item));
            }
            if (Array.isArray(_data["itemIngredients"])) {
                this.itemIngredients = [] as any;
                for (let item of _data["itemIngredients"])
                    this.itemIngredients!.push(ItemIngredient.fromJS(item));
            }
            if (Array.isArray(_data["itemAttributes"])) {
                this.itemAttributes = [] as any;
                for (let item of _data["itemAttributes"])
                    this.itemAttributes!.push(ItemAttribute.fromJS(item));
            }
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Item {
        data = typeof data === 'object' ? data : {};
        let result = new Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["unitId"] = this.unitId;
        data["image"] = this.image;
        data["imagePath"] = this.imagePath;
        data["isActive"] = this.isActive;
        data["counterId"] = this.counterId;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["counter"] = this.counter ? this.counter.toJSON() : <any>undefined;
        if (Array.isArray(this.discountItems)) {
            data["discountItems"] = [];
            for (let item of this.discountItems)
                data["discountItems"].push(item.toJSON());
        }
        if (Array.isArray(this.itemIngredients)) {
            data["itemIngredients"] = [];
            for (let item of this.itemIngredients)
                data["itemIngredients"].push(item.toJSON());
        }
        if (Array.isArray(this.itemAttributes)) {
            data["itemAttributes"] = [];
            for (let item of this.itemAttributes)
                data["itemAttributes"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IItem {
    id?: number;
    categoryId?: number;
    name?: string | undefined;
    description?: string | undefined;
    unitId?: number;
    image?: string | undefined;
    imagePath?: string | undefined;
    isActive?: boolean;
    counterId?: number | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    unit?: Unit | undefined;
    category?: Category | undefined;
    counter?: BusinessCategory | undefined;
    discountItems?: DiscountItem[] | undefined;
    itemIngredients?: ItemIngredient[] | undefined;
    itemAttributes?: ItemAttribute[] | undefined;
    orderItems?: OrderItem[] | undefined;
}

export class Unit implements IUnit {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    items?: Item[] | undefined;
    stockItems?: StockItem[] | undefined;

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Item.fromJS(item));
            }
            if (Array.isArray(_data["stockItems"])) {
                this.stockItems = [] as any;
                for (let item of _data["stockItems"])
                    this.stockItems!.push(StockItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.stockItems)) {
            data["stockItems"] = [];
            for (let item of this.stockItems)
                data["stockItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUnit {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    items?: Item[] | undefined;
    stockItems?: StockItem[] | undefined;
}

export class StockItem implements IStockItem {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    stockCategoryId?: number;
    initialStockQuantity?: number | undefined;
    unitPrice?: number | undefined;
    stockUnitId?: number;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    stockCategory?: StockCategory | undefined;
    stockUnit?: Unit | undefined;
    dailyStoreStockItemConsumptions?: DailyStoreStockItemConsumption[] | undefined;
    stockItemTransferDetails?: StockItemTransferDetail[] | undefined;
    itemAttributes?: ItemAttribute[] | undefined;
    stockItemRegisterDetails?: StockItemRegisterDetail[] | undefined;

    constructor(data?: IStockItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.stockCategoryId = _data["stockCategoryId"];
            this.initialStockQuantity = _data["initialStockQuantity"];
            this.unitPrice = _data["unitPrice"];
            this.stockUnitId = _data["stockUnitId"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.stockCategory = _data["stockCategory"] ? StockCategory.fromJS(_data["stockCategory"]) : <any>undefined;
            this.stockUnit = _data["stockUnit"] ? Unit.fromJS(_data["stockUnit"]) : <any>undefined;
            if (Array.isArray(_data["dailyStoreStockItemConsumptions"])) {
                this.dailyStoreStockItemConsumptions = [] as any;
                for (let item of _data["dailyStoreStockItemConsumptions"])
                    this.dailyStoreStockItemConsumptions!.push(DailyStoreStockItemConsumption.fromJS(item));
            }
            if (Array.isArray(_data["stockItemTransferDetails"])) {
                this.stockItemTransferDetails = [] as any;
                for (let item of _data["stockItemTransferDetails"])
                    this.stockItemTransferDetails!.push(StockItemTransferDetail.fromJS(item));
            }
            if (Array.isArray(_data["itemAttributes"])) {
                this.itemAttributes = [] as any;
                for (let item of _data["itemAttributes"])
                    this.itemAttributes!.push(ItemAttribute.fromJS(item));
            }
            if (Array.isArray(_data["stockItemRegisterDetails"])) {
                this.stockItemRegisterDetails = [] as any;
                for (let item of _data["stockItemRegisterDetails"])
                    this.stockItemRegisterDetails!.push(StockItemRegisterDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockItem {
        data = typeof data === 'object' ? data : {};
        let result = new StockItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["stockCategoryId"] = this.stockCategoryId;
        data["initialStockQuantity"] = this.initialStockQuantity;
        data["unitPrice"] = this.unitPrice;
        data["stockUnitId"] = this.stockUnitId;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["stockCategory"] = this.stockCategory ? this.stockCategory.toJSON() : <any>undefined;
        data["stockUnit"] = this.stockUnit ? this.stockUnit.toJSON() : <any>undefined;
        if (Array.isArray(this.dailyStoreStockItemConsumptions)) {
            data["dailyStoreStockItemConsumptions"] = [];
            for (let item of this.dailyStoreStockItemConsumptions)
                data["dailyStoreStockItemConsumptions"].push(item.toJSON());
        }
        if (Array.isArray(this.stockItemTransferDetails)) {
            data["stockItemTransferDetails"] = [];
            for (let item of this.stockItemTransferDetails)
                data["stockItemTransferDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.itemAttributes)) {
            data["itemAttributes"] = [];
            for (let item of this.itemAttributes)
                data["itemAttributes"].push(item.toJSON());
        }
        if (Array.isArray(this.stockItemRegisterDetails)) {
            data["stockItemRegisterDetails"] = [];
            for (let item of this.stockItemRegisterDetails)
                data["stockItemRegisterDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStockItem {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    stockCategoryId?: number;
    initialStockQuantity?: number | undefined;
    unitPrice?: number | undefined;
    stockUnitId?: number;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    stockCategory?: StockCategory | undefined;
    stockUnit?: Unit | undefined;
    dailyStoreStockItemConsumptions?: DailyStoreStockItemConsumption[] | undefined;
    stockItemTransferDetails?: StockItemTransferDetail[] | undefined;
    itemAttributes?: ItemAttribute[] | undefined;
    stockItemRegisterDetails?: StockItemRegisterDetail[] | undefined;
}

export class StockCategory implements IStockCategory {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    parentId?: number | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    parent?: StockCategory | undefined;
    inverseParent?: StockCategory[] | undefined;
    stockItems?: StockItem[] | undefined;
    itemAttributes?: ItemAttribute[] | undefined;

    constructor(data?: IStockCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.parentId = _data["parentId"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.parent = _data["parent"] ? StockCategory.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["inverseParent"])) {
                this.inverseParent = [] as any;
                for (let item of _data["inverseParent"])
                    this.inverseParent!.push(StockCategory.fromJS(item));
            }
            if (Array.isArray(_data["stockItems"])) {
                this.stockItems = [] as any;
                for (let item of _data["stockItems"])
                    this.stockItems!.push(StockItem.fromJS(item));
            }
            if (Array.isArray(_data["itemAttributes"])) {
                this.itemAttributes = [] as any;
                for (let item of _data["itemAttributes"])
                    this.itemAttributes!.push(ItemAttribute.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockCategory {
        data = typeof data === 'object' ? data : {};
        let result = new StockCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentId"] = this.parentId;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.inverseParent)) {
            data["inverseParent"] = [];
            for (let item of this.inverseParent)
                data["inverseParent"].push(item.toJSON());
        }
        if (Array.isArray(this.stockItems)) {
            data["stockItems"] = [];
            for (let item of this.stockItems)
                data["stockItems"].push(item.toJSON());
        }
        if (Array.isArray(this.itemAttributes)) {
            data["itemAttributes"] = [];
            for (let item of this.itemAttributes)
                data["itemAttributes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStockCategory {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    parentId?: number | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    parent?: StockCategory | undefined;
    inverseParent?: StockCategory[] | undefined;
    stockItems?: StockItem[] | undefined;
    itemAttributes?: ItemAttribute[] | undefined;
}

export class ItemAttribute implements IItemAttribute {
    id?: number;
    itemId?: number;
    attributesId?: number;
    stockItemId?: number | undefined;
    stockCategoryId?: number | undefined;
    price?: number;
    quantity?: number | undefined;
    isDefault?: boolean;
    attribute?: Attribute | undefined;
    item?: Item | undefined;
    stockItem?: StockItem | undefined;
    stockCategory?: StockCategory | undefined;
    orderItemDetails?: OrderItemDetail[] | undefined;

    constructor(data?: IItemAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemId = _data["itemId"];
            this.attributesId = _data["attributesId"];
            this.stockItemId = _data["stockItemId"];
            this.stockCategoryId = _data["stockCategoryId"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.isDefault = _data["isDefault"];
            this.attribute = _data["attribute"] ? Attribute.fromJS(_data["attribute"]) : <any>undefined;
            this.item = _data["item"] ? Item.fromJS(_data["item"]) : <any>undefined;
            this.stockItem = _data["stockItem"] ? StockItem.fromJS(_data["stockItem"]) : <any>undefined;
            this.stockCategory = _data["stockCategory"] ? StockCategory.fromJS(_data["stockCategory"]) : <any>undefined;
            if (Array.isArray(_data["orderItemDetails"])) {
                this.orderItemDetails = [] as any;
                for (let item of _data["orderItemDetails"])
                    this.orderItemDetails!.push(OrderItemDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ItemAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new ItemAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemId"] = this.itemId;
        data["attributesId"] = this.attributesId;
        data["stockItemId"] = this.stockItemId;
        data["stockCategoryId"] = this.stockCategoryId;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["isDefault"] = this.isDefault;
        data["attribute"] = this.attribute ? this.attribute.toJSON() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["stockItem"] = this.stockItem ? this.stockItem.toJSON() : <any>undefined;
        data["stockCategory"] = this.stockCategory ? this.stockCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItemDetails)) {
            data["orderItemDetails"] = [];
            for (let item of this.orderItemDetails)
                data["orderItemDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IItemAttribute {
    id?: number;
    itemId?: number;
    attributesId?: number;
    stockItemId?: number | undefined;
    stockCategoryId?: number | undefined;
    price?: number;
    quantity?: number | undefined;
    isDefault?: boolean;
    attribute?: Attribute | undefined;
    item?: Item | undefined;
    stockItem?: StockItem | undefined;
    stockCategory?: StockCategory | undefined;
    orderItemDetails?: OrderItemDetail[] | undefined;
}

export class Attribute implements IAttribute {
    id?: number;
    name?: string | undefined;
    typeId?: number;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date;
    type?: BusinessCategory | undefined;
    itemAttributes?: ItemAttribute[] | undefined;

    constructor(data?: IAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.type = _data["type"] ? BusinessCategory.fromJS(_data["type"]) : <any>undefined;
            if (Array.isArray(_data["itemAttributes"])) {
                this.itemAttributes = [] as any;
                for (let item of _data["itemAttributes"])
                    this.itemAttributes!.push(ItemAttribute.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Attribute {
        data = typeof data === 'object' ? data : {};
        let result = new Attribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        if (Array.isArray(this.itemAttributes)) {
            data["itemAttributes"] = [];
            for (let item of this.itemAttributes)
                data["itemAttributes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAttribute {
    id?: number;
    name?: string | undefined;
    typeId?: number;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date;
    type?: BusinessCategory | undefined;
    itemAttributes?: ItemAttribute[] | undefined;
}

export class OrderItemDetail implements IOrderItemDetail {
    id?: number;
    orderItemId?: number;
    itemAttributeId?: number;
    price?: number;
    itemAttribute?: ItemAttribute | undefined;
    orderItem?: OrderItem | undefined;

    constructor(data?: IOrderItemDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderItemId = _data["orderItemId"];
            this.itemAttributeId = _data["itemAttributeId"];
            this.price = _data["price"];
            this.itemAttribute = _data["itemAttribute"] ? ItemAttribute.fromJS(_data["itemAttribute"]) : <any>undefined;
            this.orderItem = _data["orderItem"] ? OrderItem.fromJS(_data["orderItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderItemDetail {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderItemId"] = this.orderItemId;
        data["itemAttributeId"] = this.itemAttributeId;
        data["price"] = this.price;
        data["itemAttribute"] = this.itemAttribute ? this.itemAttribute.toJSON() : <any>undefined;
        data["orderItem"] = this.orderItem ? this.orderItem.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IOrderItemDetail {
    id?: number;
    orderItemId?: number;
    itemAttributeId?: number;
    price?: number;
    itemAttribute?: ItemAttribute | undefined;
    orderItem?: OrderItem | undefined;
}

export class DailyStoreStockItemConsumption implements IDailyStoreStockItemConsumption {
    id?: number;
    stockStoreId?: number | undefined;
    stockItemId?: number | undefined;
    quantity?: number | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    stockItem?: StockItem | undefined;

    constructor(data?: IDailyStoreStockItemConsumption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stockStoreId = _data["stockStoreId"];
            this.stockItemId = _data["stockItemId"];
            this.quantity = _data["quantity"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.stockItem = _data["stockItem"] ? StockItem.fromJS(_data["stockItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DailyStoreStockItemConsumption {
        data = typeof data === 'object' ? data : {};
        let result = new DailyStoreStockItemConsumption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stockStoreId"] = this.stockStoreId;
        data["stockItemId"] = this.stockItemId;
        data["quantity"] = this.quantity;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["stockItem"] = this.stockItem ? this.stockItem.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDailyStoreStockItemConsumption {
    id?: number;
    stockStoreId?: number | undefined;
    stockItemId?: number | undefined;
    quantity?: number | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    stockItem?: StockItem | undefined;
}

export class StockItemTransferDetail implements IStockItemTransferDetail {
    id?: number;
    stockItemTransferId?: number | undefined;
    stockItemId?: number | undefined;
    quantity?: number | undefined;
    stockItem?: StockItem | undefined;
    stockItemTransfer?: StockItemTransfer | undefined;

    constructor(data?: IStockItemTransferDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stockItemTransferId = _data["stockItemTransferId"];
            this.stockItemId = _data["stockItemId"];
            this.quantity = _data["quantity"];
            this.stockItem = _data["stockItem"] ? StockItem.fromJS(_data["stockItem"]) : <any>undefined;
            this.stockItemTransfer = _data["stockItemTransfer"] ? StockItemTransfer.fromJS(_data["stockItemTransfer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StockItemTransferDetail {
        data = typeof data === 'object' ? data : {};
        let result = new StockItemTransferDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stockItemTransferId"] = this.stockItemTransferId;
        data["stockItemId"] = this.stockItemId;
        data["quantity"] = this.quantity;
        data["stockItem"] = this.stockItem ? this.stockItem.toJSON() : <any>undefined;
        data["stockItemTransfer"] = this.stockItemTransfer ? this.stockItemTransfer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IStockItemTransferDetail {
    id?: number;
    stockItemTransferId?: number | undefined;
    stockItemId?: number | undefined;
    quantity?: number | undefined;
    stockItem?: StockItem | undefined;
    stockItemTransfer?: StockItemTransfer | undefined;
}

export class StockItemTransfer implements IStockItemTransfer {
    id?: number;
    fromStoreId?: number;
    toStoreId?: number;
    description?: string | undefined;
    transferDate?: Date | undefined;
    statusId?: number | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    fromStore?: Store | undefined;
    toStore?: Store | undefined;
    stockItemTransferDetails?: StockItemTransferDetail[] | undefined;

    constructor(data?: IStockItemTransfer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromStoreId = _data["fromStoreId"];
            this.toStoreId = _data["toStoreId"];
            this.description = _data["description"];
            this.transferDate = _data["transferDate"] ? new Date(_data["transferDate"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.fromStore = _data["fromStore"] ? Store.fromJS(_data["fromStore"]) : <any>undefined;
            this.toStore = _data["toStore"] ? Store.fromJS(_data["toStore"]) : <any>undefined;
            if (Array.isArray(_data["stockItemTransferDetails"])) {
                this.stockItemTransferDetails = [] as any;
                for (let item of _data["stockItemTransferDetails"])
                    this.stockItemTransferDetails!.push(StockItemTransferDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockItemTransfer {
        data = typeof data === 'object' ? data : {};
        let result = new StockItemTransfer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromStoreId"] = this.fromStoreId;
        data["toStoreId"] = this.toStoreId;
        data["description"] = this.description;
        data["transferDate"] = this.transferDate ? this.transferDate.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["fromStore"] = this.fromStore ? this.fromStore.toJSON() : <any>undefined;
        data["toStore"] = this.toStore ? this.toStore.toJSON() : <any>undefined;
        if (Array.isArray(this.stockItemTransferDetails)) {
            data["stockItemTransferDetails"] = [];
            for (let item of this.stockItemTransferDetails)
                data["stockItemTransferDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStockItemTransfer {
    id?: number;
    fromStoreId?: number;
    toStoreId?: number;
    description?: string | undefined;
    transferDate?: Date | undefined;
    statusId?: number | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    fromStore?: Store | undefined;
    toStore?: Store | undefined;
    stockItemTransferDetails?: StockItemTransferDetail[] | undefined;
}

export class Store implements IStore {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    stockItemRegistersToStore?: StockItemRegister[] | undefined;
    stockItemRegistersStore?: StockItemRegister[] | undefined;
    stockItemTransfersFromStore?: StockItemTransfer[] | undefined;
    stockItemTransfersToStore?: StockItemTransfer[] | undefined;

    constructor(data?: IStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["stockItemRegistersToStore"])) {
                this.stockItemRegistersToStore = [] as any;
                for (let item of _data["stockItemRegistersToStore"])
                    this.stockItemRegistersToStore!.push(StockItemRegister.fromJS(item));
            }
            if (Array.isArray(_data["stockItemRegistersStore"])) {
                this.stockItemRegistersStore = [] as any;
                for (let item of _data["stockItemRegistersStore"])
                    this.stockItemRegistersStore!.push(StockItemRegister.fromJS(item));
            }
            if (Array.isArray(_data["stockItemTransfersFromStore"])) {
                this.stockItemTransfersFromStore = [] as any;
                for (let item of _data["stockItemTransfersFromStore"])
                    this.stockItemTransfersFromStore!.push(StockItemTransfer.fromJS(item));
            }
            if (Array.isArray(_data["stockItemTransfersToStore"])) {
                this.stockItemTransfersToStore = [] as any;
                for (let item of _data["stockItemTransfersToStore"])
                    this.stockItemTransfersToStore!.push(StockItemTransfer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Store {
        data = typeof data === 'object' ? data : {};
        let result = new Store();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.stockItemRegistersToStore)) {
            data["stockItemRegistersToStore"] = [];
            for (let item of this.stockItemRegistersToStore)
                data["stockItemRegistersToStore"].push(item.toJSON());
        }
        if (Array.isArray(this.stockItemRegistersStore)) {
            data["stockItemRegistersStore"] = [];
            for (let item of this.stockItemRegistersStore)
                data["stockItemRegistersStore"].push(item.toJSON());
        }
        if (Array.isArray(this.stockItemTransfersFromStore)) {
            data["stockItemTransfersFromStore"] = [];
            for (let item of this.stockItemTransfersFromStore)
                data["stockItemTransfersFromStore"].push(item.toJSON());
        }
        if (Array.isArray(this.stockItemTransfersToStore)) {
            data["stockItemTransfersToStore"] = [];
            for (let item of this.stockItemTransfersToStore)
                data["stockItemTransfersToStore"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStore {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    stockItemRegistersToStore?: StockItemRegister[] | undefined;
    stockItemRegistersStore?: StockItemRegister[] | undefined;
    stockItemTransfersFromStore?: StockItemTransfer[] | undefined;
    stockItemTransfersToStore?: StockItemTransfer[] | undefined;
}

export class StockItemRegister implements IStockItemRegister {
    id?: number;
    storeId?: number | undefined;
    fromStoreId?: number | undefined;
    registerTypeId?: number;
    registerDate?: Date;
    registerReference?: string | undefined;
    note?: string | undefined;
    statusId?: number;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    toStore?: Store | undefined;
    registerType?: BusinessCategory | undefined;
    status?: BusinessCategory | undefined;
    store?: Store | undefined;
    stockItemRegisterDetails?: StockItemRegisterDetail[] | undefined;

    constructor(data?: IStockItemRegister) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.fromStoreId = _data["fromStoreId"];
            this.registerTypeId = _data["registerTypeId"];
            this.registerDate = _data["registerDate"] ? new Date(_data["registerDate"].toString()) : <any>undefined;
            this.registerReference = _data["registerReference"];
            this.note = _data["note"];
            this.statusId = _data["statusId"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.toStore = _data["toStore"] ? Store.fromJS(_data["toStore"]) : <any>undefined;
            this.registerType = _data["registerType"] ? BusinessCategory.fromJS(_data["registerType"]) : <any>undefined;
            this.status = _data["status"] ? BusinessCategory.fromJS(_data["status"]) : <any>undefined;
            this.store = _data["store"] ? Store.fromJS(_data["store"]) : <any>undefined;
            if (Array.isArray(_data["stockItemRegisterDetails"])) {
                this.stockItemRegisterDetails = [] as any;
                for (let item of _data["stockItemRegisterDetails"])
                    this.stockItemRegisterDetails!.push(StockItemRegisterDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockItemRegister {
        data = typeof data === 'object' ? data : {};
        let result = new StockItemRegister();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["fromStoreId"] = this.fromStoreId;
        data["registerTypeId"] = this.registerTypeId;
        data["registerDate"] = this.registerDate ? this.registerDate.toISOString() : <any>undefined;
        data["registerReference"] = this.registerReference;
        data["note"] = this.note;
        data["statusId"] = this.statusId;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["toStore"] = this.toStore ? this.toStore.toJSON() : <any>undefined;
        data["registerType"] = this.registerType ? this.registerType.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        if (Array.isArray(this.stockItemRegisterDetails)) {
            data["stockItemRegisterDetails"] = [];
            for (let item of this.stockItemRegisterDetails)
                data["stockItemRegisterDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStockItemRegister {
    id?: number;
    storeId?: number | undefined;
    fromStoreId?: number | undefined;
    registerTypeId?: number;
    registerDate?: Date;
    registerReference?: string | undefined;
    note?: string | undefined;
    statusId?: number;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    toStore?: Store | undefined;
    registerType?: BusinessCategory | undefined;
    status?: BusinessCategory | undefined;
    store?: Store | undefined;
    stockItemRegisterDetails?: StockItemRegisterDetail[] | undefined;
}

export class StockItemRegisterDetail implements IStockItemRegisterDetail {
    id?: number;
    stockRegisterId?: number;
    storeId?: number;
    stockItemId?: number;
    quantity?: number;
    price?: number | undefined;
    pricePerQuantity?: number | undefined;
    registerTypeId?: number;
    stockItemRegister?: StockItemRegister | undefined;
    stockItem?: StockItem | undefined;

    constructor(data?: IStockItemRegisterDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stockRegisterId = _data["stockRegisterId"];
            this.storeId = _data["storeId"];
            this.stockItemId = _data["stockItemId"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.pricePerQuantity = _data["pricePerQuantity"];
            this.registerTypeId = _data["registerTypeId"];
            this.stockItemRegister = _data["stockItemRegister"] ? StockItemRegister.fromJS(_data["stockItemRegister"]) : <any>undefined;
            this.stockItem = _data["stockItem"] ? StockItem.fromJS(_data["stockItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StockItemRegisterDetail {
        data = typeof data === 'object' ? data : {};
        let result = new StockItemRegisterDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stockRegisterId"] = this.stockRegisterId;
        data["storeId"] = this.storeId;
        data["stockItemId"] = this.stockItemId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["pricePerQuantity"] = this.pricePerQuantity;
        data["registerTypeId"] = this.registerTypeId;
        data["stockItemRegister"] = this.stockItemRegister ? this.stockItemRegister.toJSON() : <any>undefined;
        data["stockItem"] = this.stockItem ? this.stockItem.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IStockItemRegisterDetail {
    id?: number;
    stockRegisterId?: number;
    storeId?: number;
    stockItemId?: number;
    quantity?: number;
    price?: number | undefined;
    pricePerQuantity?: number | undefined;
    registerTypeId?: number;
    stockItemRegister?: StockItemRegister | undefined;
    stockItem?: StockItem | undefined;
}

export class Category implements ICategory {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    parentId?: number | undefined;
    imagePath?: string | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date;
    categoryImage?: CategoryImage | undefined;
    parent?: Category | undefined;
    inverseParent?: Category[] | undefined;
    items?: Item[] | undefined;

    constructor(data?: ICategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.parentId = _data["parentId"];
            this.imagePath = _data["imagePath"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.categoryImage = _data["categoryImage"] ? CategoryImage.fromJS(_data["categoryImage"]) : <any>undefined;
            this.parent = _data["parent"] ? Category.fromJS(_data["parent"]) : <any>undefined;
            if (Array.isArray(_data["inverseParent"])) {
                this.inverseParent = [] as any;
                for (let item of _data["inverseParent"])
                    this.inverseParent!.push(Category.fromJS(item));
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Item.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentId"] = this.parentId;
        data["imagePath"] = this.imagePath;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["categoryImage"] = this.categoryImage ? this.categoryImage.toJSON() : <any>undefined;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        if (Array.isArray(this.inverseParent)) {
            data["inverseParent"] = [];
            for (let item of this.inverseParent)
                data["inverseParent"].push(item.toJSON());
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICategory {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    parentId?: number | undefined;
    imagePath?: string | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date;
    categoryImage?: CategoryImage | undefined;
    parent?: Category | undefined;
    inverseParent?: Category[] | undefined;
    items?: Item[] | undefined;
}

export class CategoryImage implements ICategoryImage {
    id?: number;
    image?: string | undefined;

    constructor(data?: ICategoryImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): CategoryImage {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["image"] = this.image;
        return data; 
    }
}

export interface ICategoryImage {
    id?: number;
    image?: string | undefined;
}

export class DiscountItem implements IDiscountItem {
    id?: number;
    discountId?: number;
    itemId?: number;
    discount?: Discount | undefined;
    item?: Item | undefined;

    constructor(data?: IDiscountItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.discountId = _data["discountId"];
            this.itemId = _data["itemId"];
            this.discount = _data["discount"] ? Discount.fromJS(_data["discount"]) : <any>undefined;
            this.item = _data["item"] ? Item.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DiscountItem {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["discountId"] = this.discountId;
        data["itemId"] = this.itemId;
        data["discount"] = this.discount ? this.discount.toJSON() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDiscountItem {
    id?: number;
    discountId?: number;
    itemId?: number;
    discount?: Discount | undefined;
    item?: Item | undefined;
}

export class Discount implements IDiscount {
    id?: number;
    day?: string | undefined;
    startTime?: string;
    endTime?: string;
    ratePercentage?: number;
    effectiveDate?: Date;
    expireDate?: Date;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date;
    discountItems?: DiscountItem[] | undefined;

    constructor(data?: IDiscount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.day = _data["day"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.ratePercentage = _data["ratePercentage"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? new Date(_data["expireDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["discountItems"])) {
                this.discountItems = [] as any;
                for (let item of _data["discountItems"])
                    this.discountItems!.push(DiscountItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Discount {
        data = typeof data === 'object' ? data : {};
        let result = new Discount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["day"] = this.day;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["ratePercentage"] = this.ratePercentage;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.discountItems)) {
            data["discountItems"] = [];
            for (let item of this.discountItems)
                data["discountItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDiscount {
    id?: number;
    day?: string | undefined;
    startTime?: string;
    endTime?: string;
    ratePercentage?: number;
    effectiveDate?: Date;
    expireDate?: Date;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date;
    discountItems?: DiscountItem[] | undefined;
}

export class ItemIngredient implements IItemIngredient {
    id?: number;
    itemId?: number;
    ingredientsId?: number;
    ingredient?: Ingredient | undefined;
    item?: Item | undefined;

    constructor(data?: IItemIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemId = _data["itemId"];
            this.ingredientsId = _data["ingredientsId"];
            this.ingredient = _data["ingredient"] ? Ingredient.fromJS(_data["ingredient"]) : <any>undefined;
            this.item = _data["item"] ? Item.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemIngredient {
        data = typeof data === 'object' ? data : {};
        let result = new ItemIngredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemId"] = this.itemId;
        data["ingredientsId"] = this.ingredientsId;
        data["ingredient"] = this.ingredient ? this.ingredient.toJSON() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IItemIngredient {
    id?: number;
    itemId?: number;
    ingredientsId?: number;
    ingredient?: Ingredient | undefined;
    item?: Item | undefined;
}

export class Ingredient implements IIngredient {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date;
    itemIngredients?: ItemIngredient[] | undefined;

    constructor(data?: IIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["itemIngredients"])) {
                this.itemIngredients = [] as any;
                for (let item of _data["itemIngredients"])
                    this.itemIngredients!.push(ItemIngredient.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Ingredient {
        data = typeof data === 'object' ? data : {};
        let result = new Ingredient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.itemIngredients)) {
            data["itemIngredients"] = [];
            for (let item of this.itemIngredients)
                data["itemIngredients"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIngredient {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date;
    itemIngredients?: ItemIngredient[] | undefined;
}

export class TennisSlotBooking implements ITennisSlotBooking {
    id?: number;
    memberId?: number;
    bookedForMemberId?: number | undefined;
    isBookedForChildren?: boolean;
    isBookedForMarker?: boolean;
    isBookedForRacket?: boolean;
    isBookedForNoShow?: boolean;
    isBookedForHoliday?: boolean;
    isBookedForLadies?: boolean;
    bookingDate?: Date;
    courtId?: number;
    slotId?: number;
    courtFee?: number;
    markersFee?: number;
    racketRentalCount?: number;
    racketRentalCharge?: number;
    noShowCharge?: number;
    totalCharge?: number;
    statusId?: number;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    court?: TennisCourt | undefined;
    slot?: TennisBookingSlot | undefined;
    member?: Member | undefined;
    bookedForMember?: Member | undefined;
    bookingStatus?: BusinessCategory | undefined;

    constructor(data?: ITennisSlotBooking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.bookedForMemberId = _data["bookedForMemberId"];
            this.isBookedForChildren = _data["isBookedForChildren"];
            this.isBookedForMarker = _data["isBookedForMarker"];
            this.isBookedForRacket = _data["isBookedForRacket"];
            this.isBookedForNoShow = _data["isBookedForNoShow"];
            this.isBookedForHoliday = _data["isBookedForHoliday"];
            this.isBookedForLadies = _data["isBookedForLadies"];
            this.bookingDate = _data["bookingDate"] ? new Date(_data["bookingDate"].toString()) : <any>undefined;
            this.courtId = _data["courtId"];
            this.slotId = _data["slotId"];
            this.courtFee = _data["courtFee"];
            this.markersFee = _data["markersFee"];
            this.racketRentalCount = _data["racketRentalCount"];
            this.racketRentalCharge = _data["racketRentalCharge"];
            this.noShowCharge = _data["noShowCharge"];
            this.totalCharge = _data["totalCharge"];
            this.statusId = _data["statusId"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.court = _data["court"] ? TennisCourt.fromJS(_data["court"]) : <any>undefined;
            this.slot = _data["slot"] ? TennisBookingSlot.fromJS(_data["slot"]) : <any>undefined;
            this.member = _data["member"] ? Member.fromJS(_data["member"]) : <any>undefined;
            this.bookedForMember = _data["bookedForMember"] ? Member.fromJS(_data["bookedForMember"]) : <any>undefined;
            this.bookingStatus = _data["bookingStatus"] ? BusinessCategory.fromJS(_data["bookingStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TennisSlotBooking {
        data = typeof data === 'object' ? data : {};
        let result = new TennisSlotBooking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["bookedForMemberId"] = this.bookedForMemberId;
        data["isBookedForChildren"] = this.isBookedForChildren;
        data["isBookedForMarker"] = this.isBookedForMarker;
        data["isBookedForRacket"] = this.isBookedForRacket;
        data["isBookedForNoShow"] = this.isBookedForNoShow;
        data["isBookedForHoliday"] = this.isBookedForHoliday;
        data["isBookedForLadies"] = this.isBookedForLadies;
        data["bookingDate"] = this.bookingDate ? this.bookingDate.toISOString() : <any>undefined;
        data["courtId"] = this.courtId;
        data["slotId"] = this.slotId;
        data["courtFee"] = this.courtFee;
        data["markersFee"] = this.markersFee;
        data["racketRentalCount"] = this.racketRentalCount;
        data["racketRentalCharge"] = this.racketRentalCharge;
        data["noShowCharge"] = this.noShowCharge;
        data["totalCharge"] = this.totalCharge;
        data["statusId"] = this.statusId;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["court"] = this.court ? this.court.toJSON() : <any>undefined;
        data["slot"] = this.slot ? this.slot.toJSON() : <any>undefined;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["bookedForMember"] = this.bookedForMember ? this.bookedForMember.toJSON() : <any>undefined;
        data["bookingStatus"] = this.bookingStatus ? this.bookingStatus.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITennisSlotBooking {
    id?: number;
    memberId?: number;
    bookedForMemberId?: number | undefined;
    isBookedForChildren?: boolean;
    isBookedForMarker?: boolean;
    isBookedForRacket?: boolean;
    isBookedForNoShow?: boolean;
    isBookedForHoliday?: boolean;
    isBookedForLadies?: boolean;
    bookingDate?: Date;
    courtId?: number;
    slotId?: number;
    courtFee?: number;
    markersFee?: number;
    racketRentalCount?: number;
    racketRentalCharge?: number;
    noShowCharge?: number;
    totalCharge?: number;
    statusId?: number;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    court?: TennisCourt | undefined;
    slot?: TennisBookingSlot | undefined;
    member?: Member | undefined;
    bookedForMember?: Member | undefined;
    bookingStatus?: BusinessCategory | undefined;
}

export class TennisCourt implements ITennisCourt {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    tennisSlotBooking?: TennisSlotBooking[] | undefined;

    constructor(data?: ITennisCourt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["tennisSlotBooking"])) {
                this.tennisSlotBooking = [] as any;
                for (let item of _data["tennisSlotBooking"])
                    this.tennisSlotBooking!.push(TennisSlotBooking.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TennisCourt {
        data = typeof data === 'object' ? data : {};
        let result = new TennisCourt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.tennisSlotBooking)) {
            data["tennisSlotBooking"] = [];
            for (let item of this.tennisSlotBooking)
                data["tennisSlotBooking"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITennisCourt {
    id?: number;
    name?: string | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    tennisSlotBooking?: TennisSlotBooking[] | undefined;
}

export class TennisBookingSlot implements ITennisBookingSlot {
    id?: number;
    startTime?: string;
    endTime?: string;
    shiftId?: number;
    tennisShift?: BusinessCategory | undefined;
    tennisFeeSettings?: TennisFeeSetting[] | undefined;
    tennisSlotBookings?: TennisSlotBooking[] | undefined;

    constructor(data?: ITennisBookingSlot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.shiftId = _data["shiftId"];
            this.tennisShift = _data["tennisShift"] ? BusinessCategory.fromJS(_data["tennisShift"]) : <any>undefined;
            if (Array.isArray(_data["tennisFeeSettings"])) {
                this.tennisFeeSettings = [] as any;
                for (let item of _data["tennisFeeSettings"])
                    this.tennisFeeSettings!.push(TennisFeeSetting.fromJS(item));
            }
            if (Array.isArray(_data["tennisSlotBookings"])) {
                this.tennisSlotBookings = [] as any;
                for (let item of _data["tennisSlotBookings"])
                    this.tennisSlotBookings!.push(TennisSlotBooking.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TennisBookingSlot {
        data = typeof data === 'object' ? data : {};
        let result = new TennisBookingSlot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["shiftId"] = this.shiftId;
        data["tennisShift"] = this.tennisShift ? this.tennisShift.toJSON() : <any>undefined;
        if (Array.isArray(this.tennisFeeSettings)) {
            data["tennisFeeSettings"] = [];
            for (let item of this.tennisFeeSettings)
                data["tennisFeeSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.tennisSlotBookings)) {
            data["tennisSlotBookings"] = [];
            for (let item of this.tennisSlotBookings)
                data["tennisSlotBookings"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITennisBookingSlot {
    id?: number;
    startTime?: string;
    endTime?: string;
    shiftId?: number;
    tennisShift?: BusinessCategory | undefined;
    tennisFeeSettings?: TennisFeeSetting[] | undefined;
    tennisSlotBookings?: TennisSlotBooking[] | undefined;
}

export class TennisFeeSetting implements ITennisFeeSetting {
    id?: number;
    dayId?: number;
    slotId?: number;
    regularCourtFee?: number;
    openTennisHourCourtFee?: number;
    openLadiesTennisHourCourtFee?: number;
    childrenCourtFee?: number;
    holidayCourtFee?: number;
    markersFee?: number;
    tennisRacketRent?: number;
    noShowCharge?: number;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    slot?: TennisBookingSlot | undefined;
    day?: BusinessCategory | undefined;

    constructor(data?: ITennisFeeSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dayId = _data["dayId"];
            this.slotId = _data["slotId"];
            this.regularCourtFee = _data["regularCourtFee"];
            this.openTennisHourCourtFee = _data["openTennisHourCourtFee"];
            this.openLadiesTennisHourCourtFee = _data["openLadiesTennisHourCourtFee"];
            this.childrenCourtFee = _data["childrenCourtFee"];
            this.holidayCourtFee = _data["holidayCourtFee"];
            this.markersFee = _data["markersFee"];
            this.tennisRacketRent = _data["tennisRacketRent"];
            this.noShowCharge = _data["noShowCharge"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.slot = _data["slot"] ? TennisBookingSlot.fromJS(_data["slot"]) : <any>undefined;
            this.day = _data["day"] ? BusinessCategory.fromJS(_data["day"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TennisFeeSetting {
        data = typeof data === 'object' ? data : {};
        let result = new TennisFeeSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dayId"] = this.dayId;
        data["slotId"] = this.slotId;
        data["regularCourtFee"] = this.regularCourtFee;
        data["openTennisHourCourtFee"] = this.openTennisHourCourtFee;
        data["openLadiesTennisHourCourtFee"] = this.openLadiesTennisHourCourtFee;
        data["childrenCourtFee"] = this.childrenCourtFee;
        data["holidayCourtFee"] = this.holidayCourtFee;
        data["markersFee"] = this.markersFee;
        data["tennisRacketRent"] = this.tennisRacketRent;
        data["noShowCharge"] = this.noShowCharge;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["slot"] = this.slot ? this.slot.toJSON() : <any>undefined;
        data["day"] = this.day ? this.day.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITennisFeeSetting {
    id?: number;
    dayId?: number;
    slotId?: number;
    regularCourtFee?: number;
    openTennisHourCourtFee?: number;
    openLadiesTennisHourCourtFee?: number;
    childrenCourtFee?: number;
    holidayCourtFee?: number;
    markersFee?: number;
    tennisRacketRent?: number;
    noShowCharge?: number;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    slot?: TennisBookingSlot | undefined;
    day?: BusinessCategory | undefined;
}

export class TipsoiLog implements ITipsoiLog {
    id?: number;
    memberId?: number | undefined;
    inTime?: Date | undefined;
    enterTypeId?: number | undefined;
    enterType?: BusinessCategory | undefined;
    member?: Member | undefined;

    constructor(data?: ITipsoiLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.enterTypeId = _data["enterTypeId"];
            this.enterType = _data["enterType"] ? BusinessCategory.fromJS(_data["enterType"]) : <any>undefined;
            this.member = _data["member"] ? Member.fromJS(_data["member"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TipsoiLog {
        data = typeof data === 'object' ? data : {};
        let result = new TipsoiLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["enterTypeId"] = this.enterTypeId;
        data["enterType"] = this.enterType ? this.enterType.toJSON() : <any>undefined;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITipsoiLog {
    id?: number;
    memberId?: number | undefined;
    inTime?: Date | undefined;
    enterTypeId?: number | undefined;
    enterType?: BusinessCategory | undefined;
    member?: Member | undefined;
}

export class BusinessCategoryType implements IBusinessCategoryType {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
    businessCategories?: BusinessCategory[] | undefined;

    constructor(data?: IBusinessCategoryType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["businessCategories"])) {
                this.businessCategories = [] as any;
                for (let item of _data["businessCategories"])
                    this.businessCategories!.push(BusinessCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BusinessCategoryType {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessCategoryType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.businessCategories)) {
            data["businessCategories"] = [];
            for (let item of this.businessCategories)
                data["businessCategories"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IBusinessCategoryType {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
    businessCategories?: BusinessCategory[] | undefined;
}

export class SystemReport implements ISystemReport {
    id?: number;
    businessProfileId?: number | undefined;
    moduleId?: number;
    name?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    reportTypeId?: number;
    reportMapTypeId?: number | undefined;
    layout?: string | undefined;
    sampleJsonDataSource?: string | undefined;
    parameterOptionDataSourceUrl?: string | undefined;
    reportDataServiceUrl?: string | undefined;
    parentReportId?: number | undefined;
    isActive?: boolean | undefined;
    isDefault?: boolean;
    createdDateTime?: Date;
    createdBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    lastModifiedBy?: string | undefined;
    module?: BusinessCategory | undefined;
    parentReport?: SystemReport | undefined;
    reportType?: BusinessCategory | undefined;
    reportMapType?: BusinessCategory | undefined;
    inverseParentReport?: SystemReport[] | undefined;
    systemReportParams?: SystemReportParam[] | undefined;

    constructor(data?: ISystemReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessProfileId = _data["businessProfileId"];
            this.moduleId = _data["moduleId"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.reportTypeId = _data["reportTypeId"];
            this.reportMapTypeId = _data["reportMapTypeId"];
            this.layout = _data["layout"];
            this.sampleJsonDataSource = _data["sampleJsonDataSource"];
            this.parameterOptionDataSourceUrl = _data["parameterOptionDataSourceUrl"];
            this.reportDataServiceUrl = _data["reportDataServiceUrl"];
            this.parentReportId = _data["parentReportId"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.module = _data["module"] ? BusinessCategory.fromJS(_data["module"]) : <any>undefined;
            this.parentReport = _data["parentReport"] ? SystemReport.fromJS(_data["parentReport"]) : <any>undefined;
            this.reportType = _data["reportType"] ? BusinessCategory.fromJS(_data["reportType"]) : <any>undefined;
            this.reportMapType = _data["reportMapType"] ? BusinessCategory.fromJS(_data["reportMapType"]) : <any>undefined;
            if (Array.isArray(_data["inverseParentReport"])) {
                this.inverseParentReport = [] as any;
                for (let item of _data["inverseParentReport"])
                    this.inverseParentReport!.push(SystemReport.fromJS(item));
            }
            if (Array.isArray(_data["systemReportParams"])) {
                this.systemReportParams = [] as any;
                for (let item of _data["systemReportParams"])
                    this.systemReportParams!.push(SystemReportParam.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SystemReport {
        data = typeof data === 'object' ? data : {};
        let result = new SystemReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessProfileId"] = this.businessProfileId;
        data["moduleId"] = this.moduleId;
        data["name"] = this.name;
        data["title"] = this.title;
        data["description"] = this.description;
        data["reportTypeId"] = this.reportTypeId;
        data["reportMapTypeId"] = this.reportMapTypeId;
        data["layout"] = this.layout;
        data["sampleJsonDataSource"] = this.sampleJsonDataSource;
        data["parameterOptionDataSourceUrl"] = this.parameterOptionDataSourceUrl;
        data["reportDataServiceUrl"] = this.reportDataServiceUrl;
        data["parentReportId"] = this.parentReportId;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["parentReport"] = this.parentReport ? this.parentReport.toJSON() : <any>undefined;
        data["reportType"] = this.reportType ? this.reportType.toJSON() : <any>undefined;
        data["reportMapType"] = this.reportMapType ? this.reportMapType.toJSON() : <any>undefined;
        if (Array.isArray(this.inverseParentReport)) {
            data["inverseParentReport"] = [];
            for (let item of this.inverseParentReport)
                data["inverseParentReport"].push(item.toJSON());
        }
        if (Array.isArray(this.systemReportParams)) {
            data["systemReportParams"] = [];
            for (let item of this.systemReportParams)
                data["systemReportParams"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISystemReport {
    id?: number;
    businessProfileId?: number | undefined;
    moduleId?: number;
    name?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    reportTypeId?: number;
    reportMapTypeId?: number | undefined;
    layout?: string | undefined;
    sampleJsonDataSource?: string | undefined;
    parameterOptionDataSourceUrl?: string | undefined;
    reportDataServiceUrl?: string | undefined;
    parentReportId?: number | undefined;
    isActive?: boolean | undefined;
    isDefault?: boolean;
    createdDateTime?: Date;
    createdBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    lastModifiedBy?: string | undefined;
    module?: BusinessCategory | undefined;
    parentReport?: SystemReport | undefined;
    reportType?: BusinessCategory | undefined;
    reportMapType?: BusinessCategory | undefined;
    inverseParentReport?: SystemReport[] | undefined;
    systemReportParams?: SystemReportParam[] | undefined;
}

export class SystemReportParam implements ISystemReportParam {
    id?: number;
    systemReportId?: number;
    name?: string | undefined;
    caption?: string | undefined;
    dataType?: string | undefined;
    editorType?: string | undefined;
    dataSource?: string | undefined;
    defaultValue?: string | undefined;
    isQueryParam?: boolean;
    isRequired?: boolean;
    isVisble?: boolean;
    systemReport?: SystemReport | undefined;

    constructor(data?: ISystemReportParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.systemReportId = _data["systemReportId"];
            this.name = _data["name"];
            this.caption = _data["caption"];
            this.dataType = _data["dataType"];
            this.editorType = _data["editorType"];
            this.dataSource = _data["dataSource"];
            this.defaultValue = _data["defaultValue"];
            this.isQueryParam = _data["isQueryParam"];
            this.isRequired = _data["isRequired"];
            this.isVisble = _data["isVisble"];
            this.systemReport = _data["systemReport"] ? SystemReport.fromJS(_data["systemReport"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SystemReportParam {
        data = typeof data === 'object' ? data : {};
        let result = new SystemReportParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["systemReportId"] = this.systemReportId;
        data["name"] = this.name;
        data["caption"] = this.caption;
        data["dataType"] = this.dataType;
        data["editorType"] = this.editorType;
        data["dataSource"] = this.dataSource;
        data["defaultValue"] = this.defaultValue;
        data["isQueryParam"] = this.isQueryParam;
        data["isRequired"] = this.isRequired;
        data["isVisble"] = this.isVisble;
        data["systemReport"] = this.systemReport ? this.systemReport.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISystemReportParam {
    id?: number;
    systemReportId?: number;
    name?: string | undefined;
    caption?: string | undefined;
    dataType?: string | undefined;
    editorType?: string | undefined;
    dataSource?: string | undefined;
    defaultValue?: string | undefined;
    isQueryParam?: boolean;
    isRequired?: boolean;
    isVisble?: boolean;
    systemReport?: SystemReport | undefined;
}

export class MonthlyEmailProcess implements IMonthlyEmailProcess {
    id?: number;
    month?: string | undefined;
    year?: number;
    billType?: number;
    billTypeNavigation?: BusinessCategory | undefined;

    constructor(data?: IMonthlyEmailProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.billType = _data["billType"];
            this.billTypeNavigation = _data["billTypeNavigation"] ? BusinessCategory.fromJS(_data["billTypeNavigation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MonthlyEmailProcess {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyEmailProcess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["month"] = this.month;
        data["year"] = this.year;
        data["billType"] = this.billType;
        data["billTypeNavigation"] = this.billTypeNavigation ? this.billTypeNavigation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMonthlyEmailProcess {
    id?: number;
    month?: string | undefined;
    year?: number;
    billType?: number;
    billTypeNavigation?: BusinessCategory | undefined;
}

export class MembershipTypesInterchange implements IMembershipTypesInterchange {
    id?: number;
    membershipTypeId?: number;
    interchangeMembershipTypeId?: number;
    interchangeMembershipType?: MembershipType | undefined;
    membershipType?: MembershipType | undefined;

    constructor(data?: IMembershipTypesInterchange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.membershipTypeId = _data["membershipTypeId"];
            this.interchangeMembershipTypeId = _data["interchangeMembershipTypeId"];
            this.interchangeMembershipType = _data["interchangeMembershipType"] ? MembershipType.fromJS(_data["interchangeMembershipType"]) : <any>undefined;
            this.membershipType = _data["membershipType"] ? MembershipType.fromJS(_data["membershipType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MembershipTypesInterchange {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipTypesInterchange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["membershipTypeId"] = this.membershipTypeId;
        data["interchangeMembershipTypeId"] = this.interchangeMembershipTypeId;
        data["interchangeMembershipType"] = this.interchangeMembershipType ? this.interchangeMembershipType.toJSON() : <any>undefined;
        data["membershipType"] = this.membershipType ? this.membershipType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMembershipTypesInterchange {
    id?: number;
    membershipTypeId?: number;
    interchangeMembershipTypeId?: number;
    interchangeMembershipType?: MembershipType | undefined;
    membershipType?: MembershipType | undefined;
}

export class UpsertGymRatesCommand extends GymRatesModel implements IUpsertGymRatesCommand {

    constructor(data?: IUpsertGymRatesCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertGymRatesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertGymRatesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertGymRatesCommand extends IGymRatesModel {
}

export class HolidayModel implements IHolidayModel {
    id?: number;
    dateFrom?: Date;
    dateTo?: Date;
    description?: string | undefined;
    isActive?: boolean;

    constructor(data?: IHolidayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): HolidayModel {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IHolidayModel {
    id?: number;
    dateFrom?: Date;
    dateTo?: Date;
    description?: string | undefined;
    isActive?: boolean;
}

export class UpsertHolidayCommand extends HolidayModel implements IUpsertHolidayCommand {

    constructor(data?: IUpsertHolidayCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertHolidayCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertHolidayCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertHolidayCommand extends IHolidayModel {
}

export class IngredientViewModel implements IIngredientViewModel {
    model?: IngredientModel | undefined;

    constructor(data?: IIngredientViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? IngredientModel.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IngredientViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIngredientViewModel {
    model?: IngredientModel | undefined;
}

export class IngredientModel implements IIngredientModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date;

    constructor(data?: IIngredientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): IngredientModel {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IIngredientModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date;
}

export class UpsertIngredientCommand extends IngredientModel implements IUpsertIngredientCommand {

    constructor(data?: IUpsertIngredientCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertIngredientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertIngredientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertIngredientCommand extends IIngredientModel {
}

export class ItemCatalogViewModel implements IItemCatalogViewModel {
    model?: ItemModel | undefined;
    salesCategoriesTreeNode?: TreeNodeModel[] | undefined;
    unitsSelectList?: SelectModel[] | undefined;
    itemIngredientsSelectList?: SelectModel[] | undefined;
    itemAttributesSelectList?: SelectModel[] | undefined;
    counterSelectList?: SelectModel[] | undefined;
    stockCategorySelectList?: SelectModel[] | undefined;
    stockItemSelectList?: SelectModel[] | undefined;

    constructor(data?: IItemCatalogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? ItemModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["salesCategoriesTreeNode"])) {
                this.salesCategoriesTreeNode = [] as any;
                for (let item of _data["salesCategoriesTreeNode"])
                    this.salesCategoriesTreeNode!.push(TreeNodeModel.fromJS(item));
            }
            if (Array.isArray(_data["unitsSelectList"])) {
                this.unitsSelectList = [] as any;
                for (let item of _data["unitsSelectList"])
                    this.unitsSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["itemIngredientsSelectList"])) {
                this.itemIngredientsSelectList = [] as any;
                for (let item of _data["itemIngredientsSelectList"])
                    this.itemIngredientsSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["itemAttributesSelectList"])) {
                this.itemAttributesSelectList = [] as any;
                for (let item of _data["itemAttributesSelectList"])
                    this.itemAttributesSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["counterSelectList"])) {
                this.counterSelectList = [] as any;
                for (let item of _data["counterSelectList"])
                    this.counterSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["stockCategorySelectList"])) {
                this.stockCategorySelectList = [] as any;
                for (let item of _data["stockCategorySelectList"])
                    this.stockCategorySelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["stockItemSelectList"])) {
                this.stockItemSelectList = [] as any;
                for (let item of _data["stockItemSelectList"])
                    this.stockItemSelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ItemCatalogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ItemCatalogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.salesCategoriesTreeNode)) {
            data["salesCategoriesTreeNode"] = [];
            for (let item of this.salesCategoriesTreeNode)
                data["salesCategoriesTreeNode"].push(item.toJSON());
        }
        if (Array.isArray(this.unitsSelectList)) {
            data["unitsSelectList"] = [];
            for (let item of this.unitsSelectList)
                data["unitsSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.itemIngredientsSelectList)) {
            data["itemIngredientsSelectList"] = [];
            for (let item of this.itemIngredientsSelectList)
                data["itemIngredientsSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.itemAttributesSelectList)) {
            data["itemAttributesSelectList"] = [];
            for (let item of this.itemAttributesSelectList)
                data["itemAttributesSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.counterSelectList)) {
            data["counterSelectList"] = [];
            for (let item of this.counterSelectList)
                data["counterSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.stockCategorySelectList)) {
            data["stockCategorySelectList"] = [];
            for (let item of this.stockCategorySelectList)
                data["stockCategorySelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.stockItemSelectList)) {
            data["stockItemSelectList"] = [];
            for (let item of this.stockItemSelectList)
                data["stockItemSelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IItemCatalogViewModel {
    model?: ItemModel | undefined;
    salesCategoriesTreeNode?: TreeNodeModel[] | undefined;
    unitsSelectList?: SelectModel[] | undefined;
    itemIngredientsSelectList?: SelectModel[] | undefined;
    itemAttributesSelectList?: SelectModel[] | undefined;
    counterSelectList?: SelectModel[] | undefined;
    stockCategorySelectList?: SelectModel[] | undefined;
    stockItemSelectList?: SelectModel[] | undefined;
}

export class ItemModel extends BaseModel implements IItemModel {
    id?: number;
    categoryId?: number;
    name?: string | undefined;
    description?: string | undefined;
    unitId?: number;
    unitName?: string | undefined;
    imagePath?: string | undefined;
    isActive?: boolean;
    counterId?: number | undefined;
    stockItemId?: number | undefined;
    itemIngredients?: ItemIngredientModel[] | undefined;
    itemAttributes?: ItemAttributeModel[] | undefined;

    constructor(data?: IItemModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.unitId = _data["unitId"];
            this.unitName = _data["unitName"];
            this.imagePath = _data["imagePath"];
            this.isActive = _data["isActive"];
            this.counterId = _data["counterId"];
            this.stockItemId = _data["stockItemId"];
            if (Array.isArray(_data["itemIngredients"])) {
                this.itemIngredients = [] as any;
                for (let item of _data["itemIngredients"])
                    this.itemIngredients!.push(ItemIngredientModel.fromJS(item));
            }
            if (Array.isArray(_data["itemAttributes"])) {
                this.itemAttributes = [] as any;
                for (let item of _data["itemAttributes"])
                    this.itemAttributes!.push(ItemAttributeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new ItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["unitId"] = this.unitId;
        data["unitName"] = this.unitName;
        data["imagePath"] = this.imagePath;
        data["isActive"] = this.isActive;
        data["counterId"] = this.counterId;
        data["stockItemId"] = this.stockItemId;
        if (Array.isArray(this.itemIngredients)) {
            data["itemIngredients"] = [];
            for (let item of this.itemIngredients)
                data["itemIngredients"].push(item.toJSON());
        }
        if (Array.isArray(this.itemAttributes)) {
            data["itemAttributes"] = [];
            for (let item of this.itemAttributes)
                data["itemAttributes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IItemModel extends IBaseModel {
    id?: number;
    categoryId?: number;
    name?: string | undefined;
    description?: string | undefined;
    unitId?: number;
    unitName?: string | undefined;
    imagePath?: string | undefined;
    isActive?: boolean;
    counterId?: number | undefined;
    stockItemId?: number | undefined;
    itemIngredients?: ItemIngredientModel[] | undefined;
    itemAttributes?: ItemAttributeModel[] | undefined;
}

export class ItemIngredientModel extends BaseModel implements IItemIngredientModel {
    id?: number;
    itemId?: number;
    ingredientsId?: number;
    ingredientName?: string | undefined;

    constructor(data?: IItemIngredientModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.itemId = _data["itemId"];
            this.ingredientsId = _data["ingredientsId"];
            this.ingredientName = _data["ingredientName"];
        }
    }

    static fromJS(data: any): ItemIngredientModel {
        data = typeof data === 'object' ? data : {};
        let result = new ItemIngredientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemId"] = this.itemId;
        data["ingredientsId"] = this.ingredientsId;
        data["ingredientName"] = this.ingredientName;
        super.toJSON(data);
        return data; 
    }
}

export interface IItemIngredientModel extends IBaseModel {
    id?: number;
    itemId?: number;
    ingredientsId?: number;
    ingredientName?: string | undefined;
}

export class ItemAttributeModel extends BaseModel implements IItemAttributeModel {
    id?: number;
    itemId?: number;
    attributesId?: number;
    attributeName?: string | undefined;
    attributeType?: string | undefined;
    stockItemId?: number | undefined;
    stockCategoryId?: number | undefined;
    price?: number;
    quantity?: number | undefined;
    isDefault?: number;
    attTypeOrder?: string | undefined;

    constructor(data?: IItemAttributeModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.itemId = _data["itemId"];
            this.attributesId = _data["attributesId"];
            this.attributeName = _data["attributeName"];
            this.attributeType = _data["attributeType"];
            this.stockItemId = _data["stockItemId"];
            this.stockCategoryId = _data["stockCategoryId"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.isDefault = _data["isDefault"];
            this.attTypeOrder = _data["attTypeOrder"];
        }
    }

    static fromJS(data: any): ItemAttributeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ItemAttributeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemId"] = this.itemId;
        data["attributesId"] = this.attributesId;
        data["attributeName"] = this.attributeName;
        data["attributeType"] = this.attributeType;
        data["stockItemId"] = this.stockItemId;
        data["stockCategoryId"] = this.stockCategoryId;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["isDefault"] = this.isDefault;
        data["attTypeOrder"] = this.attTypeOrder;
        super.toJSON(data);
        return data; 
    }
}

export interface IItemAttributeModel extends IBaseModel {
    id?: number;
    itemId?: number;
    attributesId?: number;
    attributeName?: string | undefined;
    attributeType?: string | undefined;
    stockItemId?: number | undefined;
    stockCategoryId?: number | undefined;
    price?: number;
    quantity?: number | undefined;
    isDefault?: number;
    attTypeOrder?: string | undefined;
}

export class TreeNodeModel implements ITreeNodeModel {
    key?: number;
    parentId?: number | undefined;
    title?: string | undefined;
    imagePath?: string | undefined;
    description?: string | undefined;
    disableCheckbox?: boolean;
    visible?: boolean;
    icon?: string | undefined;
    isLeaf?: boolean;
    isActive?: boolean;
    type?: string | undefined;
    children?: TreeNodeModel[] | undefined;

    constructor(data?: ITreeNodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.parentId = _data["parentId"];
            this.title = _data["title"];
            this.imagePath = _data["imagePath"];
            this.description = _data["description"];
            this.disableCheckbox = _data["disableCheckbox"];
            this.visible = _data["visible"];
            this.icon = _data["icon"];
            this.isLeaf = _data["isLeaf"];
            this.isActive = _data["isActive"];
            this.type = _data["type"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(TreeNodeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreeNodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new TreeNodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["imagePath"] = this.imagePath;
        data["description"] = this.description;
        data["disableCheckbox"] = this.disableCheckbox;
        data["visible"] = this.visible;
        data["icon"] = this.icon;
        data["isLeaf"] = this.isLeaf;
        data["isActive"] = this.isActive;
        data["type"] = this.type;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITreeNodeModel {
    key?: number;
    parentId?: number | undefined;
    title?: string | undefined;
    imagePath?: string | undefined;
    description?: string | undefined;
    disableCheckbox?: boolean;
    visible?: boolean;
    icon?: string | undefined;
    isLeaf?: boolean;
    isActive?: boolean;
    type?: string | undefined;
    children?: TreeNodeModel[] | undefined;
}

export class UpsertItemCatalogCommand extends ItemModel implements IUpsertItemCatalogCommand {

    constructor(data?: IUpsertItemCatalogCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertItemCatalogCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertItemCatalogCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertItemCatalogCommand extends IItemModel {
}

export class MemberCardViewModel implements IMemberCardViewModel {
    model?: MemberCardModel | undefined;
    cardStatusSelectList?: SelectModel[] | undefined;
    cardMemberSelectList?: SelectModel[] | undefined;

    constructor(data?: IMemberCardViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? MemberCardModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["cardStatusSelectList"])) {
                this.cardStatusSelectList = [] as any;
                for (let item of _data["cardStatusSelectList"])
                    this.cardStatusSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["cardMemberSelectList"])) {
                this.cardMemberSelectList = [] as any;
                for (let item of _data["cardMemberSelectList"])
                    this.cardMemberSelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MemberCardViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberCardViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.cardStatusSelectList)) {
            data["cardStatusSelectList"] = [];
            for (let item of this.cardStatusSelectList)
                data["cardStatusSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.cardMemberSelectList)) {
            data["cardMemberSelectList"] = [];
            for (let item of this.cardMemberSelectList)
                data["cardMemberSelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMemberCardViewModel {
    model?: MemberCardModel | undefined;
    cardStatusSelectList?: SelectModel[] | undefined;
    cardMemberSelectList?: SelectModel[] | undefined;
}

export class UpsertCardCommand extends MemberCardModel implements IUpsertCardCommand {

    constructor(data?: IUpsertCardCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertCardCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCardCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertCardCommand extends IMemberCardModel {
}

export class BulkInsertMembershipCardPinCommand implements IBulkInsertMembershipCardPinCommand {
    count?: number;

    constructor(data?: IBulkInsertMembershipCardPinCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): BulkInsertMembershipCardPinCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BulkInsertMembershipCardPinCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        return data; 
    }
}

export interface IBulkInsertMembershipCardPinCommand {
    count?: number;
}

export class MemberContributionViewModel implements IMemberContributionViewModel {
    model?: MemberContributionModel | undefined;
    memberContributionSelectList?: SelectModel[] | undefined;

    constructor(data?: IMemberContributionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? MemberContributionModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["memberContributionSelectList"])) {
                this.memberContributionSelectList = [] as any;
                for (let item of _data["memberContributionSelectList"])
                    this.memberContributionSelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MemberContributionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberContributionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.memberContributionSelectList)) {
            data["memberContributionSelectList"] = [];
            for (let item of this.memberContributionSelectList)
                data["memberContributionSelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMemberContributionViewModel {
    model?: MemberContributionModel | undefined;
    memberContributionSelectList?: SelectModel[] | undefined;
}

export class MemberContributionModel extends BaseModel implements IMemberContributionModel {
    id?: number;
    memberId?: number;
    contributionItemId?: number;
    quantity?: number;
    equivalentAmount?: number;
    transactionId?: number;
    cardId?: number;

    constructor(data?: IMemberContributionModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.contributionItemId = _data["contributionItemId"];
            this.quantity = _data["quantity"];
            this.equivalentAmount = _data["equivalentAmount"];
            this.transactionId = _data["transactionId"];
            this.cardId = _data["cardId"];
        }
    }

    static fromJS(data: any): MemberContributionModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberContributionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["contributionItemId"] = this.contributionItemId;
        data["quantity"] = this.quantity;
        data["equivalentAmount"] = this.equivalentAmount;
        data["transactionId"] = this.transactionId;
        data["cardId"] = this.cardId;
        super.toJSON(data);
        return data; 
    }
}

export interface IMemberContributionModel extends IBaseModel {
    id?: number;
    memberId?: number;
    contributionItemId?: number;
    quantity?: number;
    equivalentAmount?: number;
    transactionId?: number;
    cardId?: number;
}

export class UpsertContributionCommand extends MemberContributionModel implements IUpsertContributionCommand {

    constructor(data?: IUpsertContributionCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertContributionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertContributionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertContributionCommand extends IMemberContributionModel {
}

export class MemberDocumentViewModel implements IMemberDocumentViewModel {
    model?: MemberDocumentModel | undefined;
    documentTypeSelectList?: SelectModel[] | undefined;

    constructor(data?: IMemberDocumentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? MemberDocumentModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["documentTypeSelectList"])) {
                this.documentTypeSelectList = [] as any;
                for (let item of _data["documentTypeSelectList"])
                    this.documentTypeSelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MemberDocumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberDocumentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.documentTypeSelectList)) {
            data["documentTypeSelectList"] = [];
            for (let item of this.documentTypeSelectList)
                data["documentTypeSelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMemberDocumentViewModel {
    model?: MemberDocumentModel | undefined;
    documentTypeSelectList?: SelectModel[] | undefined;
}

export class MemberDocumentModel extends BaseModel implements IMemberDocumentModel {
    id?: number;
    memberId?: number;
    documentTypeId?: number;
    documentName?: string | undefined;
    documentDescription?: string | undefined;
    documentContent?: string | undefined;

    constructor(data?: IMemberDocumentModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentName = _data["documentName"];
            this.documentDescription = _data["documentDescription"];
            this.documentContent = _data["documentContent"];
        }
    }

    static fromJS(data: any): MemberDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["documentTypeId"] = this.documentTypeId;
        data["documentName"] = this.documentName;
        data["documentDescription"] = this.documentDescription;
        data["documentContent"] = this.documentContent;
        super.toJSON(data);
        return data; 
    }
}

export interface IMemberDocumentModel extends IBaseModel {
    id?: number;
    memberId?: number;
    documentTypeId?: number;
    documentName?: string | undefined;
    documentDescription?: string | undefined;
    documentContent?: string | undefined;
}

export class UpsertMemberDocumentCommand extends MemberDocumentModel implements IUpsertMemberDocumentCommand {

    constructor(data?: IUpsertMemberDocumentCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertMemberDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertMemberDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertMemberDocumentCommand extends IMemberDocumentModel {
}

export class UpsertMemberPhotoCommand extends ApplicationImageModel implements IUpsertMemberPhotoCommand {

    constructor(data?: IUpsertMemberPhotoCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertMemberPhotoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertMemberPhotoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertMemberPhotoCommand extends IApplicationImageModel {
}

export class RFTracViewModel implements IRFTracViewModel {
    model?: RFTracModel | undefined;
    memberCardSelectList?: SelectModel[] | undefined;

    constructor(data?: IRFTracViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? RFTracModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["memberCardSelectList"])) {
                this.memberCardSelectList = [] as any;
                for (let item of _data["memberCardSelectList"])
                    this.memberCardSelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RFTracViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RFTracViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.memberCardSelectList)) {
            data["memberCardSelectList"] = [];
            for (let item of this.memberCardSelectList)
                data["memberCardSelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRFTracViewModel {
    model?: RFTracModel | undefined;
    memberCardSelectList?: SelectModel[] | undefined;
}

export class RFTracModel implements IRFTracModel {
    id?: number;
    memberId?: number;
    cardNumber?: string | undefined;
    rfId?: string | undefined;

    constructor(data?: IRFTracModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.cardNumber = _data["cardNumber"];
            this.rfId = _data["rfId"];
        }
    }

    static fromJS(data: any): RFTracModel {
        data = typeof data === 'object' ? data : {};
        let result = new RFTracModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["cardNumber"] = this.cardNumber;
        data["rfId"] = this.rfId;
        return data; 
    }
}

export interface IRFTracModel {
    id?: number;
    memberId?: number;
    cardNumber?: string | undefined;
    rfId?: string | undefined;
}

export class UpssertRfIdTrackCommand extends RFTracModel implements IUpssertRfIdTrackCommand {

    constructor(data?: IUpssertRfIdTrackCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpssertRfIdTrackCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpssertRfIdTrackCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpssertRfIdTrackCommand extends IRFTracModel {
}

export class MemberViewModel implements IMemberViewModel {
    model?: MemberModel | undefined;
    memberTypeSelectList?: SelectModel[] | undefined;
    genderSelectList?: SelectModel[] | undefined;
    referenceMemberSelectList?: SelectModel[] | undefined;
    bloodGroupSelectList?: SelectModel[] | undefined;

    constructor(data?: IMemberViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? MemberModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["memberTypeSelectList"])) {
                this.memberTypeSelectList = [] as any;
                for (let item of _data["memberTypeSelectList"])
                    this.memberTypeSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["genderSelectList"])) {
                this.genderSelectList = [] as any;
                for (let item of _data["genderSelectList"])
                    this.genderSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["referenceMemberSelectList"])) {
                this.referenceMemberSelectList = [] as any;
                for (let item of _data["referenceMemberSelectList"])
                    this.referenceMemberSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["bloodGroupSelectList"])) {
                this.bloodGroupSelectList = [] as any;
                for (let item of _data["bloodGroupSelectList"])
                    this.bloodGroupSelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MemberViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.memberTypeSelectList)) {
            data["memberTypeSelectList"] = [];
            for (let item of this.memberTypeSelectList)
                data["memberTypeSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.genderSelectList)) {
            data["genderSelectList"] = [];
            for (let item of this.genderSelectList)
                data["genderSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.referenceMemberSelectList)) {
            data["referenceMemberSelectList"] = [];
            for (let item of this.referenceMemberSelectList)
                data["referenceMemberSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.bloodGroupSelectList)) {
            data["bloodGroupSelectList"] = [];
            for (let item of this.bloodGroupSelectList)
                data["bloodGroupSelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMemberViewModel {
    model?: MemberModel | undefined;
    memberTypeSelectList?: SelectModel[] | undefined;
    genderSelectList?: SelectModel[] | undefined;
    referenceMemberSelectList?: SelectModel[] | undefined;
    bloodGroupSelectList?: SelectModel[] | undefined;
}

export class MemberUpsertResponse implements IMemberUpsertResponse {
    statusCode?: number;
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: IMemberUpsertResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): MemberUpsertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MemberUpsertResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data; 
    }
}

export interface IMemberUpsertResponse {
    statusCode?: number;
    isSuccess?: boolean;
    message?: string | undefined;
}

export class UpsertMemberCommand extends MemberModel implements IUpsertMemberCommand {

    constructor(data?: IUpsertMemberCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertMemberCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertMemberCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertMemberCommand extends IMemberModel {
}

export class MembershipTypeViewModel implements IMembershipTypeViewModel {
    model?: MembershipTypeModel | undefined;
    memberCategorySelectList?: SelectModel[] | undefined;

    constructor(data?: IMembershipTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? MembershipTypeModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["memberCategorySelectList"])) {
                this.memberCategorySelectList = [] as any;
                for (let item of _data["memberCategorySelectList"])
                    this.memberCategorySelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MembershipTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.memberCategorySelectList)) {
            data["memberCategorySelectList"] = [];
            for (let item of this.memberCategorySelectList)
                data["memberCategorySelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMembershipTypeViewModel {
    model?: MembershipTypeModel | undefined;
    memberCategorySelectList?: SelectModel[] | undefined;
}

export class MembershipTypeModel implements IMembershipTypeModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    memberCategoryId?: number;
    debentureAmount?: number;
    monthlyFee?: number;
    validityDuration?: number | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;

    constructor(data?: IMembershipTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.memberCategoryId = _data["memberCategoryId"];
            this.debentureAmount = _data["debentureAmount"];
            this.monthlyFee = _data["monthlyFee"];
            this.validityDuration = _data["validityDuration"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MembershipTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new MembershipTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["memberCategoryId"] = this.memberCategoryId;
        data["debentureAmount"] = this.debentureAmount;
        data["monthlyFee"] = this.monthlyFee;
        data["validityDuration"] = this.validityDuration;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IMembershipTypeModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    memberCategoryId?: number;
    debentureAmount?: number;
    monthlyFee?: number;
    validityDuration?: number | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
}

export class UpsertMembershipTypeCommand extends MembershipTypeModel implements IUpsertMembershipTypeCommand {

    constructor(data?: IUpsertMembershipTypeCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertMembershipTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertMembershipTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertMembershipTypeCommand extends IMembershipTypeModel {
}

export class MemberTransactionViewModel implements IMemberTransactionViewModel {
    model?: MemberTransactionModel | undefined;
    transactionTypeSelectList?: SelectModel[] | undefined;
    memberSelectList?: SelectModel[] | undefined;
    paymentTypeSelectList?: SelectModel[] | undefined;
    bankSelectList?: SelectModel[] | undefined;

    constructor(data?: IMemberTransactionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? MemberTransactionModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["transactionTypeSelectList"])) {
                this.transactionTypeSelectList = [] as any;
                for (let item of _data["transactionTypeSelectList"])
                    this.transactionTypeSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["memberSelectList"])) {
                this.memberSelectList = [] as any;
                for (let item of _data["memberSelectList"])
                    this.memberSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["paymentTypeSelectList"])) {
                this.paymentTypeSelectList = [] as any;
                for (let item of _data["paymentTypeSelectList"])
                    this.paymentTypeSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["bankSelectList"])) {
                this.bankSelectList = [] as any;
                for (let item of _data["bankSelectList"])
                    this.bankSelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MemberTransactionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MemberTransactionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.transactionTypeSelectList)) {
            data["transactionTypeSelectList"] = [];
            for (let item of this.transactionTypeSelectList)
                data["transactionTypeSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.memberSelectList)) {
            data["memberSelectList"] = [];
            for (let item of this.memberSelectList)
                data["memberSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentTypeSelectList)) {
            data["paymentTypeSelectList"] = [];
            for (let item of this.paymentTypeSelectList)
                data["paymentTypeSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.bankSelectList)) {
            data["bankSelectList"] = [];
            for (let item of this.bankSelectList)
                data["bankSelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMemberTransactionViewModel {
    model?: MemberTransactionModel | undefined;
    transactionTypeSelectList?: SelectModel[] | undefined;
    memberSelectList?: SelectModel[] | undefined;
    paymentTypeSelectList?: SelectModel[] | undefined;
    bankSelectList?: SelectModel[] | undefined;
}

export class NoticeViewModel implements INoticeViewModel {
    model?: NoticeModel | undefined;

    constructor(data?: INoticeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? NoticeModel.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NoticeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NoticeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data; 
    }
}

export interface INoticeViewModel {
    model?: NoticeModel | undefined;
}

export class NoticeModel extends BaseModel implements INoticeModel {
    id?: number;
    title?: string | undefined;
    description?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;

    constructor(data?: INoticeModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NoticeModel {
        data = typeof data === 'object' ? data : {};
        let result = new NoticeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface INoticeModel extends IBaseModel {
    id?: number;
    title?: string | undefined;
    description?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
}

export class UpsertNoticeCommand extends NoticeModel implements IUpsertNoticeCommand {

    constructor(data?: IUpsertNoticeCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertNoticeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertNoticeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertNoticeCommand extends INoticeModel {
}

export class OrderModel extends BaseModel implements IOrderModel {
    id?: number;
    membershipTypeId?: number;
    memberId?: number;
    memberName?: string | undefined;
    memberCode?: string | undefined;
    memberImagePath?: string | undefined;
    orderDate?: Date;
    isOpen?: boolean | undefined;
    statusId?: number;
    tableNumber?: string | undefined;
    statusName?: string | undefined;
    createdBy?: string | undefined;
    orderAmount?: number;
    orderItems?: OrderItemModel[] | undefined;
    display?: string | undefined;

    constructor(data?: IOrderModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.membershipTypeId = _data["membershipTypeId"];
            this.memberId = _data["memberId"];
            this.memberName = _data["memberName"];
            this.memberCode = _data["memberCode"];
            this.memberImagePath = _data["memberImagePath"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.isOpen = _data["isOpen"];
            this.statusId = _data["statusId"];
            this.tableNumber = _data["tableNumber"];
            this.statusName = _data["statusName"];
            this.createdBy = _data["createdBy"];
            this.orderAmount = _data["orderAmount"];
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItemModel.fromJS(item));
            }
            this.display = _data["display"];
        }
    }

    static fromJS(data: any): OrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["membershipTypeId"] = this.membershipTypeId;
        data["memberId"] = this.memberId;
        data["memberName"] = this.memberName;
        data["memberCode"] = this.memberCode;
        data["memberImagePath"] = this.memberImagePath;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["isOpen"] = this.isOpen;
        data["statusId"] = this.statusId;
        data["tableNumber"] = this.tableNumber;
        data["statusName"] = this.statusName;
        data["createdBy"] = this.createdBy;
        data["orderAmount"] = this.orderAmount;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        data["display"] = this.display;
        super.toJSON(data);
        return data; 
    }
}

export interface IOrderModel extends IBaseModel {
    id?: number;
    membershipTypeId?: number;
    memberId?: number;
    memberName?: string | undefined;
    memberCode?: string | undefined;
    memberImagePath?: string | undefined;
    orderDate?: Date;
    isOpen?: boolean | undefined;
    statusId?: number;
    tableNumber?: string | undefined;
    statusName?: string | undefined;
    createdBy?: string | undefined;
    orderAmount?: number;
    orderItems?: OrderItemModel[] | undefined;
    display?: string | undefined;
}

export class OrderItemModel extends BaseModel implements IOrderItemModel {
    id?: number;
    itemId?: number;
    orderId?: number;
    name?: string | undefined;
    description?: string | undefined;
    imagePath?: string | undefined;
    quantity?: number;
    statusId?: number;
    orederItemStatus?: string | undefined;
    unit?: string | undefined;
    itemIngredients?: string[] | undefined;
    category?: string | undefined;
    counterId?: number | undefined;
    counterType?: number;
    ordPrice?: number;
    size?: OrderItemDetailsModel | undefined;
    itemAttrributes?: OrderItemDetailsModel[] | undefined;
    orderItemDetails?: OrderItemDetailsModel[] | undefined;

    constructor(data?: IOrderItemModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.itemId = _data["itemId"];
            this.orderId = _data["orderId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.imagePath = _data["imagePath"];
            this.quantity = _data["quantity"];
            this.statusId = _data["statusId"];
            this.orederItemStatus = _data["orederItemStatus"];
            this.unit = _data["unit"];
            if (Array.isArray(_data["itemIngredients"])) {
                this.itemIngredients = [] as any;
                for (let item of _data["itemIngredients"])
                    this.itemIngredients!.push(item);
            }
            this.category = _data["category"];
            this.counterId = _data["counterId"];
            this.counterType = _data["counterType"];
            this.ordPrice = _data["ordPrice"];
            this.size = _data["size"] ? OrderItemDetailsModel.fromJS(_data["size"]) : <any>undefined;
            if (Array.isArray(_data["itemAttrributes"])) {
                this.itemAttrributes = [] as any;
                for (let item of _data["itemAttrributes"])
                    this.itemAttrributes!.push(OrderItemDetailsModel.fromJS(item));
            }
            if (Array.isArray(_data["orderItemDetails"])) {
                this.orderItemDetails = [] as any;
                for (let item of _data["orderItemDetails"])
                    this.orderItemDetails!.push(OrderItemDetailsModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemId"] = this.itemId;
        data["orderId"] = this.orderId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["imagePath"] = this.imagePath;
        data["quantity"] = this.quantity;
        data["statusId"] = this.statusId;
        data["orederItemStatus"] = this.orederItemStatus;
        data["unit"] = this.unit;
        if (Array.isArray(this.itemIngredients)) {
            data["itemIngredients"] = [];
            for (let item of this.itemIngredients)
                data["itemIngredients"].push(item);
        }
        data["category"] = this.category;
        data["counterId"] = this.counterId;
        data["counterType"] = this.counterType;
        data["ordPrice"] = this.ordPrice;
        data["size"] = this.size ? this.size.toJSON() : <any>undefined;
        if (Array.isArray(this.itemAttrributes)) {
            data["itemAttrributes"] = [];
            for (let item of this.itemAttrributes)
                data["itemAttrributes"].push(item.toJSON());
        }
        if (Array.isArray(this.orderItemDetails)) {
            data["orderItemDetails"] = [];
            for (let item of this.orderItemDetails)
                data["orderItemDetails"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IOrderItemModel extends IBaseModel {
    id?: number;
    itemId?: number;
    orderId?: number;
    name?: string | undefined;
    description?: string | undefined;
    imagePath?: string | undefined;
    quantity?: number;
    statusId?: number;
    orederItemStatus?: string | undefined;
    unit?: string | undefined;
    itemIngredients?: string[] | undefined;
    category?: string | undefined;
    counterId?: number | undefined;
    counterType?: number;
    ordPrice?: number;
    size?: OrderItemDetailsModel | undefined;
    itemAttrributes?: OrderItemDetailsModel[] | undefined;
    orderItemDetails?: OrderItemDetailsModel[] | undefined;
}

export class OrderItemDetailsModel extends BaseModel implements IOrderItemDetailsModel {
    id?: number;
    orderItemId?: number;
    attributeId?: number;
    typeId?: number;
    attName?: string | undefined;
    price?: number;

    constructor(data?: IOrderItemDetailsModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.orderItemId = _data["orderItemId"];
            this.attributeId = _data["attributeId"];
            this.typeId = _data["typeId"];
            this.attName = _data["attName"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): OrderItemDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderItemId"] = this.orderItemId;
        data["attributeId"] = this.attributeId;
        data["typeId"] = this.typeId;
        data["attName"] = this.attName;
        data["price"] = this.price;
        super.toJSON(data);
        return data; 
    }
}

export interface IOrderItemDetailsModel extends IBaseModel {
    id?: number;
    orderItemId?: number;
    attributeId?: number;
    typeId?: number;
    attName?: string | undefined;
    price?: number;
}

export class OrderViewModel implements IOrderViewModel {
    model?: OrderModel | undefined;

    constructor(data?: IOrderViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? OrderModel.fromJS(_data["model"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IOrderViewModel {
    model?: OrderModel | undefined;
}

export class UpsertOrderCommand extends OrderModel implements IUpsertOrderCommand {

    constructor(data?: IUpsertOrderCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertOrderCommand extends IOrderModel {
}

export class UpdateSpecificOrderItemCommand extends OrderItemModel implements IUpdateSpecificOrderItemCommand {

    constructor(data?: IUpdateSpecificOrderItemCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateSpecificOrderItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSpecificOrderItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpdateSpecificOrderItemCommand extends IOrderItemModel {
}

export class UpdateOrderItemCommand extends OrderItemModel implements IUpdateOrderItemCommand {

    constructor(data?: IUpdateOrderItemCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateOrderItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpdateOrderItemCommand extends IOrderItemModel {
}

export class PasswordChangeCommand implements IPasswordChangeCommand {
    memberCode?: string | undefined;
    oldPass?: string | undefined;
    newPass?: string | undefined;

    constructor(data?: IPasswordChangeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberCode = _data["memberCode"];
            this.oldPass = _data["oldPass"];
            this.newPass = _data["newPass"];
        }
    }

    static fromJS(data: any): PasswordChangeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordChangeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCode"] = this.memberCode;
        data["oldPass"] = this.oldPass;
        data["newPass"] = this.newPass;
        return data; 
    }
}

export interface IPasswordChangeCommand {
    memberCode?: string | undefined;
    oldPass?: string | undefined;
    newPass?: string | undefined;
}

export class PoolAvailLogViewModel implements IPoolAvailLogViewModel {
    model?: PoolAvailLogModel | undefined;
    members?: SelectModel[] | undefined;

    constructor(data?: IPoolAvailLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? PoolAvailLogModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PoolAvailLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PoolAvailLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPoolAvailLogViewModel {
    model?: PoolAvailLogModel | undefined;
    members?: SelectModel[] | undefined;
}

export class PoolAvailLogModel extends BaseModel implements IPoolAvailLogModel {
    id?: number;
    memberId?: number;
    personCount?: number;
    inTime?: Date;
    outTime?: Date | undefined;
    isExcludeMember?: boolean;
    charge?: number;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    memberCode?: string | undefined;
    memberName?: string | undefined;

    constructor(data?: IPoolAvailLogModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.memberId = _data["memberId"];
            this.personCount = _data["personCount"];
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.isExcludeMember = _data["isExcludeMember"];
            this.charge = _data["charge"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.memberCode = _data["memberCode"];
            this.memberName = _data["memberName"];
        }
    }

    static fromJS(data: any): PoolAvailLogModel {
        data = typeof data === 'object' ? data : {};
        let result = new PoolAvailLogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["memberId"] = this.memberId;
        data["personCount"] = this.personCount;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["isExcludeMember"] = this.isExcludeMember;
        data["charge"] = this.charge;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["memberCode"] = this.memberCode;
        data["memberName"] = this.memberName;
        super.toJSON(data);
        return data; 
    }
}

export interface IPoolAvailLogModel extends IBaseModel {
    id?: number;
    memberId?: number;
    personCount?: number;
    inTime?: Date;
    outTime?: Date | undefined;
    isExcludeMember?: boolean;
    charge?: number;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    memberCode?: string | undefined;
    memberName?: string | undefined;
}

export class UpsertPoolAvailLogCommand extends PoolAvailLogModel implements IUpsertPoolAvailLogCommand {

    constructor(data?: IUpsertPoolAvailLogCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertPoolAvailLogCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertPoolAvailLogCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertPoolAvailLogCommand extends IPoolAvailLogModel {
}

export class PoolRatesViewModel implements IPoolRatesViewModel {
    model?: PoolRateModel | undefined;
    membershipTypeSelectList?: SelectModel[] | undefined;

    constructor(data?: IPoolRatesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? PoolRateModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["membershipTypeSelectList"])) {
                this.membershipTypeSelectList = [] as any;
                for (let item of _data["membershipTypeSelectList"])
                    this.membershipTypeSelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PoolRatesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PoolRatesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.membershipTypeSelectList)) {
            data["membershipTypeSelectList"] = [];
            for (let item of this.membershipTypeSelectList)
                data["membershipTypeSelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPoolRatesViewModel {
    model?: PoolRateModel | undefined;
    membershipTypeSelectList?: SelectModel[] | undefined;
}

export class PoolRateModel implements IPoolRateModel {
    id?: number;
    membershipTypeId?: number;
    rate?: number;
    isActive?: boolean;

    constructor(data?: IPoolRateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.membershipTypeId = _data["membershipTypeId"];
            this.rate = _data["rate"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PoolRateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PoolRateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["membershipTypeId"] = this.membershipTypeId;
        data["rate"] = this.rate;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IPoolRateModel {
    id?: number;
    membershipTypeId?: number;
    rate?: number;
    isActive?: boolean;
}

export class UpsertPoolRatesCommand extends PoolRateModel implements IUpsertPoolRatesCommand {

    constructor(data?: IUpsertPoolRatesCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertPoolRatesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertPoolRatesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertPoolRatesCommand extends IPoolRateModel {
}

export class RolePermissionViewModel implements IRolePermissionViewModel {
    model?: ApplicationRoleModel | undefined;
    systemRoleRights?: TreeNodeModel[] | undefined;

    constructor(data?: IRolePermissionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? ApplicationRoleModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["systemRoleRights"])) {
                this.systemRoleRights = [] as any;
                for (let item of _data["systemRoleRights"])
                    this.systemRoleRights!.push(TreeNodeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RolePermissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.systemRoleRights)) {
            data["systemRoleRights"] = [];
            for (let item of this.systemRoleRights)
                data["systemRoleRights"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRolePermissionViewModel {
    model?: ApplicationRoleModel | undefined;
    systemRoleRights?: TreeNodeModel[] | undefined;
}

export class ApplicationRoleModel extends BaseModel implements IApplicationRoleModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    rights?: number[] | undefined;

    constructor(data?: IApplicationRoleModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["rights"])) {
                this.rights = [] as any;
                for (let item of _data["rights"])
                    this.rights!.push(item);
            }
        }
    }

    static fromJS(data: any): ApplicationRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.rights)) {
            data["rights"] = [];
            for (let item of this.rights)
                data["rights"].push(item);
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IApplicationRoleModel extends IBaseModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    rights?: number[] | undefined;
}

export class UpsertRolePermissionCommand extends ApplicationRoleModel implements IUpsertRolePermissionCommand {

    constructor(data?: IUpsertRolePermissionCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertRolePermissionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRolePermissionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertRolePermissionCommand extends IApplicationRoleModel {
}

export class SalesCategoryViewModel implements ISalesCategoryViewModel {
    model?: SalesCategoryModel | undefined;
    categories?: SelectModel[] | undefined;
    salesCategoriesTreeNode?: TreeNodeModel[] | undefined;

    constructor(data?: ISalesCategoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? SalesCategoryModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["salesCategoriesTreeNode"])) {
                this.salesCategoriesTreeNode = [] as any;
                for (let item of _data["salesCategoriesTreeNode"])
                    this.salesCategoriesTreeNode!.push(TreeNodeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesCategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SalesCategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.salesCategoriesTreeNode)) {
            data["salesCategoriesTreeNode"] = [];
            for (let item of this.salesCategoriesTreeNode)
                data["salesCategoriesTreeNode"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISalesCategoryViewModel {
    model?: SalesCategoryModel | undefined;
    categories?: SelectModel[] | undefined;
    salesCategoriesTreeNode?: TreeNodeModel[] | undefined;
}

export class SalesCategoryModel extends BaseModel implements ISalesCategoryModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    parentId?: number | undefined;
    image?: string | undefined;
    imagePath?: string | undefined;
    isActive?: boolean;

    constructor(data?: ISalesCategoryModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.parentId = _data["parentId"];
            this.image = _data["image"];
            this.imagePath = _data["imagePath"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SalesCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SalesCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentId"] = this.parentId;
        data["image"] = this.image;
        data["imagePath"] = this.imagePath;
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data; 
    }
}

export interface ISalesCategoryModel extends IBaseModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    parentId?: number | undefined;
    image?: string | undefined;
    imagePath?: string | undefined;
    isActive?: boolean;
}

export class UpsertCategoryCommand extends SalesCategoryModel implements IUpsertCategoryCommand {

    constructor(data?: IUpsertCategoryCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertCategoryCommand extends ISalesCategoryModel {
}

export class CounterModel implements ICounterModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    typeId?: number;
    isActive?: boolean;
    isDefault?: boolean;

    constructor(data?: ICounterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.typeId = _data["typeId"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): CounterModel {
        data = typeof data === 'object' ? data : {};
        let result = new CounterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["typeId"] = this.typeId;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface ICounterModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    typeId?: number;
    isActive?: boolean;
    isDefault?: boolean;
}

export class StockCategoryViewModel implements IStockCategoryViewModel {
    model?: StockCategoryModel | undefined;
    stockCategoriesTreeNode?: TreeNodeModel[] | undefined;

    constructor(data?: IStockCategoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? StockCategoryModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["stockCategoriesTreeNode"])) {
                this.stockCategoriesTreeNode = [] as any;
                for (let item of _data["stockCategoriesTreeNode"])
                    this.stockCategoriesTreeNode!.push(TreeNodeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockCategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StockCategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.stockCategoriesTreeNode)) {
            data["stockCategoriesTreeNode"] = [];
            for (let item of this.stockCategoriesTreeNode)
                data["stockCategoriesTreeNode"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStockCategoryViewModel {
    model?: StockCategoryModel | undefined;
    stockCategoriesTreeNode?: TreeNodeModel[] | undefined;
}

export class StockCategoryModel extends BaseModel implements IStockCategoryModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    parentId?: number | undefined;
    isActive?: boolean | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    parent?: StockCategoryModel | undefined;

    constructor(data?: IStockCategoryModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.parentId = _data["parentId"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? new Date(_data["lastModifiedDateTime"].toString()) : <any>undefined;
            this.parent = _data["parent"] ? StockCategoryModel.fromJS(_data["parent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StockCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new StockCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentId"] = this.parentId;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>undefined;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IStockCategoryModel extends IBaseModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    parentId?: number | undefined;
    isActive?: boolean | undefined;
    createdBy?: string | undefined;
    createdDateTime?: Date;
    lastModifiedBy?: string | undefined;
    lastModifiedDateTime?: Date | undefined;
    parent?: StockCategoryModel | undefined;
}

export class UpsertStockCategoryCommand extends StockCategoryModel implements IUpsertStockCategoryCommand {

    constructor(data?: IUpsertStockCategoryCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertStockCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertStockCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertStockCategoryCommand extends IStockCategoryModel {
}

export class StockItemViewModel implements IStockItemViewModel {
    model?: StockItemModel | undefined;
    stockCategoriesTreeNode?: TreeNodeModel[] | undefined;
    stockUnitsSelectList?: SelectModel[] | undefined;

    constructor(data?: IStockItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? StockItemModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["stockCategoriesTreeNode"])) {
                this.stockCategoriesTreeNode = [] as any;
                for (let item of _data["stockCategoriesTreeNode"])
                    this.stockCategoriesTreeNode!.push(TreeNodeModel.fromJS(item));
            }
            if (Array.isArray(_data["stockUnitsSelectList"])) {
                this.stockUnitsSelectList = [] as any;
                for (let item of _data["stockUnitsSelectList"])
                    this.stockUnitsSelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StockItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.stockCategoriesTreeNode)) {
            data["stockCategoriesTreeNode"] = [];
            for (let item of this.stockCategoriesTreeNode)
                data["stockCategoriesTreeNode"].push(item.toJSON());
        }
        if (Array.isArray(this.stockUnitsSelectList)) {
            data["stockUnitsSelectList"] = [];
            for (let item of this.stockUnitsSelectList)
                data["stockUnitsSelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStockItemViewModel {
    model?: StockItemModel | undefined;
    stockCategoriesTreeNode?: TreeNodeModel[] | undefined;
    stockUnitsSelectList?: SelectModel[] | undefined;
}

export class StockItemModel extends BaseModel implements IStockItemModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    stockCategoryId?: number;
    stockQuantity?: number;
    unitPrice?: number | undefined;
    stockUnitId?: number;

    constructor(data?: IStockItemModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.stockCategoryId = _data["stockCategoryId"];
            this.stockQuantity = _data["stockQuantity"];
            this.unitPrice = _data["unitPrice"];
            this.stockUnitId = _data["stockUnitId"];
        }
    }

    static fromJS(data: any): StockItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new StockItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["stockCategoryId"] = this.stockCategoryId;
        data["stockQuantity"] = this.stockQuantity;
        data["unitPrice"] = this.unitPrice;
        data["stockUnitId"] = this.stockUnitId;
        super.toJSON(data);
        return data; 
    }
}

export interface IStockItemModel extends IBaseModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    stockCategoryId?: number;
    stockQuantity?: number;
    unitPrice?: number | undefined;
    stockUnitId?: number;
}

export class UpsertStockItemCommand extends StockItemModel implements IUpsertStockItemCommand {

    constructor(data?: IUpsertStockItemCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertStockItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertStockItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertStockItemCommand extends IStockItemModel {
}

export class StockItemRegisterViewModel implements IStockItemRegisterViewModel {
    model?: StockItemRegisterModel | undefined;
    storeSelectList?: SelectModel[] | undefined;
    registerTypeSelectList?: SelectModel[] | undefined;
    stockItemSelectList?: SelectModel[] | undefined;

    constructor(data?: IStockItemRegisterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? StockItemRegisterModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["storeSelectList"])) {
                this.storeSelectList = [] as any;
                for (let item of _data["storeSelectList"])
                    this.storeSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["registerTypeSelectList"])) {
                this.registerTypeSelectList = [] as any;
                for (let item of _data["registerTypeSelectList"])
                    this.registerTypeSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["stockItemSelectList"])) {
                this.stockItemSelectList = [] as any;
                for (let item of _data["stockItemSelectList"])
                    this.stockItemSelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockItemRegisterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StockItemRegisterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.storeSelectList)) {
            data["storeSelectList"] = [];
            for (let item of this.storeSelectList)
                data["storeSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.registerTypeSelectList)) {
            data["registerTypeSelectList"] = [];
            for (let item of this.registerTypeSelectList)
                data["registerTypeSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.stockItemSelectList)) {
            data["stockItemSelectList"] = [];
            for (let item of this.stockItemSelectList)
                data["stockItemSelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStockItemRegisterViewModel {
    model?: StockItemRegisterModel | undefined;
    storeSelectList?: SelectModel[] | undefined;
    registerTypeSelectList?: SelectModel[] | undefined;
    stockItemSelectList?: SelectModel[] | undefined;
}

export class StockItemRegisterModel extends BaseModel implements IStockItemRegisterModel {
    id?: number;
    storeId?: number;
    fromStoreId?: number | undefined;
    registerTypeId?: number;
    registerDate?: Date;
    registerReference?: string | undefined;
    note?: string | undefined;
    statusId?: number;
    stockItemRegisterDetails?: StockItemRegisterDetailModel[] | undefined;

    constructor(data?: IStockItemRegisterModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.fromStoreId = _data["fromStoreId"];
            this.registerTypeId = _data["registerTypeId"];
            this.registerDate = _data["registerDate"] ? new Date(_data["registerDate"].toString()) : <any>undefined;
            this.registerReference = _data["registerReference"];
            this.note = _data["note"];
            this.statusId = _data["statusId"];
            if (Array.isArray(_data["stockItemRegisterDetails"])) {
                this.stockItemRegisterDetails = [] as any;
                for (let item of _data["stockItemRegisterDetails"])
                    this.stockItemRegisterDetails!.push(StockItemRegisterDetailModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockItemRegisterModel {
        data = typeof data === 'object' ? data : {};
        let result = new StockItemRegisterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["fromStoreId"] = this.fromStoreId;
        data["registerTypeId"] = this.registerTypeId;
        data["registerDate"] = this.registerDate ? this.registerDate.toISOString() : <any>undefined;
        data["registerReference"] = this.registerReference;
        data["note"] = this.note;
        data["statusId"] = this.statusId;
        if (Array.isArray(this.stockItemRegisterDetails)) {
            data["stockItemRegisterDetails"] = [];
            for (let item of this.stockItemRegisterDetails)
                data["stockItemRegisterDetails"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IStockItemRegisterModel extends IBaseModel {
    id?: number;
    storeId?: number;
    fromStoreId?: number | undefined;
    registerTypeId?: number;
    registerDate?: Date;
    registerReference?: string | undefined;
    note?: string | undefined;
    statusId?: number;
    stockItemRegisterDetails?: StockItemRegisterDetailModel[] | undefined;
}

export class StockItemRegisterDetailModel extends BaseModel implements IStockItemRegisterDetailModel {
    id?: number;
    stockRegisterId?: number;
    storeId?: number;
    stockItemId?: number;
    quantity?: number;
    price?: number | undefined;
    pricePerQuantity?: number | undefined;
    registerTypeId?: number;
    stockItemRegister?: StockItemRegister | undefined;

    constructor(data?: IStockItemRegisterDetailModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.stockRegisterId = _data["stockRegisterId"];
            this.storeId = _data["storeId"];
            this.stockItemId = _data["stockItemId"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.pricePerQuantity = _data["pricePerQuantity"];
            this.registerTypeId = _data["registerTypeId"];
            this.stockItemRegister = _data["stockItemRegister"] ? StockItemRegister.fromJS(_data["stockItemRegister"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StockItemRegisterDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new StockItemRegisterDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stockRegisterId"] = this.stockRegisterId;
        data["storeId"] = this.storeId;
        data["stockItemId"] = this.stockItemId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["pricePerQuantity"] = this.pricePerQuantity;
        data["registerTypeId"] = this.registerTypeId;
        data["stockItemRegister"] = this.stockItemRegister ? this.stockItemRegister.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IStockItemRegisterDetailModel extends IBaseModel {
    id?: number;
    stockRegisterId?: number;
    storeId?: number;
    stockItemId?: number;
    quantity?: number;
    price?: number | undefined;
    pricePerQuantity?: number | undefined;
    registerTypeId?: number;
    stockItemRegister?: StockItemRegister | undefined;
}

export class InsertStockItemRegisterCommand extends StockItemRegisterModel implements IInsertStockItemRegisterCommand {

    constructor(data?: IInsertStockItemRegisterCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): InsertStockItemRegisterCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InsertStockItemRegisterCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IInsertStockItemRegisterCommand extends IStockItemRegisterModel {
}

export class InsertStockItemTransferRegisterCommand extends StockItemRegisterModel implements IInsertStockItemTransferRegisterCommand {

    constructor(data?: IInsertStockItemTransferRegisterCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): InsertStockItemTransferRegisterCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InsertStockItemTransferRegisterCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IInsertStockItemTransferRegisterCommand extends IStockItemRegisterModel {
}

export class InsertStockItemConsumptionRegisterCommand extends StockItemRegisterModel implements IInsertStockItemConsumptionRegisterCommand {

    constructor(data?: IInsertStockItemConsumptionRegisterCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): InsertStockItemConsumptionRegisterCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InsertStockItemConsumptionRegisterCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IInsertStockItemConsumptionRegisterCommand extends IStockItemRegisterModel {
}

export class MonthlyStockDetailRequestModel implements IMonthlyStockDetailRequestModel {
    startDate?: Date;
    enddate?: Date;
    storeId?: number;

    constructor(data?: IMonthlyStockDetailRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.enddate = _data["enddate"] ? new Date(_data["enddate"].toString()) : <any>undefined;
            this.storeId = _data["storeId"];
        }
    }

    static fromJS(data: any): MonthlyStockDetailRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyStockDetailRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["enddate"] = this.enddate ? this.enddate.toISOString() : <any>undefined;
        data["storeId"] = this.storeId;
        return data; 
    }
}

export interface IMonthlyStockDetailRequestModel {
    startDate?: Date;
    enddate?: Date;
    storeId?: number;
}

export class GetReportOfMonthlyStockItemsDetailQuery extends MonthlyStockDetailRequestModel implements IGetReportOfMonthlyStockItemsDetailQuery {

    constructor(data?: IGetReportOfMonthlyStockItemsDetailQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): GetReportOfMonthlyStockItemsDetailQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportOfMonthlyStockItemsDetailQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IGetReportOfMonthlyStockItemsDetailQuery extends IMonthlyStockDetailRequestModel {
}

export class TennisBookingSlotViewModel implements ITennisBookingSlotViewModel {
    model?: TennisBookingSlotModel | undefined;
    businessCategoriesTennisShiftSelectList?: SelectModel[] | undefined;

    constructor(data?: ITennisBookingSlotViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? TennisBookingSlotModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["businessCategoriesTennisShiftSelectList"])) {
                this.businessCategoriesTennisShiftSelectList = [] as any;
                for (let item of _data["businessCategoriesTennisShiftSelectList"])
                    this.businessCategoriesTennisShiftSelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TennisBookingSlotViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TennisBookingSlotViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.businessCategoriesTennisShiftSelectList)) {
            data["businessCategoriesTennisShiftSelectList"] = [];
            for (let item of this.businessCategoriesTennisShiftSelectList)
                data["businessCategoriesTennisShiftSelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITennisBookingSlotViewModel {
    model?: TennisBookingSlotModel | undefined;
    businessCategoriesTennisShiftSelectList?: SelectModel[] | undefined;
}

export class TennisBookingSlotModel extends BaseModel implements ITennisBookingSlotModel {
    id?: number;
    startTime?: string;
    endTime?: string;
    shiftId?: number;
    memberName?: string | undefined;
    memberCode?: string | undefined;
    slotId?: number;
    bookingStatus?: string | undefined;
    tennisShift?: BusinessCategory | undefined;

    constructor(data?: ITennisBookingSlotModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.shiftId = _data["shiftId"];
            this.memberName = _data["memberName"];
            this.memberCode = _data["memberCode"];
            this.slotId = _data["slotId"];
            this.bookingStatus = _data["bookingStatus"];
            this.tennisShift = _data["tennisShift"] ? BusinessCategory.fromJS(_data["tennisShift"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TennisBookingSlotModel {
        data = typeof data === 'object' ? data : {};
        let result = new TennisBookingSlotModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["shiftId"] = this.shiftId;
        data["memberName"] = this.memberName;
        data["memberCode"] = this.memberCode;
        data["slotId"] = this.slotId;
        data["bookingStatus"] = this.bookingStatus;
        data["tennisShift"] = this.tennisShift ? this.tennisShift.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface ITennisBookingSlotModel extends IBaseModel {
    id?: number;
    startTime?: string;
    endTime?: string;
    shiftId?: number;
    memberName?: string | undefined;
    memberCode?: string | undefined;
    slotId?: number;
    bookingStatus?: string | undefined;
    tennisShift?: BusinessCategory | undefined;
}

export class UpsertTennisBookingSlotCommand extends TennisBookingSlotModel implements IUpsertTennisBookingSlotCommand {

    constructor(data?: IUpsertTennisBookingSlotCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertTennisBookingSlotCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertTennisBookingSlotCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertTennisBookingSlotCommand extends ITennisBookingSlotModel {
}

export class CardListModel implements ICardListModel {
    cards?: CardModel[] | undefined;

    constructor(data?: ICardListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(CardModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CardListModel {
        data = typeof data === 'object' ? data : {};
        let result = new CardListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICardListModel {
    cards?: CardModel[] | undefined;
}

export class CardModel implements ICardModel {
    id?: number | undefined;
    slotId?: number | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    bookingDate?: Date;
    memberName?: string | undefined;
    memberCode?: string | undefined;
    bookingStatus?: string | undefined;
    canceled?: boolean | undefined;

    constructor(data?: ICardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.slotId = _data["slotId"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.bookingDate = _data["bookingDate"] ? new Date(_data["bookingDate"].toString()) : <any>undefined;
            this.memberName = _data["memberName"];
            this.memberCode = _data["memberCode"];
            this.bookingStatus = _data["bookingStatus"];
            this.canceled = _data["canceled"];
        }
    }

    static fromJS(data: any): CardModel {
        data = typeof data === 'object' ? data : {};
        let result = new CardModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["slotId"] = this.slotId;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["bookingDate"] = this.bookingDate ? this.bookingDate.toISOString() : <any>undefined;
        data["memberName"] = this.memberName;
        data["memberCode"] = this.memberCode;
        data["bookingStatus"] = this.bookingStatus;
        data["canceled"] = this.canceled;
        return data; 
    }
}

export interface ICardModel {
    id?: number | undefined;
    slotId?: number | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    bookingDate?: Date;
    memberName?: string | undefined;
    memberCode?: string | undefined;
    bookingStatus?: string | undefined;
    canceled?: boolean | undefined;
}

export class CancelTennisBookingSlotCommand implements ICancelTennisBookingSlotCommand {
    idList?: number[] | undefined;

    constructor(data?: ICancelTennisBookingSlotCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["idList"])) {
                this.idList = [] as any;
                for (let item of _data["idList"])
                    this.idList!.push(item);
            }
        }
    }

    static fromJS(data: any): CancelTennisBookingSlotCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CancelTennisBookingSlotCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.idList)) {
            data["idList"] = [];
            for (let item of this.idList)
                data["idList"].push(item);
        }
        return data; 
    }
}

export interface ICancelTennisBookingSlotCommand {
    idList?: number[] | undefined;
}

export class BlockTennisBookingSlotCommand extends CardModel implements IBlockTennisBookingSlotCommand {

    constructor(data?: IBlockTennisBookingSlotCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): BlockTennisBookingSlotCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BlockTennisBookingSlotCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IBlockTennisBookingSlotCommand extends ICardModel {
}

export class TennisFeeSettingViewModel implements ITennisFeeSettingViewModel {
    model?: TennisFeeSettingModel | undefined;
    weekDaysTypeSelectList?: SelectModel[] | undefined;
    tennisCourtTypeSelectList?: SelectModel[] | undefined;

    constructor(data?: ITennisFeeSettingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? TennisFeeSettingModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["weekDaysTypeSelectList"])) {
                this.weekDaysTypeSelectList = [] as any;
                for (let item of _data["weekDaysTypeSelectList"])
                    this.weekDaysTypeSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["tennisCourtTypeSelectList"])) {
                this.tennisCourtTypeSelectList = [] as any;
                for (let item of _data["tennisCourtTypeSelectList"])
                    this.tennisCourtTypeSelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TennisFeeSettingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TennisFeeSettingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.weekDaysTypeSelectList)) {
            data["weekDaysTypeSelectList"] = [];
            for (let item of this.weekDaysTypeSelectList)
                data["weekDaysTypeSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.tennisCourtTypeSelectList)) {
            data["tennisCourtTypeSelectList"] = [];
            for (let item of this.tennisCourtTypeSelectList)
                data["tennisCourtTypeSelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITennisFeeSettingViewModel {
    model?: TennisFeeSettingModel | undefined;
    weekDaysTypeSelectList?: SelectModel[] | undefined;
    tennisCourtTypeSelectList?: SelectModel[] | undefined;
}

export class TennisFeeSettingModel extends BaseModel implements ITennisFeeSettingModel {
    id?: number;
    dayId?: number;
    slotId?: number;
    regularCourtFee?: number;
    openTennisHourCourtFee?: number;
    openLadiesTennisHourCourtFee?: number;
    childrenCourtFee?: number;
    holidayCourtFee?: number;
    markersFee?: number;
    tennisRacketRent?: number;
    noShowCharge?: number;
    isActive?: boolean;
    isHoliday?: boolean;

    constructor(data?: ITennisFeeSettingModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.dayId = _data["dayId"];
            this.slotId = _data["slotId"];
            this.regularCourtFee = _data["regularCourtFee"];
            this.openTennisHourCourtFee = _data["openTennisHourCourtFee"];
            this.openLadiesTennisHourCourtFee = _data["openLadiesTennisHourCourtFee"];
            this.childrenCourtFee = _data["childrenCourtFee"];
            this.holidayCourtFee = _data["holidayCourtFee"];
            this.markersFee = _data["markersFee"];
            this.tennisRacketRent = _data["tennisRacketRent"];
            this.noShowCharge = _data["noShowCharge"];
            this.isActive = _data["isActive"];
            this.isHoliday = _data["isHoliday"];
        }
    }

    static fromJS(data: any): TennisFeeSettingModel {
        data = typeof data === 'object' ? data : {};
        let result = new TennisFeeSettingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dayId"] = this.dayId;
        data["slotId"] = this.slotId;
        data["regularCourtFee"] = this.regularCourtFee;
        data["openTennisHourCourtFee"] = this.openTennisHourCourtFee;
        data["openLadiesTennisHourCourtFee"] = this.openLadiesTennisHourCourtFee;
        data["childrenCourtFee"] = this.childrenCourtFee;
        data["holidayCourtFee"] = this.holidayCourtFee;
        data["markersFee"] = this.markersFee;
        data["tennisRacketRent"] = this.tennisRacketRent;
        data["noShowCharge"] = this.noShowCharge;
        data["isActive"] = this.isActive;
        data["isHoliday"] = this.isHoliday;
        super.toJSON(data);
        return data; 
    }
}

export interface ITennisFeeSettingModel extends IBaseModel {
    id?: number;
    dayId?: number;
    slotId?: number;
    regularCourtFee?: number;
    openTennisHourCourtFee?: number;
    openLadiesTennisHourCourtFee?: number;
    childrenCourtFee?: number;
    holidayCourtFee?: number;
    markersFee?: number;
    tennisRacketRent?: number;
    noShowCharge?: number;
    isActive?: boolean;
    isHoliday?: boolean;
}

export class UpsertTennisFeeSettingCommand extends TennisFeeSettingModel implements IUpsertTennisFeeSettingCommand {

    constructor(data?: IUpsertTennisFeeSettingCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertTennisFeeSettingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertTennisFeeSettingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertTennisFeeSettingCommand extends ITennisFeeSettingModel {
}

export class TennisSlotBookingViewModel implements ITennisSlotBookingViewModel {
    model?: TennisSlotBookingModel | undefined;
    tennisCourtSelectList?: SelectModel[] | undefined;
    memberSelectList?: SelectModel[] | undefined;
    slotSelectList?: SelectModel[] | undefined;
    bookingStatusSelectList?: SelectModel[] | undefined;

    constructor(data?: ITennisSlotBookingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? TennisSlotBookingModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["tennisCourtSelectList"])) {
                this.tennisCourtSelectList = [] as any;
                for (let item of _data["tennisCourtSelectList"])
                    this.tennisCourtSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["memberSelectList"])) {
                this.memberSelectList = [] as any;
                for (let item of _data["memberSelectList"])
                    this.memberSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["slotSelectList"])) {
                this.slotSelectList = [] as any;
                for (let item of _data["slotSelectList"])
                    this.slotSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["bookingStatusSelectList"])) {
                this.bookingStatusSelectList = [] as any;
                for (let item of _data["bookingStatusSelectList"])
                    this.bookingStatusSelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TennisSlotBookingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TennisSlotBookingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.tennisCourtSelectList)) {
            data["tennisCourtSelectList"] = [];
            for (let item of this.tennisCourtSelectList)
                data["tennisCourtSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.memberSelectList)) {
            data["memberSelectList"] = [];
            for (let item of this.memberSelectList)
                data["memberSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.slotSelectList)) {
            data["slotSelectList"] = [];
            for (let item of this.slotSelectList)
                data["slotSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.bookingStatusSelectList)) {
            data["bookingStatusSelectList"] = [];
            for (let item of this.bookingStatusSelectList)
                data["bookingStatusSelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITennisSlotBookingViewModel {
    model?: TennisSlotBookingModel | undefined;
    tennisCourtSelectList?: SelectModel[] | undefined;
    memberSelectList?: SelectModel[] | undefined;
    slotSelectList?: SelectModel[] | undefined;
    bookingStatusSelectList?: SelectModel[] | undefined;
}

export class UserContactViewModel implements IUserContactViewModel {
    model?: UserContactModel | undefined;
    genderSelectList?: SelectModel[] | undefined;
    roleRightList?: SelectModel[] | undefined;
    systemRoleRightsList?: TreeNodeModel[] | undefined;

    constructor(data?: IUserContactViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? UserContactModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["genderSelectList"])) {
                this.genderSelectList = [] as any;
                for (let item of _data["genderSelectList"])
                    this.genderSelectList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["roleRightList"])) {
                this.roleRightList = [] as any;
                for (let item of _data["roleRightList"])
                    this.roleRightList!.push(SelectModel.fromJS(item));
            }
            if (Array.isArray(_data["systemRoleRightsList"])) {
                this.systemRoleRightsList = [] as any;
                for (let item of _data["systemRoleRightsList"])
                    this.systemRoleRightsList!.push(TreeNodeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserContactViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserContactViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.genderSelectList)) {
            data["genderSelectList"] = [];
            for (let item of this.genderSelectList)
                data["genderSelectList"].push(item.toJSON());
        }
        if (Array.isArray(this.roleRightList)) {
            data["roleRightList"] = [];
            for (let item of this.roleRightList)
                data["roleRightList"].push(item.toJSON());
        }
        if (Array.isArray(this.systemRoleRightsList)) {
            data["systemRoleRightsList"] = [];
            for (let item of this.systemRoleRightsList)
                data["systemRoleRightsList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUserContactViewModel {
    model?: UserContactModel | undefined;
    genderSelectList?: SelectModel[] | undefined;
    roleRightList?: SelectModel[] | undefined;
    systemRoleRightsList?: TreeNodeModel[] | undefined;
}

export class UserContactModel extends BaseModel implements IUserContactModel {
    id?: number;
    title?: string | undefined;
    forename?: string | undefined;
    surname?: string | undefined;
    gender?: string | undefined;
    nationality?: string | undefined;
    designation?: string | undefined;
    email?: string | undefined;
    mobileNumber?: string | undefined;
    residentialAddress?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    roles?: string[] | undefined;
    profileImagePath?: string | undefined;
    profileImageId?: number | undefined;

    constructor(data?: IUserContactModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.forename = _data["forename"];
            this.surname = _data["surname"];
            this.gender = _data["gender"];
            this.nationality = _data["nationality"];
            this.designation = _data["designation"];
            this.email = _data["email"];
            this.mobileNumber = _data["mobileNumber"];
            this.residentialAddress = _data["residentialAddress"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.profileImagePath = _data["profileImagePath"];
            this.profileImageId = _data["profileImageId"];
        }
    }

    static fromJS(data: any): UserContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["forename"] = this.forename;
        data["surname"] = this.surname;
        data["gender"] = this.gender;
        data["nationality"] = this.nationality;
        data["designation"] = this.designation;
        data["email"] = this.email;
        data["mobileNumber"] = this.mobileNumber;
        data["residentialAddress"] = this.residentialAddress;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["profileImagePath"] = this.profileImagePath;
        data["profileImageId"] = this.profileImageId;
        super.toJSON(data);
        return data; 
    }
}

export interface IUserContactModel extends IBaseModel {
    id?: number;
    title?: string | undefined;
    forename?: string | undefined;
    surname?: string | undefined;
    gender?: string | undefined;
    nationality?: string | undefined;
    designation?: string | undefined;
    email?: string | undefined;
    mobileNumber?: string | undefined;
    residentialAddress?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    roles?: string[] | undefined;
    profileImagePath?: string | undefined;
    profileImageId?: number | undefined;
}

export class UpsertUserContactCommand extends UserContactModel implements IUpsertUserContactCommand {

    constructor(data?: IUpsertUserContactCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertUserContactCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUserContactCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertUserContactCommand extends IUserContactModel {
}

export class UserProfileViewModel implements IUserProfileViewModel {
    model?: UserProfileModel | undefined;
    genderSelectList?: SelectModel[] | undefined;

    constructor(data?: IUserProfileViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.model = _data["model"] ? UserProfileModel.fromJS(_data["model"]) : <any>undefined;
            if (Array.isArray(_data["genderSelectList"])) {
                this.genderSelectList = [] as any;
                for (let item of _data["genderSelectList"])
                    this.genderSelectList!.push(SelectModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserProfileViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        if (Array.isArray(this.genderSelectList)) {
            data["genderSelectList"] = [];
            for (let item of this.genderSelectList)
                data["genderSelectList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUserProfileViewModel {
    model?: UserProfileModel | undefined;
    genderSelectList?: SelectModel[] | undefined;
}

export class UserProfileModel extends BaseModel implements IUserProfileModel {
    id?: number;
    title?: string | undefined;
    forename?: string | undefined;
    surname?: string | undefined;
    gender?: string | undefined;
    nationality?: string | undefined;
    designation?: string | undefined;
    email?: string | undefined;
    mobileNumber?: string | undefined;
    residentialAddress?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    oldPassword?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    profileImagePath?: string | undefined;
    profileImageId?: number | undefined;

    constructor(data?: IUserProfileModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.forename = _data["forename"];
            this.surname = _data["surname"];
            this.gender = _data["gender"];
            this.nationality = _data["nationality"];
            this.designation = _data["designation"];
            this.email = _data["email"];
            this.mobileNumber = _data["mobileNumber"];
            this.residentialAddress = _data["residentialAddress"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.oldPassword = _data["oldPassword"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.profileImagePath = _data["profileImagePath"];
            this.profileImageId = _data["profileImageId"];
        }
    }

    static fromJS(data: any): UserProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["forename"] = this.forename;
        data["surname"] = this.surname;
        data["gender"] = this.gender;
        data["nationality"] = this.nationality;
        data["designation"] = this.designation;
        data["email"] = this.email;
        data["mobileNumber"] = this.mobileNumber;
        data["residentialAddress"] = this.residentialAddress;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["oldPassword"] = this.oldPassword;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["profileImagePath"] = this.profileImagePath;
        data["profileImageId"] = this.profileImageId;
        super.toJSON(data);
        return data; 
    }
}

export interface IUserProfileModel extends IBaseModel {
    id?: number;
    title?: string | undefined;
    forename?: string | undefined;
    surname?: string | undefined;
    gender?: string | undefined;
    nationality?: string | undefined;
    designation?: string | undefined;
    email?: string | undefined;
    mobileNumber?: string | undefined;
    residentialAddress?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    oldPassword?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    profileImagePath?: string | undefined;
    profileImageId?: number | undefined;
}

export class UpsertUserProfileCommand extends UserProfileModel implements IUpsertUserProfileCommand {

    constructor(data?: IUpsertUserProfileCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpsertUserProfileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertUserProfileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IUpsertUserProfileCommand extends IUserProfileModel {
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}